import ToggleInput from "./inputs/ToggleInput";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState, useCallback } from "react";
import { AnimatePresence, motion } from 'framer-motion';
import unidecode from "unidecode-plus";
import { ReactComponent as PencilIcon } from "../images/icons/pencil.svg";
import { ReactComponent as TokenIcon } from '../images/icons/promptus-token.svg';
// import TokenIcon from '../images/icons/promptus-token.svg';
import { ReactComponent as HistoryIcon } from '../images/icons/history.svg';
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import { ReactComponent as AdvancedSettingsIcon } from '../images/icons/advanced-settings-expand-arrow.svg';
import { useGenerateDispatch, useGenerateStatus } from "../context/GenerateContext";
import { usePromptusAPIState, usePromptusAPIDispatch } from "../context/PromptusAPIContext";
import { useDriverContext, useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import ImageUpload from "./ImageUpload";
import { db } from "../db";
import DrawingInput from "./inputs/DrawingInput";
import PromptHistory from "./PromptHistory";
import { getLoras, getModels, getServerStatus, revealLocator, isLocalServerBusy, getRecommendedSettings, getCosyflows, getCosyflowData, getApiBaseUrl, getAuthorizationToken, enhancePromptAPI, getCosyflowCategories } from "../api-helper";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { ReactComponent as InfoIcon } from "../images/icons/info.svg"
import { ReactComponent as HowToIconActive } from "../images/icons/nav-icons/nav-icon-how-to-active.svg";
import { ReactComponent as RecordingIcon } from "../images/icons/input-bar-icons/icon-input-bar-voice.svg";
import { ReactComponent as StopRecordingIcon } from "../images/icons/input-bar-icons/icon-input-bar-voice-recording.svg";
import { ReactComponent as AccountIcon } from "../images/icons/promptus-profile-pic.svg";
import { ReactComponent as RefreshIcon } from "../images/icons/refresh.svg";
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { debounce } from 'lodash';
import { usePromptContext } from '../context/PromptContext';
import { isUndefined } from "cropperjs";
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated'
import Image from "image-js";
import { memo } from "react";
import Video from "./Video";
import Audio from "./Audio";
import axios from "axios";
import DynamicPromptForm from "./DynamicPromptForm";
import electronBridge from '../utils/electronBridge';
import { SlMenu } from "react-icons/sl";
import Logo from "../images/logo_light_grey.png";
import eventBus from '../utils/eventBus';
import * as LottiePlayer from "@lottiefiles/lottie-player";
import PromptSpin from "../images/prompts.lottie";
import { useReactMediaRecorder } from "react-media-recorder";
import LoginModal from "./LoginModal";
import CosyflowsGallery from "../containers/CosyflowsGallery";
import DynamicPromptFormExperiment from "./DynamicPromptFormExperiment";
import { analyzeImage, classifyAlpha } from "../alpha-inspector-browser";
import { getActiveOfflineMode } from "../utils/offlineModeHelper";
import { getUnifiedOfflineModels, getModelsForServer, getDefaultModelsForServerType, refreshModelCache, getServerForModel, checkOfflineServersAvailable, isModelLocal } from '../services/offlineModelService';
import { useInternetBypass } from '../hooks/useInternetConnectivity';
import { isFreeUser } from '../utils/accountTypes';
import { Video as VideoIcon, Music as MusicIcon, Image as ImageIcon, LayoutGrid as LayoutGridIcon } from "lucide-react";

console.log('🚨🚨🚨 SCHEDULER TEST - If you see this, the new code is loaded! 🚨🚨🚨');

const schedulerOptions = [
    'Linear Multistep Scheduler',
    'Denoising Diffusion Implicit',
    'DPM-Solver',
    'DPM++ 2M Karras',
    'DPM++ SDE Karras',
    'DPM++ 2M SDE Karras',
    'Euler',
    'Euler 2',
    'Euler a',
    'Heun',
    'Pseudo Numerical',
    'Denoising Diffusion Probabilistic',
    'Ancestral Euler',
    'LCM',
    'DDIM',
    'UniPC'
];

console.log('[PromptHeader] schedulerOptions array loaded with', schedulerOptions.length, 'options:', schedulerOptions);

// List of default models with weights for selection probability
// Higher weight = higher chance of being selected
const DEFAULT_MODEL_LIST_BASE = [
    { name: '(ByteDance) Seedream 4.0: Text to Image', weight: 30 },
    { name: '(cosy) Flux Schnell fp8', weight: 20 },
    { name: '(ByteDance) Seedream 4.5: Text to Image', weight: 25 },
    { name: '(ByteDance) Seedream 4.5: Image to Image', weight: 25 }
];

// Helper function to select a random item based on weights
const selectWeightedRandom = (weightedItems) => {
    if (!weightedItems || weightedItems.length === 0) return null;

    const totalWeight = weightedItems.reduce((sum, item) => sum + item.weight, 0);
    const randomRoll = Math.random() * totalWeight;
    let remaining = randomRoll;

    console.log(`[WEIGHTED SELECTION] Starting weighted random selection`);
    console.log(`[WEIGHTED SELECTION] Total weight: ${totalWeight}`);
    console.log(`[WEIGHTED SELECTION] Random roll: ${randomRoll.toFixed(2)} / ${totalWeight}`);
    console.log(`[WEIGHTED SELECTION] Candidates:`, weightedItems.map(i => `${i.name} (weight: ${i.weight}, ${((i.weight / totalWeight) * 100).toFixed(1)}%)`));

    for (const item of weightedItems) {
        console.log(`[WEIGHTED SELECTION] Checking "${item.name}" - weight: ${item.weight}, remaining: ${remaining.toFixed(2)}`);
        remaining -= item.weight;
        if (remaining <= 0) {
            console.log(`[WEIGHTED SELECTION] ✓ Selected: "${item.name}" (roll ${randomRoll.toFixed(2)} fell within this weight range)`);
            return item.name;
        }
    }
    const fallback = weightedItems[weightedItems.length - 1].name;
    console.log(`[WEIGHTED SELECTION] ✓ Fallback selected: "${fallback}"`);
    return fallback;
};

const getOfflineModelVarsFallback = (model) => {
    return {
        "params.count": {
            "node_title": "",
            "input_title": "No. of images",
            "title": "No. of images",
            "default": 1,
            "type": "INT",
            "required": true,
            "tooltip": "The number of images to generate.",
            "min": 1,
            "max": 100,
            "importance": 4
        },
        "prompt": {
            "node_title": "",
            "input_title": "Prompt",
            "title": "Prompt",
            "default": "",
            "type": "prompt",
            "required": true,
            "tooltip": "The text to be encoded.",
            "multiline": true,
            "dynamic_prompts": true,
            "importance": 5
        },
        "negative_prompt": {
            "node_title": "",
            "input_title": "Negative Keywords",
            "title": "Negative Keywords",
            "default": "",
            "type": "prompt",
            "required": true,
            "tooltip": "The text to be encoded.",
            "dynamic_prompts": true,
            "importance": 4
        },
        "params.seed_value": {
            "node_title": "",
            "input_title": "Seed",
            "title": "Seed",
            "default": "",
            "type": "STRING",
            "required": false,
            "tooltip": "The seed used for image generation. Leave blank to use a random value, or fill in a numeric value to reproduce a previous output.",
            "importance": 3
        },
        "params.num_inference_steps": {
            "node_title": "",
            "input_title": "Steps",
            "title": "Steps",
            "default": 20,
            "type": "INT",
            "required": false,
            "tooltip": "The number of steps used in the denoising process.",
            "min": 1,
            "max": 100,
            "importance": 3
        },
        "params.guidance_scale": {
            "node_title": "",
            "input_title": "guidance",
            "title": "guidance",
            "default": 7.5,
            "type": "FLOAT",
            "required": false,
            "tooltip": "The Classifier-Free Guidance scale balances creativity and adherence to the prompt. Higher values result in images more closely matching the prompt however too high values will negatively impact quality.",
            "min": 0,
            "max": 20,
            "step": 0.1,
            "round": 0.01,
            "importance": 3
        },
        "params.scheduler": {
            "node_title": "",
            "input_title": "Scheduler",
            "title": "Scheduler",
            "default": "DPM-Solver",
            "type": "enum",
            "required": false,
            "options": [
                "Linear Multistep Scheduler",
                "Denoising Diffusion Implicit",
                "DPM-Solver",
                "Euler 2",
                "Pseudo Numerical",
                "Denoising Diffusion Probabilistic",
                "Ancestral Euler",
                "LCM"
            ],
            "tooltip": "The algorithm used when sampling, this can affect the quality, speed, and style of the generated output.",
            "importance": 2
        },
        "params.width": {
            "node_title": "",
            "input_title": "Image width",
            "title": "Image width",
            "default": 1024,
            "type": "INT",
            "required": false,
            "tooltip": "The width of the latent images in pixels.",
            "min": 16,
            "max": 16384,
            "step": 8,
            "importance": 4
        },
        "params.height": {
            "node_title": "",
            "input_title": "Image height",
            "title": "Image height",
            "default": 1024,
            "type": "INT",
            "required": false,
            "tooltip": "The height of the latent images in pixels.",
            "min": 16,
            "max": 16384,
            "step": 8,
            "importance": 4
        },
        "params.symmetric": {
            "node_title": "",
            "input_title": "Symmetric",
            "title": "Symmetric",
            "default": false,
            "type": "BOOLEAN",
            "required": false,
            "importance": 2
        },
        "params.safety_checker": {
            "node_title": "",
            "input_title": "Safety Checker",
            "title": "Safety Checker",
            "default": true,
            "type": "BOOLEAN",
            "style": "safety",
            "tooltip": "If enabled, content will be moderated for safety. Disable this setting for uncensored output.",
            "required": false,
            "importance": 4
        },
        "params.tile": {
            "node_title": "",
            "input_title": "Tile",
            "title": "Tile",
            "default": false,
            "type": "BOOLEAN",
            "required": false,
            "importance": 2
        },
        "params.upscale_factor": {
            "node_title": "",
            "input_title": "Upscale Factor",
            "title": "Upscale Factor",
            "default": "0",
            "type": "enum",
            "required": false,
            "options": [
                "1",
                "2",
                "4",
                "0"
            ],
            "importance": 3
        },
        "params.model": {
            "node_title": "",
            "input_title": "Model",
            "title": "Model",
            "default": model,
            "type": "enum",
            "required": true,
            "options": [
                model
            ],
            "tooltip": "Choose model weights to generate the output image.",
            "importance": 2
        },
        "prompt_output": {
            "node_title": "",
            "input_title": "Prompt Output",
            "title": "Prompt Output",
            "type": "enum",
            "required": false,
            "options": [
                "text-image"
            ],
            "default": "",
            "tooltip": "The transformation to be performed on the input to give the desired output.",
            "importance": 2
        }

    }
}

// Shuffle the default model list to remove any implicit ordering bias (preserves weights)
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

// Shuffled list with weights preserved (for weighted selection)
const DEFAULT_MODEL_LIST_WEIGHTED = shuffleArray(DEFAULT_MODEL_LIST_BASE);
// Flat list of model names (for backward compatibility and lookups)
const DEFAULT_MODEL_LIST = DEFAULT_MODEL_LIST_WEIGHTED.map(item => item.name);
console.log('[PromptHeader] DEFAULT_MODEL_LIST randomized order:', DEFAULT_MODEL_LIST);
console.log('[PromptHeader] DEFAULT_MODEL_LIST_WEIGHTED:', DEFAULT_MODEL_LIST_WEIGHTED);

const DEFAULT_VIDEO_MODEL = [
    '(GenAI) Veo 3 (preview) Text to Video'
]

const DEFAULT_AUDIO_MODEL = [
    '(Udio) Chirp v3.5 Music Generation'
]

// List of fallback models to try on "Model unavailable" error
const MODEL_FALLBACK_LIST = [...DEFAULT_MODEL_LIST];

// Helper function to randomly select a default model (offline-aware)
// weightedModels parameter allows passing dynamic models from IndexedDB
const getAvailableDefaultModel = (availableOptions = [], isOnline = true, weightedModels = DEFAULT_MODEL_LIST_WEIGHTED) => {
    console.log(`[DEFAULT MODEL] Getting default model - Online: ${isOnline}, Available options: ${availableOptions.length}`);

    // Helper to check if model exists in grouped or flat options
    const checkModelExists = (opts, modelName) => {
        if (!opts || !Array.isArray(opts)) return false;
        for (const item of opts) {
            if (item.options) {
                if (item.options.some(opt => opt.value === modelName)) return true;
            } else if (item.value === modelName) return true;
        }
        return false;
    };

    // Helper to get all models flattened from grouped or flat options
    const flattenOptions = (opts) => {
        if (!opts || !Array.isArray(opts)) return [];
        const allModels = [];
        for (const item of opts) {
            if (item.options) {
                allModels.push(...item.options);
            } else if (item.value) {
                allModels.push(item);
            }
        }
        return allModels;
    };

    // If offline and no options available yet, return empty to prevent online model contamination
    if (!isOnline && (!availableOptions || availableOptions.length === 0)) {
        console.log('[DEFAULT MODEL] Offline mode with no models loaded yet - returning empty to prevent contamination');
        return '';
    }

    console.log('[DEFAULT MODEL] Checking for MOMM image in sessionStorage...');

    const sessionImageData = sessionStorage.getItem('imageToUse');

    if (sessionImageData) {
        try {
            const imageData = JSON.parse(sessionImageData);
            console.log('[DEFAULT MODEL] Found image data from MOMM:', imageData);

            if (imageData.fromMOMM && imageData.needsImageModel) {
                console.log('[DEFAULT MODEL] Processing MOMM image with model selection...');

                const targetModel = imageData.preferredModel || "(GenAI) Nano Banana 2.5 Flash";
                console.log('[DEFAULT MODEL] Target model from MOMM:', targetModel);

                const modelExists = checkModelExists(availableOptions, targetModel);
                console.log('[DEFAULT MODEL] Target model exists in options:', modelExists);

                if (modelExists) {
                    console.log('[DEFAULT MODEL] Returning MOMM target model:', targetModel);
                    return targetModel;
                } else {
                    console.log('[DEFAULT MODEL] MOMM target model not in options, will use fallback');
                }
            }
        } catch (error) {
            console.error('[DEFAULT MODEL] Error processing MOMM image:', error);
            sessionStorage.removeItem('imageToUse');
        }
    }
    console.log('[DEFAULT MODEL] Selecting random default model');

    // Flatten options for easier access
    const flatOptions = flattenOptions(availableOptions);

    // If we have available options, find which default models exist (with their weights)
    if (flatOptions.length > 0) {
        // Filter to find which default models are actually available, preserving weights
        const availableDefaultsWeighted = weightedModels.filter(item =>
            checkModelExists(availableOptions, item.name)
        );

        // If we found any available default models, use weighted random selection
        if (availableDefaultsWeighted.length > 0) {
            const selectedModel = selectWeightedRandom(availableDefaultsWeighted);
            console.log(`[DEFAULT MODEL] Weighted random selected from available defaults: ${selectedModel}`);
            console.log(`[DEFAULT MODEL] Available weighted options:`, availableDefaultsWeighted.map(i => `${i.name} (${i.weight})`));
            return selectedModel;
        }

        console.log('[DEFAULT MODEL] No default models found in available options, picking random fallback');
    }

    // If no options available or no default models found, pick randomly from all available options
    if (flatOptions.length > 0) {
        const randomIndex = Math.floor(Math.random() * flatOptions.length);
        const selectedModel = flatOptions[randomIndex].value;
        console.log(`[DEFAULT MODEL] Random fallback from all available models: ${selectedModel}`);
        return selectedModel;
    }

    // Last resort: return empty string to wait for proper model load
    // Don't blindly return a default that might not exist
    console.log(`[DEFAULT MODEL] No available options - returning empty to wait for model load`);
    return '';
};

// Helper function to filter models by media type using cosyflow category data
const filterModelsByMediaType = async (models, mediaType) => {
    console.log(`[MEDIA FILTER] Filtering ${models.length} models for media type: ${mediaType}`);

    if (!models || models.length === 0) {
        return [];
    }

    const filteredModels = [];

    for (const model of models) {
        try {
            // Query cosyflow data for this model
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(model).first();

            if (matchingCosyflow && matchingCosyflow.data) {
                // Check for category field in cosyflow data
                if (matchingCosyflow.data.category) {
                    // Extract media type from category hierarchy (e.g., "ComfyUI/Getting Started/Image" → "Image")
                    const categoryParts = matchingCosyflow.data.category.split('/');
                    const modelMediaType = categoryParts[categoryParts.length - 1].toLowerCase();

                    console.log(`[MEDIA FILTER] Model "${model}" has category: ${matchingCosyflow.data.category} → ${modelMediaType}`);

                    if (modelMediaType === mediaType.toLowerCase()) {
                        filteredModels.push(model);
                        console.log(`[MEDIA FILTER] Model "${model}" included - matches ${mediaType} category`);
                    } else {
                        console.log(`[MEDIA FILTER] Model "${model}" excluded - category "${modelMediaType}" doesn't match "${mediaType}"`);
                    }
                } else {
                    // Only include models with no category field for image type
                    if (mediaType === 'image') {
                        filteredModels.push(model);
                        console.log(`[MEDIA FILTER] Model "${model}" included as default image type (no category field)`);
                    } else {
                        console.log(`[MEDIA FILTER] Model "${model}" excluded - no category field and not image type`);
                    }
                }
            } else {
                console.log(`[MEDIA FILTER] Model "${model}" excluded - no cosyflow data found`);
            }
        } catch (error) {
            console.error(`[MEDIA FILTER] Error processing model ${model}:`, error);
            console.log(`[MEDIA FILTER] Model "${model}" excluded due to processing error`);
        }
    }

    console.log(`[MEDIA FILTER] ========== FILTERING SUMMARY ==========`);
    console.log(`[MEDIA FILTER] Input: ${models.length} models | Output: ${filteredModels.length} models | Media Type: ${mediaType}`);
    console.log(`[MEDIA FILTER] Included models:`, filteredModels);
    console.log(`[MEDIA FILTER] =======================================`);
    return filteredModels;
};

const extractMediaType = (category) => {
    if (!category) return 'no-category';
    const parts = category.split('/');
    return parts[parts.length - 1].toLowerCase();
};

const preloadCosyflowData = async () => {
    try {
        const startTime = performance.now();
        const modelMediaTypeMap = new Map();

        const allCosyflows = await db.cosyflows.toArray();
        allCosyflows.forEach(cosyflow => {
            if (cosyflow.data?.title) {
                modelMediaTypeMap.set(cosyflow.data.title, extractMediaType(cosyflow.data.category));
            }
        });

        try {
            const cachedData = await db.settings.get('cosyflows_api_cache');
            if (cachedData?.value) {
                const rawCosyflows = cachedData.value.cosyflows || [];
                const transformedCosyflows = cachedData.value.transformedCosyflows || [];

                rawCosyflows.forEach(item => {
                    const title = item.title || item.name;
                    if (title && !modelMediaTypeMap.has(title)) {
                        let category = item.category;
                        if (!category && item.cosyflow) {
                            try {
                                const def = typeof item.cosyflow === 'string' ? JSON.parse(item.cosyflow) : item.cosyflow;
                                category = def?.category;
                            } catch (e) {}
                        }
                        modelMediaTypeMap.set(title, extractMediaType(category));
                    }
                });

                transformedCosyflows.forEach(item => {
                    if (item.title && !modelMediaTypeMap.has(item.title)) {
                        modelMediaTypeMap.set(item.title, extractMediaType(item.category));
                    }
                });
            }
        } catch (e) {}

        if (modelMediaTypeMap.size === 0) {
            try {
                const apiBase = await getApiBaseUrl();
                const response = await axios.get(`${apiBase}/api/cosyflows/query`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getAuthorizationToken()}`
                    },
                    timeout: 15000
                });

                const cosyflows = response.data?.cosyflows || [];
                cosyflows.forEach(item => {
                    const title = item.title || item.name;
                    if (title) {
                        let category = item.category;
                        if (!category && item.cosyflow) {
                            try {
                                const def = typeof item.cosyflow === 'string' ? JSON.parse(item.cosyflow) : item.cosyflow;
                                category = def?.category;
                            } catch (e) {}
                        }
                        modelMediaTypeMap.set(title, extractMediaType(category));
                    }
                });
                console.log(`[PRELOAD] Fetched ${cosyflows.length} cosyflows from API for media type cache`);
            } catch (e) {
                console.warn('[PRELOAD] Failed to fetch cosyflows from API:', e.message);
            }
        }

        const endTime = performance.now();
        console.log(`[PRELOAD] Cached ${modelMediaTypeMap.size} model media type mappings in ${(endTime - startTime).toFixed(0)}ms`);

        return modelMediaTypeMap;
    } catch (error) {
        console.error('[PRELOAD] Error preloading cosyflow data:', error);
        return new Map();
    }
};

const getModelName = (model) => (typeof model === 'object' && model !== null) ? (model.originalValue || model.value || model.label) : model;

const filterModelsByMediaTypeOptimized = async (models, mediaType, modelMediaTypeMap, setModelMediaTypeMap = null) => {
    if (!models || models.length === 0) return [];

    const startTime = performance.now();
    const uncachedModels = models.filter(model => !modelMediaTypeMap.has(getModelName(model)));

    if (uncachedModels.length > 0) {
        console.log(`[MEDIA FILTER] ${uncachedModels.length}/${models.length} models not in cache, fetching bulk...`);
        const updatedMap = new Map(modelMediaTypeMap);

        try {
            const apiBase = await getApiBaseUrl();
            const response = await axios.get(`${apiBase}/api/cosyflows/query`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getAuthorizationToken()}`
                },
                timeout: 15000
            });

            const cosyflows = response.data?.cosyflows || [];
            cosyflows.forEach(item => {
                const title = item.title || item.name;
                if (title) {
                    let category = item.category;
                    if (!category && item.cosyflow) {
                        try {
                            const def = typeof item.cosyflow === 'string' ? JSON.parse(item.cosyflow) : item.cosyflow;
                            category = def?.category;
                        } catch (e) {}
                    }
                    updatedMap.set(title, extractMediaType(category));
                }
            });
            console.log(`[MEDIA FILTER] Bulk fetch added ${updatedMap.size - modelMediaTypeMap.size} new mappings`);
        } catch (error) {
            console.warn('[MEDIA FILTER] Bulk fetch failed:', error.message);
            uncachedModels.forEach(model => {
                const name = getModelName(model);
                if (!updatedMap.has(name)) updatedMap.set(name, 'no-category');
            });
        }

        if (setModelMediaTypeMap) setModelMediaTypeMap(updatedMap);
        modelMediaTypeMap = updatedMap;
    }

    const filteredModels = models.filter(model => {
        const name = getModelName(model);
        const modelType = modelMediaTypeMap.get(name);

        if (modelType && modelType !== 'no-category') {
            return modelType === mediaType.toLowerCase();
        }

        return mediaType === 'image';
    });
    const endTime = performance.now();

    console.log(`[MEDIA FILTER] Input: ${models.length} | Output: ${filteredModels.length} | Type: ${mediaType} | Time: ${(endTime - startTime).toFixed(0)}ms`);

    return filteredModels;
};

// Helper function to check if the model requires a mask (from DynamicPromptForm.jsx)
const checkIfModelRequiresMask = (schema) => {
  if (!schema || typeof schema !== 'object') {
    return false;
  }

  return Object.values(schema).some(field => {
    return (
      field.type === 'b64data' &&
      field.importance === 5 &&
      (field.require_mask === true || field.require_alpha === true)
    );
  });
};

// Helper function to check if an image has transparent pixels (alpha channel)
const checkForAlphaChannel = async (base64Image) => {
  console.log('[checkForAlphaChannel] Starting alpha channel check');

  if (!base64Image || typeof base64Image !== 'string') {
    console.log('[checkForAlphaChannel] Invalid base64 image data');
    return false;
  }

  const imageSizeMB = base64Image.length / (1024 * 1024);
  console.log('[checkForAlphaChannel] Image size:', imageSizeMB.toFixed(2), 'MB');

  // For large images, we'll resize them for validation to prevent timeouts
  const isLargeImage = base64Image.length > 1024 * 1024; // >1MB
  if (isLargeImage) {
    console.log('[checkForAlphaChannel] Large image detected, will resize for validation');
  }

  try {
    console.log('[checkForAlphaChannel] Creating canvas and image elements');
    // Create canvas and load image
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.src = `data:image/png;base64,${base64Image}`;
    console.log('[checkForAlphaChannel] Image src set to base64 data (length:', base64Image.length, ')');

    // Dynamic timeout based on image size
    const timeoutMs = Math.min(15000, Math.max(5000, imageSizeMB * 2000)); // 5-15 seconds based on size
    console.log('[checkForAlphaChannel] Using timeout of', timeoutMs, 'ms for this image size');

    console.log('[checkForAlphaChannel] Loading image...');
    await Promise.race([
      new Promise((resolve, reject) => {
        img.onload = () => {
          console.log('[checkForAlphaChannel] Image loaded successfully');
          resolve();
        };
        img.onerror = (error) => {
          console.error('[checkForAlphaChannel] Image load error:', error);
          reject(error);
        };
      }),
      new Promise((_, reject) =>
        setTimeout(() => {
          console.error('[checkForAlphaChannel] Image load timeout after', timeoutMs, 'ms');
          reject(new Error('Image load timeout'));
        }, timeoutMs)
      )
    ]);

    console.log('[checkForAlphaChannel] Setting canvas dimensions and drawing image');

    // For large images, resize to a smaller size for validation (preserves alpha channel accuracy)
    let canvasWidth, canvasHeight;
    if (isLargeImage && (img.width > 512 || img.height > 512)) {
      // Resize to max 512px while maintaining aspect ratio
      const aspectRatio = img.width / img.height;
      if (img.width > img.height) {
        canvasWidth = 512;
        canvasHeight = 512 / aspectRatio;
      } else {
        canvasHeight = 512;
        canvasWidth = 512 * aspectRatio;
      }
      console.log('[checkForAlphaChannel] Resizing large image from', img.width + 'x' + img.height, 'to', Math.round(canvasWidth) + 'x' + Math.round(canvasHeight), 'for validation');
    } else {
      canvasWidth = img.width;
      canvasHeight = img.height;
      console.log('[checkForAlphaChannel] Using original image size:', canvasWidth + 'x' + canvasHeight);
    }

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);

    console.log('[checkForAlphaChannel] Getting image data');
    // Get image data and check for transparency
    const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
    const pixels = imageData.data;

    console.log('[checkForAlphaChannel] Checking pixels for transparency (looking for alpha = 0)');
    let transparentCount = 0;
    let semiTransparentCount = 0;
    let totalPixels = pixels.length / 4;

    // Check if any pixel has alpha = 0 (fully transparent, indicating mask)
    for (let i = 3; i < pixels.length; i += 4) { // Alpha channel is every 4th value
      if (pixels[i] === 0) {
        transparentCount++;
      } else if (pixels[i] < 255) {
        semiTransparentCount++;
      }
    }

    console.log('[checkForAlphaChannel] Pixel analysis:');
    console.log('  - Total pixels:', totalPixels);
    console.log('  - Fully transparent (alpha=0):', transparentCount);
    console.log('  - Semi-transparent (0<alpha<255):', semiTransparentCount);

    // For masked images, we should have at least some fully transparent pixels
    if (transparentCount > 0) {
      console.log('[checkForAlphaChannel] Found', transparentCount, 'fully transparent pixels (masked areas)');
      return true; // Found masked areas
    }

    console.log('[checkForAlphaChannel] No fully transparent pixels found - no mask detected');
    return false; // No masked areas found
  } catch (error) {
    console.error('[checkForAlphaChannel] Error checking alpha channel:', error);
    return false;
  }
};

const base64toBlob = (b64Data, sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: 'image/png'});
    return blob;
}

// Helper function to validate mask presence using schema properties
const validateMaskPresence = async (formData, cosyflowVariables) => {
  console.log('[validateMaskPresence] Starting validation with formData keys:', Object.keys(formData));
  console.log('[validateMaskPresence] cosyflowVariables keys:', Object.keys(cosyflowVariables || {}));

  if (!cosyflowVariables || typeof cosyflowVariables !== 'object') {
    console.log('[validateMaskPresence] No cosyflowVariables, returning valid');
    return { isValid: true, message: '' };
  }

  // Find fields that require masks
  const maskRequiredFields = [];
  const alphaRequiredFields = [];

  for (const [fieldKey, fieldConfig] of Object.entries(cosyflowVariables)) {
    if (fieldConfig.require_mask === true) {
      maskRequiredFields.push({ key: fieldKey, config: fieldConfig });
      console.log('[validateMaskPresence] Found require_mask field:', fieldKey);
    }
    if (fieldConfig.require_alpha === true) {
      alphaRequiredFields.push({ key: fieldKey, config: fieldConfig });
      console.log('[validateMaskPresence] Found require_alpha field:', fieldKey);
    }
  }

  console.log('[validateMaskPresence] Total require_mask fields:', maskRequiredFields.length);
  console.log('[validateMaskPresence] Total require_alpha fields:', alphaRequiredFields.length);

  // Check require_mask fields
  for (const field of maskRequiredFields) {
    const maskData = formData[field.key];
    if (!maskData || typeof maskData !== 'string' || maskData.trim() === '') {
      return {
        isValid: false,
        message: `This model requires a mask image. Please upload an image and add a mask by clicking on it.`
      };
    }
  }

  // Check require_alpha fields
  for (const field of alphaRequiredFields) {
    console.log('[validateMaskPresence] Checking require_alpha field:', field.key);
    const imageData = formData[field.key];
    console.log('[validateMaskPresence] Image data type:', typeof imageData);
    console.log('[validateMaskPresence] Image data length:', imageData ? imageData.length : 'null');

    if (!imageData || typeof imageData !== 'string' || imageData.trim() === '') {
      console.log('[validateMaskPresence] No image data found for require_alpha field:', field.key);
      return {
        isValid: false,
        message: `This model requires an image with transparency (alpha channel). Please upload an image and add a mask by clicking on it.`
      };
    }

    console.log('[validateMaskPresence] Checking alpha channel for field:', field.key);
    // Check if the image actually has transparency
    // const hasAlpha = await checkForAlphaChannel(imageData);
    const alphaBlob = base64toBlob(imageData); // or 'image/webp' etc.
    const alphaResult = await analyzeImage(alphaBlob);
    console.log('[validateMaskPresence-New] analysis report: ', alphaResult);
    const alphaTrue = await classifyAlpha(alphaResult);
    console.log('[validateMaskPresence-New] alpha exists: ', alphaTrue);
    const hasAlpha = alphaTrue.maskPresent
    console.log('[validateMaskPresence] Alpha channel check result:', hasAlpha);

    if (!hasAlpha) {
      console.log('[validateMaskPresence] No alpha channel found for field:', field.key);
      return {
        isValid: false,
        message: `This model requires an image with transparency (alpha channel). Please click on your uploaded image to add a mask.`
      };
    }
    console.log('[validateMaskPresence] Alpha validation passed for field:', field.key);
  }

  return { isValid: true, message: '' };
};

function AnimatedInputGroup(props) {
    return (
        <motion.div
            variants={{ collapsed: { opacity: 0, height: 0 }, open: { opacity: 1, height: 'auto' } }}
            transition={{ duration: 0.2, delay: 0.2 }}
            id={props.id || ''}
            className={props.className || ''}
        >
            {props.children}
        </motion.div>
    )
}


let default_values = {
    seed: "",
    seed_mode: "random",
    negativeKeywords: "",
    steps: 12,
    guidance: 8,
    imageCount: 1,
    imageWidth: 512,
    imageHeight: 512,
    // scheduler: "DPM-Solver",
}

const CustomMenuList = (props) => {
    const menuListRef = useRef(null);
    useEffect(() => {
        if (menuListRef.current) {
            menuListRef.current.scrollTop = 0;
        }
    }, [props.selectProps.inputValue]);

    return (
        <components.MenuList {...props} innerRef={menuListRef}>
            {props.children}
        </components.MenuList>
    );
};

const CustomOption = (props) => {
    const { data, children, ...rest } = props;
    const cost = data.cost;

    return (
        <components.Option {...rest} data={data}>
            <div className="flex justify-between items-center w-full">
                <span className="truncate flex-1 mr-2">{children}</span>
                {/* {cost !== undefined && cost !== null && (
                    <span className="text-sm text-dark-blue whitespace-nowrap flex items-center gap-1">
                        {cost >= 1 ? Math.round(cost) : cost} <TokenIcon className="w-5 h-5" alt={"Promptus Token Icon"} />
                    </span>
                )} */}
            </div>
        </components.Option>
    );
};

const animatedComponents = makeAnimated()

const formatGroupLabel = (group) => (
    <div className="flex items-center justify-between py-2 px-1  border-b-2 border-dark-blue">
        <span className="font-bold text-dark-blue text-sm">{group.label}</span>
        <span className="text-xs text-dark-blue bg-yellow px-2 py-0.5 rounded">{group.options.length}</span>
    </div>
);

const findModelInOptions = (options, modelValue) => {
    if (!Array.isArray(options) || !modelValue) return null;
    for (const item of options) {
        if (item.options) {
            const found = item.options.find(opt => opt.value === modelValue);
            if (found) return found;
        } else if (item.value === modelValue) {
            return item;
        }
    }
    return null;
};

const modelExistsInOptions = (options, modelValue) => {
    return findModelInOptions(options, modelValue) !== null;
};

const stripLocalSuffix = (modelName) => {
    if (!modelName) return modelName;
    const match = modelName.match(/^(.+)__local_(gpu|cpu|cosy)$/);
    return match ? match[1] : modelName;
};

export default function PromptHeader(props) {
    let { defaultPrompt, deepLinkModel, templateData } = props;

    // Utility function to try custom protocol with fallback
    const tryProtocolWithFallback = (protocolUrl) => {
        let hasBlurred = false;
        let timeoutId;

        const cleanup = () => {
            window.removeEventListener('blur', handleBlur);
            if (timeoutId) clearTimeout(timeoutId);
        };

        const handleBlur = () => {
            hasBlurred = true;
            cleanup();
        };

        // Add blur listener to detect if protocol launched successfully
        window.addEventListener('blur', handleBlur);

        // Set timeout for fallback
        timeoutId = setTimeout(() => {
            if (!hasBlurred) {
                cleanup();
                // Protocol likely failed, redirect to fallback
                navigate('/profile')
            }
        }, 1500);

        // Try the protocol
        try {
            window.location.assign(protocolUrl);
        } catch (error) {
            // If immediate error, cleanup and go to fallback
            cleanup();
            navigate('/profile')
        }
    };
    
    const generateStatus = useGenerateStatus();
    const generateStatusDispatch = useGenerateDispatch();
    const promptusAPIState = usePromptusAPIState();
    const promptusAPIDispatch = usePromptusAPIDispatch();
    const driverContext = useDriverContext();
    const driverContextDispatch = useDriverContextDispatch();
    const collectionContext = useCollectionContext();
    const collectionContextDispatch = useCollectionContextDispatch();
    const accountContext = useAccountContext();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [settings, setSettings] = useState([]);
    const [inPaint, setInPaint] = useState(false);
    const [maskImage, setMaskImage] = useState(null);
    const [openHistory, setOpenHistory] = useState(false);
    const [controlnetDisplay, setControlnetDisplay] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [audioPrompt, setAudioPrompt] = useState("");
    const [profilePhoto, setProfilePhoto] = useState(localStorage.getItem("profilePhoto") || "");
    const [saveStatus, setSaveStatus] = useState(''); // 'saved', 'error', or ''
    const [showCosyflowsGallery, setShowCosyflowsGallery] = useState(false);
    const [activeMediaType, setActiveMediaType] = useState('all'); // Track active media type
    const [filteringLoading, setFilteringLoading] = useState(false); // Track media filtering state
    const [modelMediaTypeMap, setModelMediaTypeMap] = useState(new Map()); // Cache for model → media type mapping
    const [allModels, setAllModels] = useState([]); // Store complete unfiltered model list
    const advancedSettingsRef = useRef(null);
    // Use centralized internet connectivity service
    const { hasInternet, shouldBypass, checkConnectivity } = useInternetBypass();
    const [options, setOptions] = useState([]);
    const [modelsLoading, setModelsLoading] = useState(true);
    const [allWorkflows, setAllWorkflows] = useState([]);
    const [promptMappings, setPromptMappings] = useState([]);
    const [dynamic_inputs, setDynamic_Inputs] = useState(default_values);
    const [selectedWorkflow, setSelectedWorkflow] = useState("");

    // Add back missing state variables
    const [promptOutput, setPromptOutput] = useState('text-image');
    const [submitPrompt, setSubmitPrompt] = useState(defaultPrompt.prompt.prompt);
    const [seed, setSeed] = useState(defaultPrompt.prompt.params.seed_value);
    const [negativeKeywords, setNegativeKeywords] = useState(defaultPrompt.prompt.negative_prompt);
    const [steps, setSteps] = useState(defaultPrompt.prompt.params.num_inference_steps);
    const [guidance, setGuidance] = useState(defaultPrompt.prompt.params.guidance_scale);
    const [imageCount, setImageCount] = useState(1);
    const [imageWidth, setImageWidth] = useState(defaultPrompt.prompt.params.width);
    const [imageHeight, setImageHeight] = useState(defaultPrompt.prompt.params.height);

    // State for tracking uploaded b64data values to persist across form re-renders
    const [uploadedB64Data, setUploadedB64Data] = useState({});
    const [selectedModel, setSelectedModel] = useState(null); // Will be set once models load
    const [modelTransitioning, setModelTransitioning] = useState(false);
    const latestRequestedModelRef = useRef(null);
    const [selectedScheduler, setSelectedScheduler] = useState(defaultPrompt.prompt.params.scheduler);
    const [tile, setTile] = useState(defaultPrompt.prompt.params.tile);
    const [shuffle, setShuffle] = useState(defaultPrompt.prompt.params.shuffle);
    const [upscale, setUpScale] = useState(defaultPrompt.prompt.params.upscale_factor);
    const [pix2pix, setPix2Pix] = useState(false);
    const [controlNet, setControlNet] = useState("");
    const [onlineState, setOnlineState] = useState(promptusAPIState.online);
    const [showOnlineModels, setShowOnlineModels] = useState(true);
    const [image, setImage] = useState(null);
    const [enhancePrompt, setEnhancePrompt] = useState(false);
    const [isEnhancing, setIsEnhancing] = useState(false);
    const [enhanceSuccess, setEnhanceSuccess] = useState(false);
    const [imageNets, setImageNets] = useState("");
    const [tag, setTag] = useState("");
    const [inputTag, setInputTag] = useState("");

    // Dynamic default models loaded from IndexedDB (populated by NavigationMenu polling)
    const [dynamicDefaultModels, setDynamicDefaultModels] = useState(null);
    const [managerOpen, setManagerOpen] = useState(false);
    const [apiLocalGPU, setApiLocalGPU] = useState("");
    const [apiLocalCPU, setApiLocalCPU] = useState("");
    const [apiLocalCosy, setApiLocalCosy] = useState("");
    const [onceTime, setOnceTime] = useState(false);
    const [selectedLora, setSelectedLora] = useState("");
    const [loraWeight, setLoraWeight] = useState(0);
    const { contextSubmitPrompt } = usePromptContext();
    const [memePrompt, setMemePrompt] = useState("");
    const [cosyUI, setCosyUI] = useState(false);
    const [onlineCosyUI, setOnlineCosyUI] = useState(false);
    const [schemaLoading, setSchemaLoading] = useState(false);
    const [schemaLoaded, setSchemaLoaded] = useState(false);
    console.log('[State Init] cosyUI initialized as false');

    const [input_json, setInput_json] = useState({});
    const [test_json, setTest_json] = useState({});

    const inputGroupRef = useRef();

    const [recording, setRecording] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const [audioURL, setAudioURL] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [logLoading, setLogLoading] = useState(false);
    const [cosyflowNotFound, setCosyflowNotFound] = useState(false);

    const [jobRequestPending, setJobRequestPending] = useState(false);

    const ipcRenderer = electronBridge.ipcRenderer
    const [loadedModelData, setLoadedModelData] = useState(null); // Track which model's data is loaded

    const [modelInvalidCheck, setModelInvalidCheck] = useState(false)
    const [testCheck, setTestCheck] = useState(false)

    const [showLoginModal, setShowLoginModal] = useState(false);

    // Category tariff data for showing credit costs in model dropdown
    const [categoryTariffs, setCategoryTariffs] = useState(new Map());

    // Drag-drop state for .prompt file loading
    const [isDraggingPromptFile, setIsDraggingPromptFile] = useState(false);

    // Add validation abort controller for cancelling ongoing validation
    const validationAbortController = useRef(null)

    // Ref to track previous server status for change detection
    const previousServerStatusRef = useRef(null)

    const { startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder({ audio: true });

    // Load dynamic default models from IndexedDB on mount
    useEffect(() => {
        const loadDefaultModels = async () => {
            try {
                const stored = await db.defaultModels.toArray();
                if (stored && stored.length > 0) {
                    const models = stored.map(m => ({
                        name: m.model,
                        weight: m.weighting
                    }));
                    setDynamicDefaultModels(models);
                    console.log('[PromptHeader] Loaded dynamic default models from IndexedDB:', models);
                } else {
                    console.log('[PromptHeader] No dynamic default models in IndexedDB, using hardcoded fallback');
                }
            } catch (error) {
                console.error('[PromptHeader] Error loading default models from IndexedDB:', error);
            }
        };
        loadDefaultModels();
    }, []);

    // Compute effective default models (dynamic or fallback to hardcoded)
    const effectiveDefaultModels = useMemo(() => {
        const models = dynamicDefaultModels || DEFAULT_MODEL_LIST_BASE;
        const shuffled = shuffleArray(models);
        console.log('[PromptHeader] Using effective default models:', shuffled.map(m => `${m.name} (${m.weight})`));
        return shuffled;
    }, [dynamicDefaultModels]);

    // Flat list of model names for backward compatibility
    const effectiveDefaultModelNames = useMemo(() => {
        return effectiveDefaultModels.map(item => item.name);
    }, [effectiveDefaultModels]);

    useEffect(() => {
        const handler = () => handleEnhancePromptClick();
        eventBus.on('enhancePromptTrue', handler);
        return () => eventBus.off('enhancePromptTrue', handler);
    }, [selectedModel, submitPrompt, isEnhancing]);

    useEffect(() => {
        const handler = () => toggleOffline(false); // or whatever args you want
        eventBus.on('offlineToggleTrue', handler);
        return () => eventBus.off('offlineToggleTrue', handler);
    }, []);

    useEffect(() => {
        const handler = (serverStatus) => {
            console.log('[PromptHeader] models_cache_refreshed event received - refreshing model list with servers:', serverStatus);
            if (!promptusAPIState.online) {
                fetchModels(serverStatus);
            }
        };
        eventBus.on('models_cache_refreshed', handler);
        return () => eventBus.off('models_cache_refreshed', handler);
    }, [promptusAPIState.online]);

    useEffect(() => {
        const fetchCategoryTariffs = async () => {
            try {
                const response = await getCosyflowCategories();
                console.log('[TARIFF] Response category tariffs:', response);
                if (response.categories && Array.isArray(response.categories)) {
                    const tariffMap = new Map();
                    response.categories.forEach(item => {
                        if (item.cosyflow_category && item.cost) {
                            tariffMap.set(item.cosyflow_category, parseFloat(item.cost));
                        }
                    });
                    setCategoryTariffs(tariffMap);
                    console.log('[TARIFF] Loaded category tariffs:', tariffMap.size, 'categories');
                }
            } catch (error) {
                console.error('[TARIFF] Error fetching category tariffs:', error);
            }
        };
        fetchCategoryTariffs();
    }, []);

    const getCostForModel = useCallback(async (modelName) => {
        if (!modelName || categoryTariffs.size === 0) return null;

        try {
            let cosyflow = await db.cosyflows.where('data.title').equals(modelName).first();

            if (!cosyflow?.data?.category) {
                try {
                    const apiData = await getCosyflowData(modelName);
                    if (apiData?.category) {
                        cosyflow = { data: apiData };
                    }
                } catch (e) {
                    // API fetch failed, continue without
                }
            }

            if (cosyflow?.data?.category) {
                const category = cosyflow.data.category;

                if (categoryTariffs.has(category)) {
                    return categoryTariffs.get(category);
                }

                const mediaType = category.split('/').pop();
                for (const [tariffCategory, cost] of categoryTariffs.entries()) {
                    if (tariffCategory.endsWith('/' + mediaType)) {
                        return cost;
                    }
                }
            }
        } catch (error) {
            console.warn('[TARIFF] Error getting cost for model:', modelName, error);
        }
        return null;
    }, [categoryTariffs]);

    const buildOptionsWithCost = useCallback(async (models) => {
        if (!models || models.length === 0) return [];

        if (!onlineState) {
            return models.map(model => ({ value: model, label: model, cost: null }));
        }

        const optionsWithCost = await Promise.all(
            models.map(async (model) => {
                const cost = await getCostForModel(model);
                return { value: model, label: model, cost: cost !== null ? cost + 6 : null };
            })
        );
        return optionsWithCost;
    }, [getCostForModel, onlineState]);

    // ========== MOMM IMAGE HANDLING HELPER FUNCTIONS ==========
    // Helper function to check if current model accepts images
    const checkModelAcceptsImages = (schema) => {
        if (!schema) return false;
        
        for (const [key, field] of Object.entries(schema)) {
            if (field.type === 'file' || 
                field.type === 'b64' || 
                field.type === 'b64data' || 
                field.type === 'IMAGE' ||
                (field.accept && field.accept.includes('image'))) {
                console.log('[MOMM_IMAGE] Model accepts images, found field:', key);
                return true;
            }
        }
        return false;
    };

    // Helper function to find first image field in schema
    const findImageField = (schema) => {
        if (!schema) return null;
        console.log('[MOMM_IMAGE] Finding image field in schema: ', schema);
        
        for (const [key, field] of Object.entries(schema)) {
            if (field.type === 'file' || 
                field.type === 'b64' || 
                field.type === 'b64data' || 
                field.type === 'IMAGE' ||
                (field.accept && field.accept.includes('image'))) {
                console.log('[MOMM_IMAGE] Found image field:', key);
                return key;
            }
        }
        return null;
    };

    const convertUrlToBase64 = async (url) => {
        console.log('[MOMM_IMAGE] Converting URL to base64:', url?.substring(0, 100));
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch image: ${response.status}`);
            }
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result.split(',')[1];
                    console.log('[MOMM_IMAGE] Successfully converted URL to base64, length:', base64?.length);
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('[MOMM_IMAGE] Error converting URL to base64:', error);
            throw error;
        }
    };

    const processImageAfterModelSwitch = async(imageUrl, modelName) => {
        console.log('[MOMM_IMAGE] Processing image after model switch...');
        console.log('[MOMM_IMAGE] imageUrl:', imageUrl?.substring(0, 100), '| modelName:', modelName);

        let newCosyVars = null;
        try {
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(modelName).first();
            if (matchingCosyflow && matchingCosyflow.data.variables) {
                newCosyVars = matchingCosyflow.data.variables;
                console.log('[MOMM_IMAGE] Found cosyflow variables for model');
            } else {
                console.warn('[MOMM_IMAGE] No cosyflow found for model:', modelName);
            }
        } catch (error) {
            console.error('[MOMM_IMAGE] Error fetching cosyflow variables:', error);
        }

        const imageFieldKey = findImageField(newCosyVars);
        console.log('[MOMM_IMAGE] Image field key found:', imageFieldKey);

        if (imageFieldKey) {
            console.log('[MOMM_IMAGE] Setting image to field:', imageFieldKey);

            let processedImage = imageUrl;

            if (imageUrl.startsWith('data:')) {
                const base64Match = imageUrl.match(/base64,(.+)/);
                if (base64Match) {
                    processedImage = base64Match[1];
                    console.log('[MOMM_IMAGE] Extracted base64 from data URL');
                }
            } else if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('blob:')) {
                try {
                    processedImage = await convertUrlToBase64(imageUrl);
                    console.log('[MOMM_IMAGE] Converted HTTP/blob URL to base64');
                } catch (error) {
                    console.error('[MOMM_IMAGE] Failed to convert URL to base64:', error);
                    return;
                }
            }

            console.log('[MOMM_IMAGE] Setting uploadedB64Data for field:', imageFieldKey);
            setUploadedB64Data(prev => ({
                ...prev,
                [imageFieldKey]: processedImage
            }));

            setTimeout(() => {
                if (inputGroupRef.current && inputGroupRef.current.setValue) {
                    inputGroupRef.current.setValue(imageFieldKey, processedImage);
                    console.log('[MOMM_IMAGE] Set image to form field via inputGroupRef');
                } else {
                    console.warn('[MOMM_IMAGE] inputGroupRef not available');
                }
            }, 200);

            console.log('[MOMM_IMAGE] Successfully set image from MOMM');

            if (!settingsOpen) {
                console.log('[MOMM_IMAGE] Opening settings panel...');
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
        } else {
            console.warn('[MOMM_IMAGE] No image field found in current model schema');
        }
    };
    // ========== END MOMM IMAGE HANDLING HELPER FUNCTIONS ==========

    // Helper function to extract prompts from current model using importance levels
    const extractPromptsFromCurrentModel = async (promptData) => {
        const prompts = {
            positive: '',
            negative: ''
        };
        
        if (!promptData?.prompt) return prompts;
        
        const prompt = promptData.prompt;
        
        // Get cosyflow variables for current model using indexed lookup
        const currentCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();
        
        if (currentCosyflow?.data?.variables) {
            const variables = currentCosyflow.data.variables;
            
            // Find positive prompt (importance: 5)
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 5 && prompt[key]) {
                    prompts.positive = prompt[key];
                    console.log(`[EXTRACT] Found positive prompt in field "${key}"`);
                    break;
                }
            }
            
            // Find negative prompt (importance: 4 or common field names)
            for (const [key, variable] of Object.entries(variables)) {
                if ((variable.importance === 4 || 
                     key.includes('negative') || 
                     key === 'negative_prompt') && 
                    prompt[key]) {
                    prompts.negative = prompt[key];
                    console.log(`[EXTRACT] Found negative prompt in field "${key}"`);
                    break;
                }
            }
        }
        
        // Fallback to common field names if no importance levels found
        if (!prompts.positive) {
            prompts.positive = prompt.prompt || prompt.text || submitPrompt || '';
        }
        if (!prompts.negative) {
            prompts.negative = prompt.negative_prompt || prompt.negative || '';
        }
        
        console.log('[EXTRACT] Extracted prompts:', prompts);
        return prompts;
    };

    // Helper function to apply extracted prompts to new model's schema
    const applyPromptsToNewModel = async (prompts, model) => {
        console.log(`[APPLY] Applying prompts to model: ${model}`, prompts);
        
        // Get the new model's schema using indexed lookup
        const newCosyflow = await db.cosyflows.where('data.title').equals(model).first();
        
        if (newCosyflow?.data?.variables) {
            const variables = newCosyflow.data.variables;
            const updates = {};
            
            // Find and set positive prompt field
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 5) {
                    updates[key] = prompts.positive;
                    console.log(`[APPLY] Setting positive prompt to field "${key}"`);
                    break;
                }
            }
            
            // Find and set negative prompt field
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 4 || 
                    key.includes('negative') || 
                    key === 'negative_prompt') {
                    updates[key] = prompts.negative;
                    console.log(`[APPLY] Setting negative prompt to field "${key}"`);
                    break;
                }
            }
            
            // Apply updates to form
            if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                const currentValues = inputGroupRef.current.getValues();
                inputGroupRef.current.resetForm({
                    ...currentValues,
                    ...updates
                });
            }
            
            // Also update submitPrompt for fallback
            setSubmitPrompt(prompts.positive);
        } else {
            // Fallback: just set the main prompt
            setSubmitPrompt(prompts.positive);
        }
    };

    useEffect(() => {
        const handler = () => setJobRequestPending(false); // or whatever args you want
        eventBus.on('request_pending', handler);
        return () => eventBus.off('request_pending', handler);
    }, []);

    // Listen for successful login events to close the LoginModal
    useEffect(() => {
        const handler = () => {
            console.log('[PromptHeader] Login success event received - closing LoginModal');
            setShowLoginModal(false);
        };
        eventBus.on('user-logged-in', handler);
        return () => eventBus.off('user-logged-in', handler);
    }, []);

    // Listen for useImage event from CollectionImage
    useEffect(() => {
        const handleUseImage = (imageData) => {
            console.log('[PromptHeader] Received useImage event with data:', imageData);
            
            // Ensure settings are open first so the form exists
            if (!settingsOpen) {
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
            
            // Wait for form to be ready
            setTimeout(() => {
                // Find the appropriate image input field in the current schema
                // Priority: 1) URL type fields, 2) b64data with url_allowed, 3) other image fields
                const currentSchema = promptMappings;
                let imageFieldKey = null;
                let fieldType = null;
                let shouldUseUrl = false;

                // First pass: Look for URL type fields with image_upload flag
                for (const [key, field] of Object.entries(currentSchema || {})) {
                    if (field.type === 'url' && field.image_upload === true) {
                        imageFieldKey = key;
                        fieldType = 'url';
                        shouldUseUrl = true;
                        console.log(`[EVENT useImage] Found URL field with image_upload: ${key}`);
                        break;
                    }
                }

                // Second pass: Look for b64data fields with url_allowed
                if (!imageFieldKey) {
                    for (const [key, field] of Object.entries(currentSchema || {})) {
                        if (field.type === 'b64data' && field.url_allowed === true) {
                            imageFieldKey = key;
                            fieldType = 'b64data';
                            shouldUseUrl = true;
                            console.log(`[EVENT useImage] Found b64data field with URL support: ${key}`);
                            break;
                        }
                    }
                }

                // Third pass: Look for traditional image fields (convert URL to base64)
                if (!imageFieldKey) {
                    for (const [key, field] of Object.entries(currentSchema || {})) {
                        if (field.type === 'file' || field.type === 'b64' ||
                            field.type === 'b64data' || field.type === 'image' ||
                            field.type === 'IMAGE' ||
                            (field.accept && field.accept.includes('image'))) {
                            imageFieldKey = key;
                            fieldType = field.type;
                            shouldUseUrl = false;
                            console.log(`[EVENT useImage] Found traditional image field: ${key}`);
                            break;
                        }
                    }
                }

                if (imageFieldKey) {
                    console.log(`[EVENT useImage] Using field: ${imageFieldKey}, type: ${fieldType}, shouldUseUrl: ${shouldUseUrl}`);

                    // Set the image data to the appropriate field
                    setUploadedB64Data(prev => ({
                        ...prev,
                        [imageFieldKey]: imageData.image
                    }));

                    // Trigger a re-render of the form with the new data
                    if (inputGroupRef.current && inputGroupRef.current.setValue) {
                        inputGroupRef.current.setValue(imageFieldKey, imageData.image);
                        console.log(`[EVENT useImage] Set image to dynamic field: ${imageFieldKey}`);
                    } else {
                        console.log('[EVENT useImage] Form not ready yet, image saved to uploadedB64Data');
                    }
                } else {
                    console.warn('[EVENT useImage] No image input field found in current schema');
                }
            }, 500); // Give time for form to render
        };
        
        eventBus.on('useImage', handleUseImage);
        return () => eventBus.off('useImage', handleUseImage);
    }, [settingsOpen, promptMappings]);

    // Listen for useAudio event from Audio component
    useEffect(() => {
        const handleUseAudio = (audioData) => {
            console.log('[PromptHeader] Received useAudio event with data:', audioData);

            // Ensure settings are open first so the form exists
            if (!settingsOpen) {
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }

            // Wait for form to be ready
            setTimeout(() => {
                // Find the appropriate audio input field in the current schema
                const currentSchema = promptMappings;
                let audioFieldKey = null;

                // Look for URL type fields with audio_upload flag
                for (const [key, field] of Object.entries(currentSchema || {})) {
                    if (field.type === 'url' && field.audio_upload === true) {
                        audioFieldKey = key;
                        console.log(`[EVENT useAudio] Found URL field with audio_upload: ${key}`);
                        break;
                    }
                }

                if (audioFieldKey) {
                    console.log(`[EVENT useAudio] Using field: ${audioFieldKey}`);

                    // Set the audio data to the appropriate field
                    setUploadedB64Data(prev => ({
                        ...prev,
                        [audioFieldKey]: audioData.audio
                    }));

                    // Trigger a re-render of the form with the new data
                    if (inputGroupRef.current && inputGroupRef.current.setValue) {
                        inputGroupRef.current.setValue(audioFieldKey, audioData.audio);
                        console.log(`[EVENT useAudio] Set audio to dynamic field: ${audioFieldKey}`);
                    } else {
                        console.log('[EVENT useAudio] Form not ready yet, audio saved to uploadedB64Data');
                    }
                } else {
                    console.warn('[EVENT useAudio] No audio input field found in current schema');
                }
            }, 500); // Give time for form to render
        };

        eventBus.on('useAudio', handleUseAudio);
        return () => eventBus.off('useAudio', handleUseAudio);
    }, [settingsOpen, promptMappings]);

    // Listen for useVideo event from Video component
    useEffect(() => {
        const handleUseVideo = (videoData) => {
            console.log('[PromptHeader] Received useVideo event with data:', videoData);

            // Ensure settings are open first so the form exists
            if (!settingsOpen) {
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }

            // Wait for form to be ready
            setTimeout(() => {
                // Find the appropriate video input field in the current schema
                const currentSchema = promptMappings;
                let videoFieldKey = null;

                // Look for URL type fields with video_upload flag
                for (const [key, field] of Object.entries(currentSchema || {})) {
                    if (field.type === 'url' && field.video_upload === true) {
                        videoFieldKey = key;
                        console.log(`[EVENT useVideo] Found URL field with video_upload: ${key}`);
                        break;
                    }
                }

                if (videoFieldKey) {
                    console.log(`[EVENT useVideo] Using field: ${videoFieldKey}`);

                    // Set the video data to the appropriate field
                    setUploadedB64Data(prev => ({
                        ...prev,
                        [videoFieldKey]: videoData.video
                    }));

                    // Trigger a re-render of the form with the new data
                    if (inputGroupRef.current && inputGroupRef.current.setValue) {
                        inputGroupRef.current.setValue(videoFieldKey, videoData.video);
                        console.log(`[EVENT useVideo] Set video to dynamic field: ${videoFieldKey}`);
                    } else {
                        console.log('[EVENT useVideo] Form not ready yet, video saved to uploadedB64Data');
                    }
                } else {
                    console.warn('[EVENT useVideo] No video input field found in current schema');
                }
            }, 500); // Give time for form to render
        };

        eventBus.on('useVideo', handleUseVideo);
        return () => eventBus.off('useVideo', handleUseVideo);
    }, [settingsOpen, promptMappings]);

    // ========== MOMM IMAGE HANDLING USEEFFECT ==========
    const [mommImageProcessed, setMommImageProcessed] = useState(false);

    useEffect(() => {
        if (!schemaLoaded || schemaLoading || mommImageProcessed) {
            return;
        }

        const sessionImageData = sessionStorage.getItem('imageToUse');
        if (!sessionImageData) {
            return;
        }

        console.log('[MOMM_IMAGE] Schema loaded, checking for MOMM image...');

        try {
            const imageData = JSON.parse(sessionImageData);
            console.log('[MOMM_IMAGE] Found image data:', {
                fromMOMM: imageData.fromMOMM,
                needsImageModel: imageData.needsImageModel,
                preferredModel: imageData.preferredModel,
                urlPreview: imageData.url?.substring(0, 50)
            });

            if (!imageData.fromMOMM || !imageData.needsImageModel) {
                console.log('[MOMM_IMAGE] Image not from MOMM or does not need model selection, skipping');
                return;
            }

            const targetModel = imageData.preferredModel || "(GenAI) Nano Banana 2.5 Flash";

            if (selectedModel !== targetModel) {
                console.log('[MOMM_IMAGE] Model mismatch, waiting for correct model. Current:', selectedModel, 'Target:', targetModel);
                return;
            }

            console.log('[MOMM_IMAGE] Model matches, processing image now...');
            setMommImageProcessed(true);

            sessionStorage.removeItem('imageToUse');
            console.log('[MOMM_IMAGE] Cleared sessionStorage');

            setTimeout(() => {
                processImageAfterModelSwitch(imageData.url, selectedModel);
            }, 300);

        } catch (error) {
            console.error('[MOMM_IMAGE] Error processing MOMM image:', error);
            sessionStorage.removeItem('imageToUse');
        }
    }, [schemaLoaded, schemaLoading, selectedModel, mommImageProcessed]);
    // ========== END MOMM IMAGE HANDLING USEEFFECT ==========
    
    // Listen for selectModel event to change models programmatically
    useEffect(() => {
        const handleSelectModel = ({ modelName, openSettings = false }) => {
            console.log('[EVENT selectModel] Received selectModel event:', modelName);
            
            // Open settings first if requested (ensures form exists)
            if (openSettings && !settingsOpen) {
                console.log('[EVENT selectModel] Opening settings panel');
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
            
            // Set the model (will trigger handleRecommendedSettings via existing useEffect)
            console.log('[EVENT selectModel] Setting model to:', modelName);
            setSelectedModel(modelName);
            // Removed direct handleRecommendedSettings call - useEffect will handle it
        };
        
        eventBus.on('selectModel', handleSelectModel);
        return () => eventBus.off('selectModel', handleSelectModel);
    }, [settingsOpen]);

    // Listen for model_unavailable event from Generate.jsx
    useEffect(() => {
        const handleModelUnavailable = async (data) => {
            console.log('[MODEL FALLBACK] Received model unavailable event', data);
            
            const { attemptedModels = [], originalPrompt } = data;
            
            // Extract current prompts using form values
            const currentFormValues = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
            console.log('[MODEL FALLBACK] currentFormValues', currentFormValues);
            const promptData = { prompt: currentFormValues };
            console.log('[MODEL FALLBACK] promptData', promptData);
            const currentPrompts = await extractPromptsFromCurrentModel(promptData);
            console.log('[MODEL FALLBACK] currentPromptst', currentPrompts);

            // Fetch cosyflow variables to check field types
            let currentCosyVars = null;
            try {
                // Use indexed lookup for O(log n) performance
                const matchingCosyflow = await db.cosyflows.where('data.title').equals(data.currentModel).first();
                if (matchingCosyflow && matchingCosyflow.data.variables) {
                    currentCosyVars = matchingCosyflow.data.variables;
                }
            } catch (error) {
                console.error('[MODEL FALLBACK] Error fetching cosyflow variables:', error);
            }


            let currentMainPrompt;

            const searchMainPrompt = (promptData, cosyVars, edit, newValue = null) => {
                // Try to get the cosyflow variables which contain the importance metadata
                if (cosyVars) {
                    console.log('[MODEL FALLBACK] Using cosyflow variables to find main prompt field: ', promptData, ' | ', cosyVars);
                    
                    // Find fields with importance: 5 (main prompt fields)
                    const mainPromptFields = [];
                    for (const [key, variable] of Object.entries(cosyVars)) {
                        if (variable.importance === 5) {
                            mainPromptFields.push(key);
                            console.log(`[MODEL FALLBACK] Found field with importance 5: "${key}"`);
                        }
                    }
                    
                    // Check if any of the main prompt fields have valid content or need to be set
                    for (const fieldName of mainPromptFields) {
                        if (edit === true && newValue !== null) {
                            // Edit mode: Set the prompt value
                            console.log(`[MODEL FALLBACK] Setting prompt in field "${fieldName}" to: "${newValue.substring(0, 50)}..."`);
                            inputGroupRef.current.setValue(fieldName, newValue);
                            return promptData; // Return modified data
                        } else if (edit === false) {
                            // Read mode: Get the prompt value
                            if (fieldName in promptData) {
                                if (typeof promptData[fieldName] === 'string' && promptData[fieldName].trim() !== '') {
                                    console.log(
                                        `[MODEL FALLBACK] Found valid prompt in importance:5 field "${fieldName}": "${promptData[fieldName].substring(0, 50)}..."`
                                    );
                                    return promptData[fieldName];
                                     // Return the found value
                                }
                            }
                        }
                    }
                    
                    // If in edit mode and no existing field found, still set it in the first importance:5 field
                    if (edit === true && newValue !== null && mainPromptFields.length > 0) {
                        const firstField = mainPromptFields[0];
                        console.log(`[MODEL FALLBACK] Setting prompt in first importance:5 field "${firstField}"`);
                        promptData[firstField] = newValue;
                        return promptData;
                    }
                }
                
                return edit ? promptData : null; // Return data if editing, null if not found when reading
            }

            currentMainPrompt = searchMainPrompt(currentFormValues, currentCosyVars, false, null)
            console.log('[MODEL FALLBACK] Found Main Prompt: ', currentMainPrompt);
            
            // Find next available model
            const availableModels = MODEL_FALLBACK_LIST.filter(
                model => !attemptedModels.includes(model) && !attemptedModels.includes(data.currentModel)
            );
            
            if (availableModels.length === 0 || attemptedModels.length >= 4) {
                console.error('[MODEL FALLBACK] All fallback models exhausted');
                Swal.fire({
                    title: "All Models Unavailable",
                    text: "All fallback models are currently unavailable. Please try again later or contact support.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E"
                });
                generateStatusDispatch({ type: 'ready' });
                return;
            }
            
            // Select next model
            const nextModel = availableModels[Math.floor(Math.random() * availableModels.length)];
            console.log(`[MODEL FALLBACK] Attempting with model: ${nextModel} (attempt ${attemptedModels.length + 1}/5)`);
            
            // Show user feedback
            generateStatusDispatch({ 
                type: 'info', 
                message: `Original model unavailable, trying ${nextModel}...` 
            });
            
            // Switch to new model and load its schema
            setSelectedModel(nextModel);

            // Fetch cosyflow variables to check field types
            let newCosyVars = null;
            try {
                // Use indexed lookup for O(log n) performance
                const matchingCosyflow = await db.cosyflows.where('data.title').equals(nextModel).first();
                if (matchingCosyflow && matchingCosyflow.data.variables) {
                    newCosyVars = matchingCosyflow.data.variables;
                }
            } catch (error) {
                console.error('[MODEL FALLBACK] Error fetching cosyflow variables:', error);
            }
            
            // Wait for schema to load
            await handleRecommendedSettings(nextModel);
            
            // Small delay to ensure form is ready
            setTimeout(() => {
                // Apply preserved prompts to new model
                // applyPromptsToNewModel(currentPrompts, nextModel);
                
                // Get current form values for retry
                const currentValues = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
                let newData = searchMainPrompt(currentValues,newCosyVars,true,currentMainPrompt)
                console.log('[MODEL FALLBACK] Attempt at editing the current prompt into new model: ', newData);
                
                const finalData = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
                // Flatten nested params object if it exists (React Hook Form creates nested structure for dotted field names)
                if (finalData.params && typeof finalData.params === 'object') {
                    console.log('[PARAMS FIX] Found nested params object, flattening it...');
                    // Extract all fields from params object
                    Object.entries(finalData.params).forEach(([key, value]) => {
                        finalData[`params.${key}`] = value;
                        console.log(`[PARAMS FIX] Flattened params.${key} =`, value);
                    });
                    // Remove the nested params object
                    delete finalData.params;
                    console.log('[PARAMS FIX] Removed nested params object');
                }
                
                console.log('[MODEL FALLBACK] Final Object before generation: ', finalData);

                const retryPrompt = {
                    prompt: finalData,
                    _attemptedModels: [...attemptedModels, data.currentModel],
                    _isRetry: true
                };
                
                // Small delay to ensure prompts are applied
                setTimeout(() => {
                    // Trigger generate with new model
                    console.log('[MODEL FALLBACK] Retrying generation with new model');
                    props.handleGenerate(retryPrompt, false, null);
                }, 200);
            }, 1000);
        };
        
        eventBus.on('model_unavailable', handleModelUnavailable);
        return () => eventBus.off('model_unavailable', handleModelUnavailable);
    }, [selectedModel, props]);

    // Skeleton Loader Component for Dynamic Inputs
    const DynamicInputsSkeleton = () => {
        return (
            <div className="flex flex-row flex-wrap gap-5">
                {/* Create 6 skeleton input fields */}
                {[1, 2, 3, 4, 5, 6].map((index) => (
                    <div key={index} className="animate-pulse">
                        {/* Skeleton for label */}
                        <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
                        {/* Skeleton for input field */}
                        <div className="h-10 bg-gray-200 rounded w-40"></div>
                    </div>
                ))}
            </div>
        );
    };

    // Lottie Animation Loader Component
    const LottieLoader = () => {
        return (
            <div className="flex justify-center items-center p-10">
                <div style={{ width: '200px', height: '200px' }}>
                    <lottie-player
                        autoplay
                        loop
                        mode="normal"
                        src={PromptSpin}
                        style={{ width: '100%', height: '100%' }}
                    ></lottie-player>
                </div>
            </div>
        );
    };

    // Connectivity logic now handled by useInternetBypass hook

    const openFile = (imageData) => {
        let imageDetails;
        try {
            imageDetails = JSON.parse(imageData);
        } catch (error) {
            console.error("Error opening file: ", error)
        }
        console.log("Image details: ", imageDetails);
        if (imageDetails['Promptus v1.0']) {
            setPromptinalPrompts(imageDetails['Promptus v1.0']);
        } else {
            setWholePrompt(imageDetails, false, true);
        }
    };

    const setPromptinalPrompts = (promptinal) => {
        let includeImages = false;
        let notFound = true;
        if (promptinal.generate.prompt) {
            setSubmitPrompt(promptinal.generate.prompt);
        }
        setSeed(promptinal.generate.seed);
        setNegativeKeywords(promptinal.generate.negative_prompt);
        setSelectedLora(promptinal.generate.lora);
        setSelectedScheduler(promptinal.generate.scheduler);
        setSteps(promptinal.generate.num_inference_steps);
        setGuidance(promptinal.generate.guidance_scale);
        setImageCount(1);
        setImageWidth(promptinal.generate.width);
        setImageHeight(promptinal.generate.height);
        promptusAPIState.models.map(model => {
            console.log("Model: ", model);
            if (promptinal.generate.model == model) {
                setSelectedModel(model);
                notFound = false;
            }
        })
        if (notFound) {
            Swal.fire({
                title: "Model not found",
                text: "The model you are trying to use is not available. Please select another model.",
                icon: "error",
                timer: 1500,
                showConfirmButton: false
            }).then(() => {
                setSettingsOpen(true);
                // setSelectedModel("stable-diffusion-v1-5");
            });
        }
        if (prompt.prompt.params.tile == "0" || prompt.prompt.params.tile.toLowercase() == "false" || prompt.prompt.params.tile == false || prompt.prompt.params.tile == "" || prompt.prompt.params.tile == "n/p") {
            setTile(false);
        } else {
            setTile(true);
        }
        if (prompt.prompt.params.shuffle == "0" || prompt.prompt.params.shuffle.toLowercase() == "false" || prompt.prompt.params.shuffle == false || prompt.prompt.params.shuffle == "" || prompt.prompt.params.shuffle == "n/p") {
            setShuffle(false);
        } else {
            setShuffle(true);
        }
        // setUpScale(promptinal.generate.upscale);
        if (promptinal.sources.source_image && includeImages) {
            setImage(promptinal.sources.source_image);
            setControlNet(promptinal.sources.control_net);
        }
        if (promptinal.sources.mask_image) {
            // setMaskImage(promptinal.sources.mask_image); // Nice to have when functional
        }
    }

    useEffect(() => {
        if (electronBridge.isElectron) {
            const openFileListener = (e, imageData) => {
                console.log(`open file listener triggered`);
                openFile(imageData);
            };

            const openPromptinalListener = (e, promptinal) => {
                let imageDetails = JSON.parse(promptinal);
                console.log("Promptinal details: ", imageDetails['Promptus v1.0']);
                setPromptinalPrompts(imageDetails['Promptus v1.0']);
            };

            if (window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.on("open-file", openFileListener);
                window.electron.ipcRenderer.on("open-promptinal", openPromptinalListener);

                return () => {
                    window.electron.ipcRenderer.removeListener("open-file", openFileListener);
                    window.electron.ipcRenderer.removeListener("open-promptinal", openPromptinalListener);
                }
            }
        }
    }, []);

    /**
     * Get the server
     * @returns {Promise<*>}
     */
    const getServer = async () => {
        return await db.settings
            .where("key")
            .equals("api_host")
            .first(setting => setting.value)
    }

    async function checkIfHostsMatch(mainHost, host) {
        const records = await db.settings
            .where("key")
            .anyOf([mainHost, host])
            .toArray();

        if (records.length === 2) {
            return records[0].value === records[1].value;
        }

        return false; // One or both keys are missing
    }

    useEffect(() => {
        // let retainedPrompt;
        // try {
        //     retainedPrompt = JSON.parse(localStorage.getItem("Generate"))
        // } catch (error) {
        //     console.error("Error fetching the saved prompt: ", error)
        // }
        // if (retainedPrompt) {
        //     setSubmitPrompt(retainedPrompt.prompt);
        //     setEnhancePrompt(retainedPrompt.enhancePrompt);
        //     setSeed(retainedPrompt.seed);
        //     setNegativeKeywords(retainedPrompt.negativeKeywords);
        //     setSteps(retainedPrompt.steps);
        //     setGuidance(retainedPrompt.guidance);
        //     setImageCount(retainedPrompt.imageCount);
        //     setImageWidth(retainedPrompt.imageWidth);
        //     setImageHeight(retainedPrompt.imageHeight);
        //     if (retainedPrompt.selectedModel && retainedPrompt.selectedModel.trim() !== '') {
        //         setSelectedModel(retainedPrompt.selectedModel);
        //     } else {
        //         // If no valid model in retained prompt, don't use retained dimensions
        //         // Let the default model's recommended settings load instead
        //         console.log('[Retained Prompt] No valid model found, will use default model dimensions');
        //         // Reset dimensions to defaults so handleRecommendedSettings can set them correctly
        //         setImageWidth(defaultPrompt.prompt.params.width);
        //         setImageHeight(defaultPrompt.prompt.params.height);
        //     }
        //     setSelectedScheduler(retainedPrompt.selectedScheduler);
        //     setTile(retainedPrompt.tile);
        //     setShuffle(retainedPrompt.shuffle);
        //     setUpScale(retainedPrompt.upscale);
        // }
        db.settings.toArray(settings => {
            settings.forEach(setting => {
                switch (setting.key) {
                    case "local_gpu":
                        setApiLocalGPU(setting.value);
                        break;
                    case "local_cpu":
                        setApiLocalCPU(setting.value);
                        break;
                    case "local_cosy":
                        setApiLocalCosy(setting.value);
                        break;
                    default:
                        // do nothing.
                        return;
                }
            });
        });

        checkIfHostsMatch(promptusAPIState.host, "local_cosy").then((matches) => {
            console.log('[Component Mount] checkIfHostsMatch result:', matches, 'host:', promptusAPIState.host);
            setCosyUI(matches)
        })

        // Log initial state
        console.log('[Component Mount] Initial state:', {
            selectedModel: defaultPrompt.prompt.params.model || getAvailableDefaultModel([], promptusAPIState.online, effectiveDefaultModels),
            cosyUI: false, // Initial value
            promptusAPIState_host: promptusAPIState.host
        });
    }, [effectiveDefaultModels])

    // Clear uploaded b64data only when switching to a different model
    useEffect(() => {
        // Don't clear on initial mount
        const defaultModel = getAvailableDefaultModel(options, promptusAPIState.online, effectiveDefaultModels);
        if (selectedModel === defaultPrompt.prompt.params.model || 
            selectedModel === defaultModel) {
            return;
        }
        
        // Clear uploaded data when model actually changes
        // This will be repopulated by handleRecommendedSettings if the model has saved images
        console.log('[IMAGE CLEAR] Clearing uploadedB64Data due to model change to:', selectedModel);
        setUploadedB64Data({});
    }, [selectedModel]);

    /**
     * Get the login method
     * @returns {Promise<*>}
     */
    const checkServer = async (localhost) => {
        if (localhost === apiLocalGPU) {
            db.settings.put({ key: 'api_host', value: apiLocalGPU })
            promptusAPIDispatch({type: 'setHost', host: apiLocalGPU});
            return apiLocalGPU
        } else if (localhost === apiLocalCPU) {
            db.settings.put({ key: 'api_host', value: apiLocalCPU })
            promptusAPIDispatch({type: 'setHost', host: apiLocalCPU});
            return apiLocalCPU
        } else if (localhost === apiLocalCosy) {
            db.settings.put({ key: 'api_host', value: apiLocalCosy })
            promptusAPIDispatch({type: 'setHost', host: apiLocalCosy});
            return apiLocalCosy
        }
    }

    // Helper function to show the offline setup dialog when no servers are detected
    const showOfflineSetupDialog = () => {
        Swal.fire({
            title: "Run Promptus Offline",
            text: "Create offline on your computer with a one-time download, no monthly costs.",
            icon: "warning",
            confirmButtonText: "Download Now",
            confirmButtonColor: "#FFB02E",
            showConfirmButton: electronBridge.isElectron ? false : true,
            showDenyButton: true,
            denyButtonText: 'Open Manager',
            denyButtonColor: '#190A4E'
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/profile')
            }
            if (result.isDenied) {
                if (electronBridge.isElectron) {
                    electronBridge && electronBridge.ipcRenderer && electronBridge.ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, localStorage.getItem('longLifeAPIKey'));
                } else {
                    const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${localStorage.getItem('longLifeAPIKey')}`;
                    tryProtocolWithFallback(protocolUrl);
                }
            }
        });
    };

    const toggleOffline = async (checked) => {
        generateStatusDispatch({ type: 'clearError' });

        // Immediately abort any ongoing validation to allow instant offline switching
        if (validationAbortController.current) {
            validationAbortController.current.abort();
            console.log('[TOGGLE OFFLINE] Aborted ongoing validation for instant mode switch');
        }

        // Reset validation state to allow immediate model loading
        setModelInvalidCheck(false);

        if (checked) {
            // Switch to online mode
            console.log('[TOGGLE OFFLINE] User chose online mode');
            promptusAPIDispatch({ type: 'online' });
            setSelectedModel(''); // Clear selected model so default can be set for online mode
            setOptions([]); // Clear options to prevent flash of old models

            setOnlineState(true);
            setCosyUI(false);

        } else {
            // USER CHOSE OFFLINE - Now smartly detect active servers
            console.log('[TOGGLE OFFLINE] User chose offline mode - detecting active servers...');

            // Check for currently detected servers from our real-time detection
            const activeServers = generateStatus.serverStatus || {};
            const hasActiveServers = Object.keys(activeServers).length > 0;

            if (hasActiveServers) {
                console.log('[TOGGLE OFFLINE] ✅ Active servers found:', activeServers);

                try {
                    // Determine server priority: GPU > CPU > Cosy
                    let selectedServerType = null;
                    let selectedServerUrl = null;

                    if (activeServers.gpu) {
                        selectedServerType = 'gpu';
                        selectedServerUrl = activeServers.gpu;
                    } else if (activeServers.cpu) {
                        selectedServerType = 'cpu';
                        selectedServerUrl = activeServers.cpu;
                    } else if (activeServers.cosy) {
                        selectedServerType = 'cosy';
                        selectedServerUrl = activeServers.cosy;
                    }

                    if (selectedServerUrl) {
                        console.log(`[TOGGLE OFFLINE] 🎯 Selected ${selectedServerType} server: ${selectedServerUrl}`);

                        // Switch to offline mode with detected server
                        promptusAPIDispatch({ type: 'offline' });
                        setSelectedModel(''); // Clear selected model so default can be set for offline mode
                        setOptions([]); // Clear options to prevent flash of old models
                        setOnlineState(false);

                        // Update API host setting
                        await db.settings.put({ key: 'api_host', value: selectedServerUrl });

                        // Set appropriate server flags
                        if (selectedServerType === 'gpu') {
                            promptusAPIDispatch({ type: 'setActiveGPU', server: true });
                        } else if (selectedServerType === 'cpu') {
                            promptusAPIDispatch({ type: 'setActiveCPU', server: true });
                        } else if (selectedServerType === 'cosy') {
                            promptusAPIDispatch({ type: 'setActiveCosy', server: true });
                        }

                        console.log('[TOGGLE OFFLINE] ✅ Successfully switched to offline mode with detected servers');
                    } else {
                        throw new Error('No valid server selected from active servers');
                    }

                } catch (error) {
                    console.error('[TOGGLE OFFLINE] ❌ Error switching to offline mode with detected servers:', error);
                    // Reset toggle to online state since offline switch failed
                    setOnlineState(true);
                    // Fall back to setup dialog
                    showOfflineSetupDialog();
                }
            } else {
                console.log('[TOGGLE OFFLINE] ⚠️ No active servers detected - showing setup dialog');
                // Reset toggle to online state since no servers detected
                setOnlineState(true);
                // No servers detected - use existing manual setup flow
                showOfflineSetupDialog();
            }
        }
    };

    const handleEnhancePromptClick = async () => {
        if (isEnhancing) return;

        let promptToEnhance = '';
        let dynamicInputKey = null;

        console.error('[ENHANCE_PROMPT] selecteModel', selectedModel);

        if (submitPrompt && submitPrompt.trim() !== '') {
            promptToEnhance = submitPrompt.trim();
        } else {
            try {
                const matchingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();
                if (matchingCosyflow && matchingCosyflow.data.variables) {
                    const cosyflowVariables = matchingCosyflow.data.variables;
                    for (const [key, variable] of Object.entries(cosyflowVariables)) {
                        if (variable.importance === 5 && variable.type === 'prompt') {
                            const formValues = inputGroupRef.current?.getValues?.() || {};
                            if (formValues[key] && typeof formValues[key] === 'string' && formValues[key].trim() !== '') {
                                promptToEnhance = formValues[key].trim();
                                dynamicInputKey = key;
                                break;
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('[ENHANCE_PROMPT] Error fetching cosyflow variables:', error);
            }
        }

        if (!promptToEnhance) {
            Swal.fire({
                title: 'No Prompt Found',
                text: 'Please enter a prompt before enhancing.',
                icon: 'warning',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        setIsEnhancing(true);
        setEnhanceSuccess(false);

        try {
            console.log('[ENHANCE_PROMPT] About to enhance this prompt : ', promptToEnhance);
            const response = await enhancePromptAPI(promptToEnhance);
            console.log('[ENHANCE_PROMPT] Prompt Enhance Response : ', response);
            if (response && !response.error && response.enhanced) {
                setSubmitPrompt(response.enhanced);
                if (dynamicInputKey && inputGroupRef.current && inputGroupRef.current.setValue) {
                    inputGroupRef.current.setValue(dynamicInputKey, response.enhanced);
                }
                setEnhanceSuccess(true);
                setTimeout(() => setEnhanceSuccess(false), 2000);
            } else if (response && response.error) {
                console.error('[ENHANCE_PROMPT] API error:', response.message);
            }
        } catch (error) {
            console.error('[ENHANCE_PROMPT] Error calling enhance API:', error);
        } finally {
            setIsEnhancing(false);
        }
    };

    const help = (e) => {
        const driver = new Driver({
            onReset: () => { driverContextDispatch({ type: 'off' }); }
        });
        driverContextDispatch({ type: 'on' });
        setTimeout(() => {
            helpOverlays(e, driver);
            if (driverContext.advanced == true) {
                driver.start(9);
            }
            if (driverContext.controlNet == true) {
                driver.start(19);
            }
            if (driverContext.advanced == false && driverContext.controlNet == false) {
                driver.start();
            }
        }, 1)
    }

    const handleUpscale = (value) => {
        const newValue = Number(value);
        if (newValue === 6) {
            setUpScale(8);
        } else if (newValue >= 2) {
            setUpScale(newValue);
        } else if (newValue < 2) {
            setUpScale(0);
        }
        // Store the scale value in localStorage to persist across tab switches
        localStorage.setItem('uiScale', newValue.toString());
    }

    // Add useEffect to initialize scale from localStorage
    useEffect(() => {
        const savedScale = localStorage.getItem('uiScale');
        if (savedScale !== null) {
            handleUpscale(savedScale);
        }
    }, []);

    useEffect(() => {
        if (pix2pix || controlNet) {
            setUpScale(0);
            localStorage.setItem('uiScale', '0');
        }
    }, [controlNet, pix2pix])

    useEffect(() => {
        if (contextSubmitPrompt.length > 0) setSubmitPrompt(contextSubmitPrompt);
    });

    useEffect(() => {
        if (maskImage) {
            setPromptOutput("image-in-paint");
        }
        if (image && !maskImage) {
            setPromptOutput("image-image")
        }
    }, [maskImage, image])

    useEffect(() => {
        if (generateStatus.status === "error" && generateStatus.message === "Out of Credits") {
            Swal.fire({
                title: 'Insufficient Credits',
                html: `You are out of credits. Please top up or go offline to use local models.`,
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Top Up Now',
                cancelButtonText: 'Go Offline',
                confirmButtonColor: '#FFB02E',
                cancelButtonColor: '#6c757d'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open(`${process.env.REACT_APP_PROMPTUS_MAIN_WEBSITE_LIVE}/payments`, '_blank');
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    electronBridge.openPromptusCreditsStore?.();
                }
            });
        }
    }, [generateStatus])

    // useEffect(() => {
    //     if (selectedModel.toLowerCase().includes("xl")) {
    //         if (selectedModel.toLowerCase().includes("turbo")) {
    //             setImageWidth(512)
    //             setImageHeight(512)
    //             setSteps(2)
    //             setGuidance(0)
    //             setSelectedScheduler("LCM")
    //         } else {
    //             setImageWidth(1024)
    //             setImageHeight(1024)
    //             setGuidance(7.5)
    //             setSteps(20)
    //             setSelectedScheduler("DPM-Solver")
    //         }
    //     } else if (selectedModel.toLowerCase().includes("cascade")) {
    //         setImageHeight(1024)
    //         setImageWidth(1024)
    //     } 
    //     else {
    //         setImageWidth(512)
    //         setImageHeight(512)
    //         setGuidance(7.5)
    //         setSteps(12)
    //         setSelectedScheduler("DPM-Solver")
    //     }
    // },[selectedModel])

    useEffect(() => {
        if (controlNet !== "") {
            setImageNets("");
        }
        setControlnetDisplay(controlNet)
        if (controlNet === 'mlsd') {
            setControlnetDisplay("Straight Lines")
        }

        if (controlNet === 'pose-to-image') {
            setControlnetDisplay("Pose to Image")
        }
    }, [controlNet])

    useEffect(() => {
        if (promptOutput !== "text-image") {
            setImageNets(promptOutput);
        }

        if (promptOutput === 'image-in-paint') {
            setImageNets("In-Paint Image")
            setSelectedModel("stable-diffusion-inpainting")
        }

        if (promptOutput === 'image-image') {
            setImageNets("Image to Image")
            if (promptusAPIState.online) {
                setSelectedModel("(AI-Horde) Stable Cascade 1.0")
            }
        }
    }, [promptOutput])


    useEffect(() => {
        (async () => {
            const settings = await db.settings.toArray();
            setSettings(settings);
        })();
        if (generateStatus.status === "loading" && submitPrompt.length === 0) {
            (async () => {
                const prompts = await db.collection.where('uid').equals(generateStatus.uid).toArray();
                if (prompts.length > 0 && prompts[0] && prompts[0].prompt) {
                    setWholePrompt(prompts[0].prompt, false, true);
                } else {
                    console.warn("No prompts found for generateStatus.uid:", generateStatus.uid);
                }
            })();
        }
    }, []);

    const setWholePrompt = async (prompt, history, includeImages = false) => {
        console.log("setWholePrompt", prompt);

        // Add validation for undefined/null prompt
        if (!prompt) {
            console.error("setWholePrompt called with undefined/null prompt");
            return;
        }

        let imageDetails;
        let notFound = true;
        if (history) {
            setSubmitPrompt(prompt)
        } else {
            // Add validation for nested prompt structure
            if (!prompt.prompt) {
                console.error("Invalid prompt structure - missing prompt.prompt");
                return;
            }

            if (typeof (prompt.prompt.prompt) === "string") {
                imageDetails = prompt.prompt;
            } else if (typeof (prompt.prompt.prompt) === "object") {
                imageDetails = prompt.prompt.prompt;
            } else {
                console.error("Invalid prompt structure - prompt.prompt.prompt is neither string nor object");
                return;
            }

            // Validate imageDetails before using it
            if (!imageDetails || !imageDetails.prompt) {
                console.error("Invalid imageDetails structure");
                return;
            }

            setSubmitPrompt(imageDetails.prompt);

            // Set negative keywords if available
            if (imageDetails.negative_prompt !== undefined) {
                setNegativeKeywords(imageDetails.negative_prompt);
            }

            // Validate params object exists before accessing its properties
            if (imageDetails.params) {
                if (imageDetails.params.lora !== undefined) setSelectedLora(imageDetails.params.lora);
                if (imageDetails.params.scheduler !== undefined) setSelectedScheduler(imageDetails.params.scheduler);
                if (imageDetails.params.num_inference_steps !== undefined) setSteps(imageDetails.params.num_inference_steps);
                if (imageDetails.params.guidance_scale !== undefined) setGuidance(imageDetails.params.guidance_scale);
                if (imageDetails.params.count !== undefined) setImageCount(imageDetails.params.count);
                if (imageDetails.params.width !== undefined) setImageWidth(imageDetails.params.width);
                if (imageDetails.params.height !== undefined) setImageHeight(imageDetails.params.height);
            } else {
                console.warn("imageDetails.params is undefined, skipping parameter updates");
            }
            // Check model if params exists
            if (imageDetails.params && imageDetails.params.model) {
                await fetchUnifiedModels()
                    .then(() => {
                        const matchedModel = findModelInOptions(options, imageDetails.params.model);
                        if (matchedModel) {
                            setSelectedModel(matchedModel.value);
                            notFound = false;
                        }
                    })
            }
            if (notFound) {
                Swal.fire({
                    title: "Model not found",
                    text: "The model you are trying to use is not available. Please select another model.",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    setSettingsOpen(true);
                    setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online, effectiveDefaultModels));
                });
            }
            // Validate params object exists before accessing tile and shuffle properties
            if (imageDetails.params) {
                const tileValue = imageDetails.params.tile;
                if (typeof tileValue === 'number') {
                    setTile(false);
                } else if (tileValue == "0" || (tileValue && tileValue.toLowerCase && tileValue.toLowerCase() == "false") || tileValue == false || tileValue == "" || tileValue == "n/p") {
                    setTile(false);
                } else {
                    setTile(true);
                }

                const shuffleValue = imageDetails.params.shuffle;
                if (typeof shuffleValue === 'number') {
                    setShuffle(false);
                } else if (shuffleValue == "0" || (shuffleValue && shuffleValue.toLowerCase && shuffleValue.toLowerCase() == "false") || shuffleValue == false || shuffleValue == "" || shuffleValue == "n/p") {
                    setShuffle(false);
                } else {
                    setShuffle(true);
                }
                // setUpScale(imageDetails.params.upscale);
                if (imageDetails.params.input_image && includeImages) {
                    setImage(imageDetails.params.input_image);
                    setControlNet(imageDetails.params.control_net);
                }
                if (imageDetails.params.mask_image) {
                    // setMaskImage(imageDetails.params.mask_image); // Nice to have when functional
                }
            } else {
                console.warn("imageDetails.params is undefined, skipping tile/shuffle/image updates");
            }
        }
    };

    const setSeedPrompt = (prompt, seed) => {
        setSubmitPrompt(prompt);
        setSeed(seed);
    }

    const loadPromptFile = async (fileData) => {
        console.log('[loadPromptFile] Loading .prompt file data:', fileData);

        try {
            const promptContent = fileData.prompt?.prompt || fileData.prompt;
            if (!promptContent) {
                console.error('[loadPromptFile] Invalid .prompt file structure - missing prompt data');
                Swal.fire({
                    title: 'Invalid File',
                    text: 'The .prompt file does not contain valid prompt data.',
                    icon: 'error',
                    confirmButtonColor: '#FFB02E'
                });
                return;
            }

            const cosyflowName = promptContent.cosyflow || promptContent.model;
            if (!cosyflowName) {
                console.error('[loadPromptFile] No cosyflow/model found in .prompt file');
                Swal.fire({
                    title: 'Missing Model',
                    text: 'The .prompt file does not specify a model/cosyflow.',
                    icon: 'error',
                    confirmButtonColor: '#FFB02E'
                });
                return;
            }

            console.log('[loadPromptFile] Found cosyflow/model:', cosyflowName);

            const matchingCosyflow = await db.cosyflows.where('data.title').equals(cosyflowName).first();

            if (!matchingCosyflow) {
                console.warn('[loadPromptFile] Cosyflow not found in database:', cosyflowName);
                Swal.fire({
                    title: 'Model Not Found',
                    text: `The model "${cosyflowName}" is not available. Please ensure it's installed or select a different model.`,
                    icon: 'warning',
                    confirmButtonColor: '#FFB02E'
                });
                return;
            }

            console.log('[loadPromptFile] Found matching cosyflow in DB:', matchingCosyflow);

            if (promptContent.prompt) {
                setSubmitPrompt(promptContent.prompt);
            }

            setSettingsOpen(true);
            setSelectedModel(cosyflowName);

            const cosyflowVariables = matchingCosyflow.data?.variables || {};
            const newDynamicInputs = {};

            for (const [schemaKey, schemaConfig] of Object.entries(cosyflowVariables)) {
                const cleanKey = schemaKey.replace('params.', '');

                let valueFromFile = promptContent[cleanKey] ?? promptContent[schemaKey];

                if (valueFromFile === undefined && promptContent.params) {
                    valueFromFile = promptContent.params[cleanKey];
                }

                if (valueFromFile !== undefined) {
                    console.log(`[loadPromptFile] Mapping field ${schemaKey}: ${valueFromFile}`);
                    newDynamicInputs[schemaKey] = valueFromFile;
                } else if (schemaConfig.default !== undefined) {
                    newDynamicInputs[schemaKey] = schemaConfig.default;
                }
            }

            console.log('[loadPromptFile] Setting dynamic inputs:', newDynamicInputs);
            setDynamic_Inputs(prev => ({
                ...prev,
                ...newDynamicInputs
            }));

            const applyValuesToForm = () => {
                if (inputGroupRef.current && inputGroupRef.current.setValue) {
                    for (const [key, value] of Object.entries(newDynamicInputs)) {
                        console.log(`[loadPromptFile] Setting form field ${key}:`, value);
                        inputGroupRef.current.setValue(key, value);
                    }
                    console.log('[loadPromptFile] All form values applied');
                } else {
                    console.warn('[loadPromptFile] inputGroupRef not ready, retrying...');
                    setTimeout(applyValuesToForm, 300);
                }
            };

            setTimeout(applyValuesToForm, 800);

            Swal.fire({
                title: 'Prompt Loaded',
                text: `Successfully loaded prompt for "${cosyflowName}"`,
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('[loadPromptFile] Error loading prompt file:', error);
            Swal.fire({
                title: 'Error Loading Prompt',
                text: 'Failed to load the .prompt file. Please check the file format.',
                icon: 'error',
                confirmButtonColor: '#FFB02E'
            });
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const items = e.dataTransfer.items;
        if (items && items.length > 0) {
            const item = items[0];
            if (item.kind === 'file') {
                setIsDraggingPromptFile(true);
            }
        }
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDraggingPromptFile(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDraggingPromptFile(false);

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            const fileName = file.name.toLowerCase();

            if (fileName.endsWith('.prompt')) {
                console.log('[handleDrop] .prompt file detected:', file.name);

                const reader = new FileReader();
                reader.onload = (event) => {
                    try {
                        const fileData = JSON.parse(event.target.result);
                        console.log('[handleDrop] Parsed .prompt file:', fileData);
                        loadPromptFile(fileData);
                    } catch (error) {
                        console.error('[handleDrop] Error parsing .prompt file:', error);
                        Swal.fire({
                            title: 'Invalid File',
                            text: 'The file could not be parsed as a valid .prompt file.',
                            icon: 'error',
                            confirmButtonColor: '#FFB02E'
                        });
                    }
                };
                reader.onerror = () => {
                    console.error('[handleDrop] Error reading file');
                    Swal.fire({
                        title: 'Read Error',
                        text: 'Failed to read the file.',
                        icon: 'error',
                        confirmButtonColor: '#FFB02E'
                    });
                };
                reader.readAsText(file);
            } else {
                console.log('[handleDrop] Non-.prompt file dropped:', file.name);
            }
        }
    };

    const handleAdvancedSettings = async () => {
        setSettingsOpen(!settingsOpen)

        if (!cosyUI) {
            fetchUnifiedModels()
        }

        if (promptusAPIState.host == apiLocalCosy) {
            setCosyUI(true)
        }

        // Check if models are still loading
        if (modelsLoading) {
            console.log('[handleAdvancedSettings] Models are still loading, please wait...');
            return;
        }

        // If opening advanced settings and we have a selected model, ensure its data is loaded
        if (!settingsOpen && selectedModel) {
            console.log('[handleAdvancedSettings] Opening settings with model:', selectedModel);
            console.log('[handleAdvancedSettings] Last loaded model data:', loadedModelData);
            console.log('[handleAdvancedSettings] Current dynamic_inputs:', dynamic_inputs);
            console.log('[handleAdvancedSettings] Models loading status:', modelsLoading);
            console.log('[handleAdvancedSettings] Options count:', options.length);

            // Debug: Check what's in IndexedDB
            try {
                const cosyflowCount = await db.cosyflows.count();
                console.log('[handleAdvancedSettings] Total cosyflows in IndexedDB:', cosyflowCount);

                const allCosyflows = await db.cosyflows.toArray();
                console.log('[handleAdvancedSettings] Cosyflow titles in IndexedDB:');
                allCosyflows.forEach((record, index) => {
                    if (record.data && record.data.title) {
                        console.log(`  ${index}: "${record.data.title}"`);
                    }
                });
            } catch (e) {
                console.error('[handleAdvancedSettings] Error checking IndexedDB:', e);
            }

            // Check if dynamic_inputs still has default values (indicating data hasn't been loaded)
            const hasDefaultValues =
                dynamic_inputs.imageWidth === default_values.imageWidth &&
                dynamic_inputs.imageHeight === default_values.imageHeight &&
                dynamic_inputs.steps === default_values.steps &&
                dynamic_inputs.guidance === default_values.guidance;

            // Check if we need to load data for this model
            if (loadedModelData !== selectedModel || hasDefaultValues) {
                console.log('[handleAdvancedSettings] Model data not loaded or has default values - loading now');
                console.log('[handleAdvancedSettings] loadedModelData:', loadedModelData, 'hasDefaultValues:', hasDefaultValues);
                await handleRecommendedSettings(selectedModel);
            } else {
                console.log('[handleAdvancedSettings] Model data already loaded with non-default values');
            }
        }

        if (settingsOpen === false) {
            driverContextDispatch({ type: 'advanced' });
        }
        if (settingsOpen === true) {
            driverContextDispatch({ type: 'reset' });
        }
    }

    useEffect(() => {
        let { uid } = generateStatus;

        if (props.uid && !uid) {
            uid = props.uid;
        }
        if (uid) {
            (async () => {
                const promptDetails = await db.collection.where("uid").equals(uid).first();
                console.log("Prompt Details From Prompt Click:", promptDetails);
                if (promptDetails && promptDetails.prompt) {
                    if (promptDetails.prompt.prompt && promptDetails.prompt.prompt.prompt) {
                        setSubmitPrompt(promptDetails.prompt.prompt.prompt);
                    }
                    setWholePrompt(promptDetails.prompt, false);
                } else {
                    console.warn("No prompt details found for uid:", uid);
                }
            })();
        }
    }, [props.uid, generateStatus.uid])

    const toFileUrl = (filePath) => {
        return filePath;
    }

    useEffect(() => {
        if (props.prompt && props.prompt !== "") {
            db.images.where("hash").equals(props.prompt).first(imageDetails => {
                console.log("Image Details From Prompt Click:", imageDetails);
                if (imageDetails) {
                    setSubmitPrompt(imageDetails.prompt);
                    setSelectedModel(imageDetails.model || "");

                    if (imageDetails.image) {
                        (async () => await Image.load(imageDetails.image && imageDetails.image.includes(":\\") ? toFileUrl(imageDetails.image) : `data:image/png;base64,${imageDetails.image}`).then((image) => {
                            setImageWidth(Number(image.width));
                            setImageHeight(Number(image.height));
                        }).catch(err => console.error("Error loading image:", err)))();
                    }
                }
            });
        }
    }, [props.prompt])

    useEffect(() => {
        if (props.seed) {
            setSeed(props.seed);
        }
    }, [props.seed]);

    // Handle collection image (keeping this for backward compatibility with collection context)
    useEffect(() => {
        if (collectionContext.collectionImage) {
            console.log("Setting image from collectionContext:", collectionContext.collectionImage);

            // Extract the image data
            let imageData = null;
            if (typeof collectionContext.collectionImage === 'string') {
                imageData = collectionContext.collectionImage;
            } else if (collectionContext.collectionImage.image && typeof collectionContext.collectionImage.image === 'string') {
                imageData = collectionContext.collectionImage.image;
            } else {
                console.log("Unknown collectionImage format:", collectionContext.collectionImage);
            }

            if (imageData) {
                // Set to old state for backward compatibility
                setImage(imageData);

                // Use a small delay to ensure form is ready
                setTimeout(() => {
                    // Also integrate with dynamic inputs system
                    const currentSchema = promptMappings;
                    let imageFieldKey = null;
                    
                    // Look for fields that accept images in the schema
                    for (const [key, field] of Object.entries(currentSchema || {})) {
                        if (field.type === 'file' || field.type === 'b64' || 
                            field.type === 'b64data' || field.type === 'image' || 
                            field.type === 'IMAGE' ||
                            (field.accept && field.accept.includes('image'))) {
                            imageFieldKey = key;
                            console.log(`[IMAGE INTEGRATION] Found image field in schema: ${key}`);
                            break;
                        }
                    }
                    
                    if (imageFieldKey) {
                        // Set the image data to the dynamic inputs
                        setUploadedB64Data(prev => ({
                            ...prev,
                            [imageFieldKey]: imageData
                        }));
                        
                        // Update the form if it's available
                        if (inputGroupRef.current && inputGroupRef.current.setValue) {
                            inputGroupRef.current.setValue(imageFieldKey, imageData);
                            console.log(`[IMAGE INTEGRATION] Set collection image to dynamic field: ${imageFieldKey}`);
                        }
                        
                        // Open settings to show the image was loaded
                        setSettingsOpen(true);
                    } else {
                        console.log('[IMAGE INTEGRATION] No image field found in current schema, keeping in old system');
                    }
                }, 100);
            }
        }
    }, [collectionContext.collectionImage, promptMappings]);

    // useEffect(() => {
    //     if (inputTag !== "") {
    //         setTag("")
    //     }

    //     if (tag !== "") {
    //         setInputTag("")
    //     }
    // },[tag, inputTag])

    // THIS ARRAY IS FOR THE SORTING OF THE MODEL LIST WHICH DETERMINES THE ORDER OF THE MODEL BEING DISPLAYED ACCORDING TO THIS ARRAY FROM TOP TO BOTTOM
    // SO IF ANYTHING IS ADDED OR REMOVED KEEP IN MIND THE ORDER OF THE ARRAY VALUES IS THE ORDER OF THE MODEL LIST
    const sortingRules = [
        {
            name: "No Prefix",
            match: (item) => !item.startsWith('('), // No (cosy) or (AI-Horde)
        },
        {
            name: "Stable Diffusion",
            match: (item) => item.toLowerCase().includes('stable_diffusion'),
        },
        {
            name: "Contains 'stable cascade'",
            match: (item) => item.toLowerCase().includes('stable cascade'),
        },
        {
            name: "Contains 'flux'",
            match: (item) => item.toLowerCase().includes('flux'),
        },
        {
            name: "Default",
            match: (item) => true, // Anything else
        }
    ];

    // THIS SORT FUNCTION USES THE ABOVE ARRAY TO SORT THE MODELS IN ITS ORDER
    function customSort(arr) {
        const grouped = sortingRules.map(() => []); // one array per rule

        arr.forEach((item) => {
            for (let i = 0; i < sortingRules.length; i++) {
                if (sortingRules[i].match(item)) {
                    grouped[i].push(item);
                    break;
                }
            }
        });

        // Flatten groups
        return grouped.flat();
    }

    /**
     * Validates models for disallowed data types using IndexedDB (optimized - no API calls)
     * @param {Array} models - Array of model names to validate
     * @param {Object} promptusAPIState - API state for online/offline checking
     * @returns {Object} { validModels: Array, invalidModels: Array, cached: boolean }
     */
    const validateModelsForDisallowedTypes = async (models, promptusAPIState) => {
        // Skip validation if offline
        if (!promptusAPIState.online) {
            return { validModels: models, invalidModels: [], cached: false };
        }

        const startTime = performance.now();
        console.log(`[MODEL VALIDATION - OPTIMIZED] Starting IndexedDB validation for ${models.length} models`);

        const ALLOWED_TYPES = [
            'FLOAT', 'INT', 'BOOLEAN', 'number', 'boolean',
            'BOOL', 'bool', 'seed', 'STRING', 'prompt',
            'text', 'enum', 'COMBO', 'b64data', 'IMAGE', 'model', 'url', 'URL'
        ];

        // Check cache first
        const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours
        const now = Date.now();

        try {
            // Get cached validation results
            const cachedResults = await db.settings.get({ key: 'model_validation_cache' });
            if (cachedResults && cachedResults.value) {
                const cache = JSON.parse(cachedResults.value);
                if (cache.timestamp && (now - cache.timestamp) < CACHE_DURATION) {
                    // Check if model list has changed
                    const cachedModelSet = new Set(cache.validModels || []);
                    const currentModelSet = new Set(models);

                    // Check for any differences in model lists
                    const hasChanges = models.length !== (cache.validModels?.length || 0) ||
                        models.some(m => !cachedModelSet.has(m)) ||
                        (cache.validModels?.some(m => !currentModelSet.has(m)) || false);

                    if (hasChanges) {
                        console.log('[MODEL VALIDATION - OPTIMIZED] Model list changed, invalidating cache');
                        console.log('[MODEL VALIDATION - OPTIMIZED] Current models:', models.length, 'Cached models:', cache.validModels?.length || 0);
                        // Continue with fresh validation - don't return here
                    } else {
                        console.log('[MODEL VALIDATION - OPTIMIZED] Using cached validation results. Cached Invalid Models:', cache.invalidModels);
                        return {
                            validModels: cache.validModels || [],
                            invalidModels: cache.invalidModels || [],
                            cached: true
                        };
                    }
                }
            }
        } catch (error) {
            console.warn('[MODEL VALIDATION - OPTIMIZED] Error reading cache:', error);
        }

        // Perform validation using IndexedDB (no API calls)
        const validModels = [];
        const invalidModels = [];

        for (const model of models) {
            try {
                // Direct IndexedDB lookup - O(log n) performance
                const modelData = await db.cosyflows.where('data.title').equals(model).first();

                if (modelData?.data?.variables) {
                    let isValid = true;

                    // Check for disallowed types using same logic as before
                    for (const [key, variable] of Object.entries(modelData.data.variables)) {
                        if (variable.type && !ALLOWED_TYPES.includes(variable.type)) {
                            console.log(`[MODEL VALIDATION - OPTIMIZED] Model "${model}" has disallowed type: ${variable.type} in variable "${key}"`);
                            invalidModels.push({ model, reason: `Disallowed type: ${variable.type}` });
                            isValid = false;
                            break;
                        }
                    }

                    if (isValid) {
                        validModels.push(model);
                    }
                } else {
                    // No workflow data found in IndexedDB, assume valid (fallback behavior)
                    validModels.push(model);
                }
            } catch (error) {
                console.warn(`[MODEL VALIDATION - OPTIMIZED] Error checking model ${model}:`, error);
                validModels.push(model); // Assume valid on error
            }
        }

        const endTime = performance.now();

        console.log(`[MODEL VALIDATION - OPTIMIZED] Completed in ${(endTime - startTime).toFixed(2)}ms`);
        console.log(`[MODEL VALIDATION - OPTIMIZED] Valid: ${validModels.length}, Invalid: ${invalidModels.length}`);

        if (invalidModels.length > 0) {
            console.log('[MODEL VALIDATION - OPTIMIZED] Invalid models:', invalidModels);
        }

        // Cache the results
        try {
            const cacheData = {
                timestamp: now,
                validModels: validModels,
                invalidModels: invalidModels.map(item => item.model)
            };
            await db.settings.put({
                key: 'model_validation_cache',
                value: JSON.stringify(cacheData)
            });
            console.log('[MODEL VALIDATION - OPTIMIZED] Results cached successfully');
        } catch (error) {
            console.warn('[MODEL VALIDATION - OPTIMIZED] Error caching results:', error);
        }

        return { validModels: validModels, invalidModels, cached: false };
    };

    const fetchModels = async (serverStatusOverride) => {
        console.log("IUBBIUOBYIUVITRUIRTICCRITICTRCRUI:  ", cosyUI);
        setModelsLoading(true);

        // Check if we're in offline mode
        if (!promptusAPIState.online) {
            try {
                const activeServers = serverStatusOverride || generateStatus.serverStatus || {};
                console.log("[fetchModels_OFFLINE] Fetching unified offline models from all servers");
                console.log("[fetchModels_OFFLINE] Current detected servers:", activeServers);

                // Get unified models from all cached servers (GPU, CPU, Cosy), filtered by active servers
                const unifiedModels = await getUnifiedOfflineModels({
                    activeServers: activeServers
                });
                const models = unifiedModels.map(model => model.value); // Extract model names

                console.log("[fetchModels_OFFLINE] Retrieved offline models data:", { models }); // Add this log for consistency

                // Continue with same processing logic as online mode
                await processModels(models);
            } catch (error) {
                console.error("[fetchModels_OFFLINE] Error getting offline models:", error);
                promptusAPIDispatch({ type: 'setModels', models: [] });
                setModelsLoading(false);
                return;
            }
        } else {
            // Online mode - use existing API call
            // Skip if host is not set OR if host is still a localhost URL (waiting for API host update)
            if (!promptusAPIState.host ||
                promptusAPIState.host.includes('localhost') ||
                promptusAPIState.host.includes('127.0.0.1')) {
                console.log("[fetchModels_ONLINE] Host not yet set or still localhost, skipping fetch");
                setModelsLoading(false);
                return;
            }
            console.log("[fetchModels_ONLINE] Retrieved online models"); // Add this log
            await getModels(promptusAPIState, generateStatusDispatch)
                .then(async data => {
                    console.log("[fetchModels_ONLINE] Retrieved models data:", data); // Add this log

                    let models = data.models;
                    await processModels(models);
                })
                .catch(error => {
                    console.error("Error in getModels:", error); // Add this log to catch errors
                    promptusAPIDispatch({ type: 'setModels', models: [] });
                    // No need to set modelInvalidCheck here since validation wasn't started
                    setModelsLoading(false);
                });
        }
    }

    const createGroupedOptions = (models, filterMode = 'all') => {
        const online = models.filter(m => !m.isLocal);
        const localGpu = models.filter(m => m.isLocal && m.serverType === 'gpu');
        const localCpu = models.filter(m => m.isLocal && m.serverType === 'cpu');
        const localCosy = models.filter(m => m.isLocal && m.serverType === 'cosy');

        const groups = [];

        if (filterMode === 'all' || filterMode === 'online') {
            if (online.length > 0) {
                groups.push({
                    label: 'Online Models',
                    options: online
                });
            }
        }

        if (filterMode === 'all' || filterMode === 'offline') {
            if (localGpu.length > 0) {
                groups.push({
                    label: 'Local Models (GPU)',
                    options: localGpu
                });
            }

            if (localCpu.length > 0) {
                groups.push({
                    label: 'Local Models (CPU)',
                    options: localCpu
                });
            }

            if (localCosy.length > 0) {
                groups.push({
                    label: 'Local Models (Cosy)',
                    options: localCosy
                });
            }
        }

        return groups;
    };

    const filteredOptions = useMemo(() => {
        if (!allModels || allModels.length === 0) return options;
        let models = allModels;
        if (activeMediaType && activeMediaType !== 'all') {
            models = allModels.filter(m => m.mediaType === activeMediaType);
        }
        const filterMode = showOnlineModels ? 'online' : 'offline';
        return createGroupedOptions(models, filterMode);
    }, [allModels, showOnlineModels, activeMediaType]);

    const fetchUnifiedModels = async () => {
        console.log("[UNIFIED] Fetching unified model list (online + offline)");
        setModelsLoading(true);

        try {
            const apiHost = await getApiBaseUrl();
            let onlineModels = [];
            let offlineModels = [];

            // 1. Fetch online models
            try {
                const stateHost = promptusAPIState.host;
                const isApiHostValid = apiHost && !apiHost.includes('localhost') && !apiHost.includes('127.0.0.1');
                const isStateHostReady = stateHost && (stateHost.includes('api.promptus.ai') || stateHost.includes('api.dev.promptus.ai'));

                if (isApiHostValid && isStateHostReady) {
                    console.log("[UNIFIED] Fetching online models from:", apiHost);
                    const data = await getModels(promptusAPIState, generateStatusDispatch);
                    if (data?.models && Array.isArray(data.models)) {
                        onlineModels = data.models.map(model => ({
                            value: model,
                            label: model,
                            originalValue: model,
                            isLocal: false,
                            serverType: null,
                            serverUrl: apiHost,
                            source: 'online'
                        }));
                        console.log(`[UNIFIED] Retrieved ${onlineModels.length} online models`);
                    }
                } else {
                    console.log("[UNIFIED] Skipping online model fetch - host not ready. apiHost:", apiHost, "stateHost:", stateHost);
                }
            } catch (error) {
                console.warn('[UNIFIED] Failed to fetch online models:', error);
            }

            // 2. Fetch offline models from detected servers
            try {
                const activeServers = generateStatus.serverStatus || {};
                console.log("[UNIFIED] Fetching offline models, active servers:", activeServers);
                const unifiedOffline = await getUnifiedOfflineModels({ activeServers });
                offlineModels = unifiedOffline.map(model => ({
                    ...model,
                    value: `${model.value}__local_${model.serverType}`,
                    originalValue: model.value,
                    isLocal: true,
                    source: 'local'
                }));
                console.log(`[UNIFIED] Retrieved ${offlineModels.length} offline models`);
            } catch (error) {
                console.warn('[UNIFIED] Failed to fetch offline models:', error);
            }

            // 3. Combine all models - keep online and offline separate (no deduplication)
            // This allows users to choose between online vs local version of the same model
            const allUnifiedModels = [...onlineModels, ...offlineModels];
            console.log(`[UNIFIED] Total unified models: ${allUnifiedModels.length} (${onlineModels.length} online, ${offlineModels.length} offline)`);

            // Filter out CosyMultiUser models (internal/system models that shouldn't be shown)
            const filteredUnifiedModels = allUnifiedModels.filter(m => !m.value.includes('CosyMultiUser'));
            console.log(`[UNIFIED] After filtering CosyMultiUser: ${filteredUnifiedModels.length} models`);

            // 4. Sort within each group, but keep online/offline separate
            // Sort online models
            const filteredOnlineModels = filteredUnifiedModels.filter(m => !m.isLocal);
            const sortedOnlineNames = customSort(filteredOnlineModels.map(m => m.value));
            const sortedOnlineModels = sortedOnlineNames.map(name => filteredOnlineModels.find(m => m.value === name)).filter(Boolean);

            // Sort offline models
            const filteredOfflineModels = filteredUnifiedModels.filter(m => m.isLocal);
            const sortedOfflineNames = customSort(filteredOfflineModels.map(m => m.value));
            const sortedOfflineModels = sortedOfflineNames.map(name => filteredOfflineModels.find(m => m.value === name)).filter(Boolean);

            // Combine sorted lists
            const sortedUnifiedModels = [...sortedOnlineModels, ...sortedOfflineModels];

            const mediaTypeMap = await preloadCosyflowData();
            setModelMediaTypeMap(mediaTypeMap);
            console.log(`[UNIFIED] Loaded ${mediaTypeMap.size} model media type mappings`);

            const modelsWithMediaType = sortedUnifiedModels.map(m => ({
                ...m,
                mediaType: mediaTypeMap.get(m.originalValue || m.value) || 'image'
            }));

            setAllModels(modelsWithMediaType);

            const groupedOptions = createGroupedOptions(modelsWithMediaType);
            console.log('[UNIFIED] Grouped options created:', groupedOptions.map(g => ({ label: g.label, count: g.options?.length })));
            setOptions(groupedOptions);

            promptusAPIDispatch({ type: 'setModels', models: modelsWithMediaType.map(m => m.value) });
            setModelsLoading(false);

        } catch (error) {
            console.error('[UNIFIED] Error in fetchUnifiedModels:', error);
            setModelsLoading(false);
        }
    };

    // Extract shared model processing logic
    const processModels = async (models) => {
        let filters = [];

        let setting = await db.settings.get({ key: 'use_aihorde_models' });
        console.log("use_aihorde_models setting:", setting);
        // if (setting) filters.push("Dall-e");

        setting = await db.settings.get({ key: 'use_openai_models' });
        console.log("use_openai_models setting:", setting);
        //if (setting) filters.push("(SH)");

        console.log("Filters array:", filters);
        console.log("Models pre filter", models);

        if (filters.length > 0) {
            try {
                models = models.filter(model => {
                    console.log("Filtering model:", model); // Log each model being filtered
                    const includesFilter = filters.some(filter => model.includes(filter));
                    console.log(`Model includes filter (${includesFilter}):`, model);
                    return !includesFilter;
                });
            } catch (error) {
                console.error("Error during filtering:", error); // Capture any errors during filtering
            }
        }

        console.log("Models post filter", models);

        // IMMEDIATELY show all models and set loading to false - don't wait for validation
        const sortedModels = customSort(models);
        setAllModels(sortedModels); // Store complete model list for filtering
        setOptions(sortedModels.map(model => ({ value: model, label: model })));
        promptusAPIDispatch({type: 'setModels', models: models});
        setModelsLoading(false);

        // Load costs for models in background (non-blocking)
        buildOptionsWithCost(sortedModels).then(optionsWithCost => {
            setOptions(optionsWithCost);
            console.log('[TARIFF] Updated options with cost data: ', optionsWithCost);
        }).catch(error => {
            console.warn('[TARIFF] Failed to load costs for models:', error);
        });

        // Preload cosyflow data for optimized filtering (non-blocking)
        preloadCosyflowData().then(cache => {
            setModelMediaTypeMap(cache);
            console.log(`[CACHE] Successfully loaded ${cache.size} model mappings for optimized filtering`);
        }).catch(error => {
            console.error('[CACHE] Failed to preload cosyflow data:', error);
        });

        if (testCheck) {
            // Try weighted selection from default models first (using dynamic models from IndexedDB or fallback)
            const availableDefaultsWeighted = effectiveDefaultModels.filter(item =>
                sortedModels.includes(item.name)
            );

            let selectedModel;
            if (availableDefaultsWeighted.length > 0) {
                selectedModel = selectWeightedRandom(availableDefaultsWeighted);
                console.log(`[RANDOM MODEL SELECT] Weighted selection from defaults: ${selectedModel}`);
                console.log(`[RANDOM MODEL SELECT] Available weighted options:`, availableDefaultsWeighted.map(i => `${i.name} (${i.weight})`));
            } else {
                // Fallback to equal probability from all models if no defaults available
                const idx = Math.floor(Math.random() * sortedModels.length);
                selectedModel = sortedModels[idx];
                console.log(`[RANDOM MODEL SELECT] Fallback random from all models: ${selectedModel}`);
            }

            setSelectedModel(selectedModel);
            // Removed direct handleRecommendedSettings call - useEffect will handle it
            setTestCheck(false)
        }

        // Check if validation is enabled via settings
        const validationEnabled = await db.settings.get({ key: 'model_validation_enabled' });
        const shouldValidate = validationEnabled ? validationEnabled.value !== false : true; // Default to true

        // Run optimized validation in background (non-blocking) - only if online
        if (shouldValidate && promptusAPIState.online) {
            // Create abort controller for this validation session
            validationAbortController.current = new AbortController();

            // Run validation in background without blocking UI
            (async () => {
                try {
                    console.log('[FETCH MODELS] Starting optimized validation in background');
                    const validationResult = await validateModelsForDisallowedTypes(models, promptusAPIState);

                    // Only update UI if validation found invalid models and wasn't aborted
                    if (!validationAbortController.current?.signal.aborted && validationResult.invalidModels.length > 0) {
                        console.log(`[FETCH MODELS] Validation completed - filtering out ${validationResult.invalidModels.length} invalid models`);
                        const sortedValidModels = customSort(validationResult.validModels);
                        setAllModels(sortedValidModels); // Store complete validated model list for filtering
                        const optionsWithCost = await buildOptionsWithCost(sortedValidModels);
                        setOptions(optionsWithCost);
                        promptusAPIDispatch({type: 'setModels', models: validationResult.validModels});
                    } else if (validationResult.invalidModels.length === 0) {
                        console.log('[FETCH MODELS] Validation completed - all models are valid');
                    }
                } catch (error) {
                    if (error.name !== 'AbortError') {
                        console.error('[FETCH MODELS] Validation error:', error);
                    } else {
                        console.log('[FETCH MODELS] Validation aborted for mode switch');
                    }
                }
            })();
        }
    }

    useEffect(() => {
        console.log("[fetchModels_] UseEffect triggered for model check: ", promptusAPIState);
        (async () => {
            console.log("[fetchModels_] UseEffect triggered for outside if: ", promptusAPIState);
            await fetchUnifiedModels();
            promptusAPIDispatch({ type: 'setLoras', models: [] })
            if (promptusAPIState.host) {
                console.log("[fetchModels_] UseEffect triggered for inside if: ", promptusAPIState);

                // if (promptusAPIState.host === apiLocalCosy) {
                //     await fetchWorkflows();
                // } else {
                    // await getLoras(promptusAPIState, generateStatusDispatch)
                    // .then(data => {
                    //     promptusAPIDispatch({type: 'setLoras', loras: data.loras});
                    // })
                    // .catch(() => promptusAPIDispatch({type: 'setLoras', models: []}));
                // }
            }
        })();
        setOnlineState(promptusAPIState.online);
        // Initialize options with an empty array if no models are available
        if (!Array.isArray(promptusAPIState.models)) {
            setOptions([]);
        }
    }, [promptusAPIState.online, promptusAPIState.host]);

    // Monitor server status changes and refresh models automatically (unified models)
    useEffect(() => {
        const currentServers = generateStatus.serverStatus || {};
        const currentServerKeys = Object.keys(currentServers).sort();
        const currentServerValues = currentServerKeys.map(key => currentServers[key]).sort();
        const serverStatusString = JSON.stringify({ keys: currentServerKeys, values: currentServerValues });

        console.log('[SERVER_STATUS_MONITOR] Current server status:', currentServers);

        // Check if server status has actually changed (not just a re-render)
        if (previousServerStatusRef.current === null) {
            // First run - just store the current status
            previousServerStatusRef.current = serverStatusString;
            console.log('[SERVER_STATUS_MONITOR] Initial server status stored');
            return;
        }

        if (previousServerStatusRef.current !== serverStatusString) {
            console.log('[SERVER_STATUS_MONITOR] 🔄 Server status changed! Refreshing models...');
            console.log('[SERVER_STATUS_MONITOR] Previous:', previousServerStatusRef.current);
            console.log('[SERVER_STATUS_MONITOR] Current:', serverStatusString);

            // Update the reference
            previousServerStatusRef.current = serverStatusString;

            // Don't refresh during active generation to avoid interruption
            if (generateStatus.loading || generateStatus.status === 'generating') {
                console.log('[SERVER_STATUS_MONITOR] ⏸️ Generation in progress, deferring model refresh');
                return;
            }

            // Check if all servers are now off
            if (currentServerKeys.length === 0) {
                console.log('[SERVER_STATUS_MONITOR] ⚠️ All local servers are off');

                // Refresh models to remove local models from list (will show only online models)
                console.log('[SERVER_STATUS_MONITOR] Refreshing models to remove offline entries');
                fetchUnifiedModels();

                // Show notification
                if (!shouldBypass) {
                    Swal.fire({
                        title: 'Local Servers Offline',
                        text: 'All local servers are off. Only online models are available.',
                        icon: 'info',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                } else {
                    Swal.fire({
                        title: 'No Servers Available',
                        text: 'All local servers are off and no internet connection is available. Please start a local server.',
                        icon: 'warning',
                        confirmButtonColor: '#FFB02E'
                    });
                }
                return;
            }

            // Debounce rapid changes with a small delay
            const timeoutId = setTimeout(() => {
                console.log('[SERVER_STATUS_MONITOR] ✅ Triggering model refresh due to server status change');
                fetchUnifiedModels();
            }, 1000);

            // Cleanup timeout on component unmount or dependency change
            return () => clearTimeout(timeoutId);
        }
    }, [generateStatus.serverStatus, promptusAPIState.online, generateStatus.loading, generateStatus.status, shouldBypass]);

    useEffect(() => {
        if (
            (generateStatus.loading && settingsOpen) ||
            (generateStatus.status === 'done' && settingsOpen)
        ) {
            setSettingsOpen(false);
        }
        if (generateStatus.status === 'done') {
            setEnhancePrompt(false);
        }
        if (image && !generateStatus.loading && generateStatus.status === 'ready') {
            setSettingsOpen(true);
        }
    }, [generateStatus.loading, generateStatus.status, image]);

    // Sync options with promptusAPIState.models when they're available
    // DISABLED: Now using unified model approach in fetchUnifiedModels which sets grouped options directly
    // useEffect(() => {
    //     const syncModels = async () => {
    //         if (promptusAPIState.models && Array.isArray(promptusAPIState.models) && promptusAPIState.models.length > 0) {
    //             console.log('[Model Dropdown] Syncing options with API models');
    //             const sortedModels = customSort(promptusAPIState.models);
    //             setAllModels(sortedModels); // Store complete model list for filtering

    //             // Only update options if no media filter is active (activeMediaType === 'all')
    //             // This prevents overwriting filtered options when a media type filter is selected
    //             if (activeMediaType === 'all') {
    //                 const optionsWithCost = await buildOptionsWithCost(sortedModels);
    //                 setOptions(optionsWithCost);
    //             } else {
    //                 // Re-apply the current media filter to the new models
    //                 console.log(`[Model Dropdown] Media filter active (${activeMediaType}), re-applying filter`);
    //                 const filteredModels = await filterModelsByMediaTypeOptimized(sortedModels, activeMediaType, modelMediaTypeMap, setModelMediaTypeMap);
    //                 const sortedFilteredModels = customSort(filteredModels);
    //                 const optionsWithCost = await buildOptionsWithCost(sortedFilteredModels);
    //                 setOptions(optionsWithCost);
    //             }
    //             // If models are already available, set loading to false
    //             setModelsLoading(false);
    //         }
    //     };
    //     syncModels();
    // }, [promptusAPIState.models, activeMediaType, modelMediaTypeMap, buildOptionsWithCost]);

    // Ensure selectedModel is in options array
    useEffect(() => {
        // Check if selectedModel is valid (not empty string)
        if (selectedModel && selectedModel.trim() !== '') {
            if (options.length > 0) {
                const modelExists = modelExistsInOptions(options, selectedModel);
                if (!modelExists) {
                    // Model doesn't exist in current options list - clear selection
                    // This handles both online and offline mode switches
                    console.log('[Model Dropdown] Model not in list, clearing selection:', selectedModel);
                    setSelectedModel('');
                }
            } else {
                // Options is empty - wait for models to load, clear invalid selection
                console.log('[Model Dropdown] No models loaded yet - clearing selection to wait for load');
                setSelectedModel('');
            }
        } else if (!selectedModel || selectedModel === null || selectedModel.trim() === '') {
            // Only set default if we have options available
            if (options.length > 0) {
                console.log('[Model Dropdown] Setting to random default model');
                setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online, effectiveDefaultModels));
            } else {
                console.log('[Model Dropdown] No models loaded yet - waiting for model load');
            }
        }
    }, [selectedModel, options.length, promptusAPIState.online]); // Watch options.length instead of options to avoid infinite loop

    // Call handleRecommendedSettings when models finish loading
    // Commented out to prevent duplicate calls to handleRecommendedSettings
    // The useEffect watching selectedModel changes already handles this
    // useEffect(() => {
    //     if (!modelsLoading && selectedModel && options.length > 0) {
    //         console.log('[Models Loaded] Models finished loading, calling handleRecommendedSettings');
    //         console.log('[Models Loaded] selectedModel:', selectedModel);
    //         console.log('[Models Loaded] options count:', options.length);

    //         // Check if the selectedModel exists in options
    //         const modelExists = options.some(opt => opt.value === selectedModel);
    //         if (modelExists) {
    //             console.log('[Models Loaded] Model exists in options, loading recommended settings');
    //             handleRecommendedSettings(selectedModel);
    //         } else {
    //             console.log('[Models Loaded] Model not found in options, skipping settings load');
    //         }
    //     }
    // }, [modelsLoading]); // Only trigger when modelsLoading changes

    const handleClearParams = () => {
        setSubmitPrompt(defaultPrompt.prompt.prompt);
        setSeed(defaultPrompt.prompt.params.seed_value);
        setNegativeKeywords(defaultPrompt.prompt.negative_prompt);
        setSteps(defaultPrompt.prompt.params.num_inference_steps);
        setGuidance(defaultPrompt.prompt.params.guidance_scale);
        setImageCount(1);
        setImageWidth(defaultPrompt.prompt.params.width);
        setImageHeight(defaultPrompt.prompt.params.height);
        setSelectedModel(
            defaultPrompt.prompt.params.model && defaultPrompt.prompt.params.model.trim() !== ''
                ? defaultPrompt.prompt.params.model
                : getAvailableDefaultModel(options, promptusAPIState.online)
        );
        setSelectedScheduler(defaultPrompt.prompt.params.scheduler);
        setTile(defaultPrompt.prompt.params.tile);
        setShuffle(defaultPrompt.prompt.params.shuffle);
        setUpScale(defaultPrompt.prompt.params.upscale_factor)
        setImage(null);
        setControlNet("");
        setMaskImage(null);
        setInPaint(false);
        setPromptOutput("text-image");
        driverContextDispatch({ type: 'advanced' });
        setImageNets("");
    }

    const handleRestoreDefaults = async () => {
        if (!selectedModel) {
            Swal.fire({
                title: "No Model Selected",
                text: "Please select a model first to restore its default values.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#FFB02E"
            });
            return;
        }

        // Show loading indicator
        Swal.fire({
            title: "Restoring Defaults",
            text: "Fetching model default values...",
            icon: "info",
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Always fetch fresh data from API
            console.log("Fetching fresh default values from API for:", selectedModel);
            let cosyflow_variables = null;
            let cosyflow_data = null;

            const apiBase = await getApiBaseUrl();
            const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(selectedModel)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getAuthorizationToken()}`
                }
            });

            if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                const cosyflow = response.data.cosyflows[0];
                if (cosyflow.cosyflow) {
                    cosyflow_data = typeof cosyflow.cosyflow === 'string'
                        ? JSON.parse(cosyflow.cosyflow)
                        : cosyflow.cosyflow;
                    cosyflow_variables = cosyflow_data.variables;
                    console.log("Successfully fetched fresh cosyflow data from API");

                    // Update IndexedDB with fresh data
                    try {
                        // Use indexed lookup for O(log n) performance
                        const existingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();

                        if (existingCosyflow) {
                            // Update existing record
                            await db.cosyflows.update(existingCosyflow.id, {
                                data: cosyflow_data,
                                timestamp: Date.now()
                            });
                            console.log("Updated cosyflow in IndexedDB with fresh data");
                        } else {
                            // Add new record
                            await db.cosyflows.add({
                                data: cosyflow_data,
                                timestamp: Date.now()
                            });
                            console.log("Added new cosyflow to IndexedDB");
                        }
                    } catch (dbError) {
                        console.error("Error updating IndexedDB:", dbError);
                        // Continue even if DB update fails
                    }
                }
            }

            if (cosyflow_variables) {
                // Rebuild promptMappings from fresh cosyflow_variables to update form schema
                const new_prompt_mappings = {};
                for (const [key, variable] of Object.entries(cosyflow_variables)) {
                    new_prompt_mappings[key] = variable;
                }
                setPromptMappings(new_prompt_mappings);
                console.log("Updated promptMappings with fresh schema:", Object.keys(new_prompt_mappings));

                // Extract default values from cosyflow variables
                const restoredValues = {};

                for (const [key, variable] of Object.entries(cosyflow_variables)) {
                    if (variable.default !== undefined) {
                        // Handle seed_mode specifically to ensure it's 'random'
                        if (key === 'seed_mode' && variable.default === 'fixed') {
                            restoredValues[key] = 'random';
                        } else {
                            restoredValues[key] = variable.default;
                        }
                    }
                }

                // Update dynamic_inputs state for cosyUI models
                if (cosyUI) {
                    setDynamic_Inputs(prevState => ({
                        ...prevState,
                        ...restoredValues
                    }));
                } else {
                    // For non-cosy models, update individual state variables
                    if (restoredValues.steps !== undefined) setSteps(restoredValues.steps);
                    if (restoredValues.guidance !== undefined) setGuidance(restoredValues.guidance);
                    if (restoredValues.imageWidth !== undefined) setImageWidth(restoredValues.imageWidth);
                    if (restoredValues.imageHeight !== undefined) setImageHeight(restoredValues.imageHeight);
                    if (restoredValues.imageCount !== undefined) setImageCount(restoredValues.imageCount);
                    if (restoredValues.negativeKeywords !== undefined) setNegativeKeywords(restoredValues.negativeKeywords);
                    if (restoredValues.scheduler !== undefined) setSelectedScheduler(restoredValues.scheduler);

                    // Handle seed based on seed_mode
                    if (restoredValues.seed_mode === 'random' || restoredValues.seed_mode === undefined) {
                        setSeed("");
                    } else if (restoredValues.seed !== undefined) {
                        setSeed(restoredValues.seed);
                    }
                }

                // Success message
                Swal.fire({
                    title: "Defaults Restored",
                    text: `Default values for ${selectedModel} have been restored successfully.`,
                    icon: "success",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#FFB02E",
                    timer: 2000,
                    timerProgressBar: true
                });

                console.log("Restored default values:", restoredValues);
            } else {
                throw new Error("No default values found for this model");
            }
        } catch (error) {
            console.error("Error restoring defaults:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to restore default values. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "#FFB02E"
            });
        }
    }

    const setRevealPrompt = (prompt) => {
        console.log("setRevealPrompt", prompt);
        let notFound = true;
        let includeImages = false;

        if (prompt.prompt) {
            setSubmitPrompt(prompt.prompt);
        }
        setSeed(prompt.seed);
        setNegativeKeywords(prompt.negative_prompt);
        setSelectedLora(prompt.lora);
        setSelectedScheduler(prompt.scheduler);
        setSteps(prompt.num_inference_steps);
        setGuidance(prompt.guidance_scale);
        setImageCount(1);
        let dimensions = prompt.image_size.split("x");
        setImageWidth(dimensions[0]);
        setImageHeight(dimensions[1]);
        setSelectedModel(prompt.model);
        // promptusAPIState.models.map(model => {
        //     if (prompt.model == model) {
        //         setSelectedModel(model);
        //         notFound = false;
        //     }
        // })
        // if (notFound) {
        //     Swal.fire({
        //         title: "Model not found",
        //         text: "The model you are trying to use is not available. Please select another model.",
        //         icon: "error",
        //         timer: 1500,
        //         showConfirmButton: false
        //     }).then(() => {
        //         setSettingsOpen(true);
        //         setSelectedModel("stable-diffusion-v1-5");
        //     });
        // }

        const tileValue = prompt.params.tile;
        if (typeof tileValue === 'number') {
            setTile(false);
        } else if (tileValue == "0" || tileValue.toLowercase() == "false" || tileValue == false || tileValue == "" || tileValue == "n/p") {
            setTile(false);
        } else {
            setTile(true);
        }

        const shuffleValue = prompt.params.shuffle;
        if (typeof shuffleValue === 'number') {
            setShuffle(false);
        } else if (shuffleValue == "0" || shuffleValue.toLowercase() == "false" || shuffleValue == false || shuffleValue == "" || shuffleValue == "n/p") {
            setShuffle(false);
        } else {
            setShuffle(true);
        }

        // setUpScale(prompt.upscale);
        if (prompt.input_image && includeImages) {
            setImage(prompt.input_image);
            setControlNet(prompt.control_net);
        }
        if (prompt.mask_image) {
            // setMaskImage(prompt.mask_image); // Nice to have when functional
        }
    }

    const getCategorySetting = async () => {
        return await db.settings
            .where("key")
            .equals("category_popup")
            .first(setting => setting.value)
    }

    const checkHostbeforeGenerate = () => {
        if (promptusAPIState.host.includes("localhost")) {
            return false;
        } else if (promptusAPIState.host.includes("promptus")) {
            return true;
        }
    }

    const numberOfAttemptsRef = useRef(1);

    const handleTagModal = () => {
        // Check if schema is still loading - prevent submission until schema is ready
        if (schemaLoading || !schemaLoaded) {
            console.log('[SCHEMA CHECK] Schema not ready, preventing submission. Loading:', schemaLoading, 'Loaded:', schemaLoaded);
            Swal.fire({
                icon: 'info',
                title: 'Loading Model Schema',
                text: 'Please wait while the model configuration loads...',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        setJobRequestPending(true);
        numberOfAttemptsRef.current = 1;

        // Log authentication decision for debugging
        console.log(`[INTERNET_CONNECTIVITY] Authentication check - LoggedIn: ${accountContext.loggedIn}, ShouldBypass: ${shouldBypass}, Allowing: ${accountContext.loggedIn || shouldBypass}`);

        if (accountContext.loggedIn || shouldBypass) {
            getCategorySetting().then(async categoryBool => {
                if (submitPrompt) {
                    // let amount = imageCount * 5
                    // if (accountContext.accountDetails.tokens - amount < 0) {
                    //     Swal.fire({
                    //         color: "£190A4E",
                    //         title: "Not enough tokens",
                    //         text: "You do not have enough tokens for the amount of images you are trying to generate",
                    //         icon: "error",
                    //         confirmButtonText: 'OK',
                    //         confirmButtonColor: "#FFB02E"
                    //     })
                    // } else {
                    if (checkHostbeforeGenerate() == false) {
                        await isLocalServerBusy(promptusAPIState).then(async (data) => {
                            console.log("Local server busy data: ", data);
                            if (data.busy == false || data.busy == "false") {
                                if (submitPrompt.slice(-2) === "i0") {
                                    revealLocator(submitPrompt).then((response) => {
                                        console.log("response", response);
                                        setRevealPrompt(response["Promptinals v1.0"]);
                                    })
                                } else {

                                    if (categoryBool) {
                                        setOpen(true)
                                    } else {
                                        handleSubmitPrompt();
                                    }
                                }
                            }
                            if (categoryBool) {
                                setOpen(true)
                            } else {
                                handleSubmitPrompt();
                            }
                            // else {
                            //     Swal.fire({
                            //         title: "Local server is busy",
                            //         text: "Please try again later",
                            //         icon: "error",
                            //         confirmButtonText: "OK",
                            //         confirmButtonColor: "#FFB02E",
                            //     });
                            // }
                        }).catch((e) => {
                            console.error("Local server is busy error", e);
                        });
                    } else {
                        if (submitPrompt.slice(-2) === "i0") {
                            revealLocator(submitPrompt).then((response) => {
                                console.log("response", response);
                                setRevealPrompt(response["Promptinals v1.0"]);
                            })
                        } else {

                            if (categoryBool) {
                                setOpen(true)
                            } else {
                                handleSubmitPrompt();
                            }
                        }
                    }
                    // }
                } else {
                    if (cosyUI) {
                        handleSubmitPrompt();
                    } else {
                        setJobRequestPending(false);
                        Swal.fire({
                            color: "#190A4E",
                            title: "No Prompt",
                            icon: "error",
                            timer: 1500,
                            showConfirmButton: false
                        })
                    }
                }
            })
        } else {
            setJobRequestPending(false);
            setShowLoginModal(true)
            // Swal.fire({
            //     color: "#190A4E",
            //     title: "Please register an account before generating images here",
            //     icon: "error",
            //     confirmButtonText: 'Login',
            //     confirmButtonColor: "#FFB02E",
            //     showDenyButton: true,
            //     denyButtonText: "Register",
            //     denyButtonColor: "#190A4E",
            // }).then((result) => {
            //     if (result.isConfirmed) {
            //         navigate('/profile?form=login');
            //     }
            //     if (result.isDenied) {
            //         navigate('/profile?form=register');
            //     }
            // })
        }
    }

    // Function to add prompt to history with proper field detection
    const addPromptToHistory = async (formValues) => {
        if (!selectedModel) {
            console.log('[addPromptToHistory] No model selected, skipping history save');
            return;
        }

        try {
            // Get current model's cosyflow variables using indexed lookup
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();

            if (!matchingCosyflow?.data?.variables) {
                console.log('[addPromptToHistory] No cosyflow variables found for model:', stripLocalSuffix(selectedModel));
                return;
            }

            const variables = matchingCosyflow.data.variables;
            let promptText = null;

            // First priority: Find fields with BOTH importance: 5 AND data_type: "prompt"
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 5 &&
                    (variable.data_type === 'prompt' || variable.dataType === 'prompt')) {

                    const fieldValue = formValues[key];
                    if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim()) {
                        promptText = fieldValue.trim();
                        console.log(`[addPromptToHistory] Found prompt in field "${key}" (importance:5 + data_type:prompt): "${promptText.substring(0, 50)}..."`);
                        break;
                    }
                }
            }

            // Fallback: If no data_type="prompt" found, use importance: 5 only
            // (for backward compatibility with models that don't have data_type defined)
            if (!promptText) {
                for (const [key, variable] of Object.entries(variables)) {
                    if (variable.importance === 5) {
                        const fieldValue = formValues[key];
                        if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim()) {
                            promptText = fieldValue.trim();
                            console.log(`[addPromptToHistory] Found prompt in field "${key}" (importance:5 fallback): "${promptText.substring(0, 50)}..."`);
                            break;
                        }
                    }
                }
            }

            // Store in history if we found a valid prompt
            if (promptText) {
                // Check if this prompt already exists
                const existingEntry = await db.history.where('prompt').equalsIgnoreCase(promptText).first();

                if (existingEntry) {
                    // Update timestamp for existing prompt
                    await db.history.update(existingEntry.id, {
                        timestamp: Date.now()
                    });
                    console.log(`[addPromptToHistory] Updated existing history entry for prompt: "${promptText.substring(0, 50)}..."`);
                } else {
                    // Add new history entry
                    await db.history.add({
                        prompt: promptText,
                        seeds: [], // Empty seeds array for now
                        timestamp: Date.now()
                    });
                    console.log(`[addPromptToHistory] Added new history entry for prompt: "${promptText.substring(0, 50)}..."`);
                }
            } else {
                console.log('[addPromptToHistory] No valid prompt found in any importance:5 field');
            }

        } catch (error) {
            console.error('[addPromptToHistory] Error saving prompt to history:', error);
        }
    };

    const syncPromptToForm = async (cosyflowVariables) => {
        if (!submitPrompt || submitPrompt.trim() === '') {
            console.log('[SYNC] No submitPrompt to sync');
            return false;
        }
        if (!inputGroupRef.current) {
            console.log('[SYNC] Form not available for sync');
            return false;
        }

        // Find the correct prompt field using schema
        const currentValues = inputGroupRef.current.getValues();
        let targetField = null;

        if (cosyflowVariables) {
            // Use schema to find prompt field (importance: 5 AND type: 'prompt')
            const promptFields = Object.entries(cosyflowVariables)
                .filter(([key, variable]) => variable.importance === 5 && variable.type === 'prompt')
                .map(([key]) => key);

            targetField = promptFields.find(field => field in currentValues);
            console.log(`[SYNC] Schema-based field detection found: ${targetField || 'none'} from ${promptFields.join(', ')}`);
        }

        if (!targetField) {
            // Fallback to common field names
            targetField = ['text_0', 'positive_prompt', 'prompt'].find(field => field in currentValues);
            console.log(`[SYNC] Fallback field detection found: ${targetField || 'none'}`);
        }

        if (targetField) {
            console.log(`[SYNC] Attempting to sync "${submitPrompt.substring(0, 50)}..." to field: ${targetField}`);

            inputGroupRef.current.setValue(targetField, submitPrompt);

            // Wait for React Hook Form to process the change
            await new Promise(resolve => setTimeout(resolve, 100));

            // Verify the sync worked
            const updatedValues = inputGroupRef.current.getValues();
            const actualValue = updatedValues[targetField];
            const synced = actualValue === submitPrompt;

            console.log(`[SYNC] ${synced ? '✅ SUCCESS' : '❌ FAILED'} - Field "${targetField}" = "${actualValue?.substring(0, 50) || 'empty'}..."`);
            return synced;
        } else {
            console.warn('[SYNC] No suitable prompt field found in form');
            return false;
        }
    };

    const validateFinalPayload = (generatePrompt, cosyflowVariables) => {
        if (!generatePrompt?.prompt) {
            console.error('[FINAL VALIDATION] No generatePrompt.prompt structure');
            return false;
        }

        const prompt = generatePrompt.prompt;

        // Use schema to find prompt fields if available
        if (cosyflowVariables) {
            const promptFields = Object.entries(cosyflowVariables)
                .filter(([key, variable]) => variable.importance === 5 && variable.type === 'prompt')
                .map(([key]) => key);

            if (promptFields.length === 0) {
                console.log('[FINAL VALIDATION] Model has no prompt requirements');
                return true; // Model doesn't require prompts
            }

            // Check if ANY required prompt field has content
            const hasValidPrompt = promptFields.some(field => {
                const value = prompt[field];
                const isValid = typeof value === 'string' && value.trim() !== '';
                console.log(`[FINAL VALIDATION] Field "${field}": "${value?.substring(0, 30) || 'empty'}..." - ${isValid ? 'VALID' : 'EMPTY'}`);
                return isValid;
            });

            return hasValidPrompt;
        } else {
            // Fallback validation without schema
            console.warn('[FINAL VALIDATION] No schema available, using fallback validation');
            const fallbackFields = ['text_0', 'positive_prompt', 'prompt', 'text'];
            return fallbackFields.some(field => {
                const value = prompt[field];
                return typeof value === 'string' && value.trim() !== '';
            });
        }
    };

    const handleSubmitPrompt = async () => {
        props.pageNumber(0);
        props.setCategory("All");

        // Pre-generation check: verify offline servers are still available
        if (!promptusAPIState.online) {
            const { available } = await checkOfflineServersAvailable();
            if (!available) {
                console.log('[PRE-GEN CHECK] Offline servers unavailable, auto-switching to online');
                promptusAPIDispatch({ type: 'online' });
                setSelectedModel('');
                setOptions([]);

                Swal.fire({
                    title: 'Switched to Online Mode',
                    text: 'Local servers are no longer available. Switched to online mode.',
                    icon: 'info',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });
                setJobRequestPending(false);
                return;
            }
        }

        let prompt_output = promptOutput;

        let generatePrompt = {};
        // ALL models now use cosy structure
        if (!inputGroupRef.current) {
            console.error('Form not available - settings panel must be open');
            setJobRequestPending(false);
            return;
        }

        // Fetch cosyflow variables early for sync and validation
        let cosyflowVariables = null;
        try {
            console.log('[COSYFLOW] Fetching variables for model:', stripLocalSuffix(selectedModel));
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();
            if (matchingCosyflow && matchingCosyflow.data.variables) {
                cosyflowVariables = matchingCosyflow.data.variables;
                console.log('[COSYFLOW] Variables loaded:', Object.keys(cosyflowVariables).length, 'fields');
            } else {
                console.warn('[COSYFLOW] No variables found for model:', selectedModel);
            }
        } catch (error) {
            console.error('[COSYFLOW] Error fetching variables:', error);
        }

        // IMPROVED: Async prompt sync with retry logic and verification
        console.log('[PROMPT SYNC] Starting sync process...');
        let syncSuccess = false;
        for (let attempt = 1; attempt <= 3; attempt++) {
            console.log(`[PROMPT SYNC] Attempt ${attempt}/3`);
            syncSuccess = await syncPromptToForm(cosyflowVariables);
            if (syncSuccess) break;

            if (attempt < 3) {
                console.warn(`[PROMPT SYNC] Attempt ${attempt} failed, retrying in 100ms...`);
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        }

        if (!syncSuccess && submitPrompt?.trim()) {
            console.error('[PROMPT SYNC] ❌ CRITICAL: Failed to sync prompt after 3 attempts!');
            console.error('[PROMPT SYNC] submitPrompt:', submitPrompt?.substring(0, 100));
            // Continue anyway but log this critical issue
        } else if (syncSuccess) {
            console.log('[PROMPT SYNC] ✅ Prompt successfully synced to form');
        }

        // Check for URL validation errors (e.g., audio too long)
        if (inputGroupRef.current?.hasUrlValidationErrors?.()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fix the URL validation errors before generating. Ensure URL fields are not empty and media files meet the required constraints.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#FFB02E'
            });
            setJobRequestPending(false);
            return;
        }

        // Get the validated values with all constraints enforced
        const cosy_prompt = inputGroupRef.current.validateAndGetValues ?
            inputGroupRef.current.validateAndGetValues() :
            inputGroupRef.current.getValues();

        console.log('[TESTINGNUMBER] Normal: ', inputGroupRef.current.getValues());
        console.log('[TESTINGNUMBER] Validated: ', inputGroupRef.current.validateAndGetValues());

        // Verify schema/model alignment - ensure form was built with the correct schema
        if (cosyflowVariables && Object.keys(cosyflowVariables).length > 0) {
            const schemaFields = Object.keys(cosyflowVariables);
            const formFields = Object.keys(cosy_prompt).filter(k => !k.endsWith('_mode') && k !== 'cosyflow');

            // Check if at least some expected schema fields exist in the form
            const matchingFields = schemaFields.filter(field =>
                formFields.includes(field) || formFields.includes(`params.${field}`)
            );
            const matchRatio = matchingFields.length / schemaFields.length;

            console.log(`[SCHEMA ALIGNMENT] Model: ${selectedModel}, Schema fields: ${schemaFields.length}, Form fields: ${formFields.length}, Matching: ${matchingFields.length} (${(matchRatio * 100).toFixed(1)}%)`);

            if (matchRatio < 0.3 && schemaFields.length > 3) {
                console.error('[SCHEMA ALIGNMENT] ❌ CRITICAL: Form fields do not match schema - possible model/schema mismatch!');
                console.error('[SCHEMA ALIGNMENT] Schema fields:', schemaFields);
                console.error('[SCHEMA ALIGNMENT] Form fields:', formFields);
                Swal.fire({
                    icon: 'error',
                    title: 'Configuration Mismatch',
                    text: 'The model settings are out of sync. Please wait a moment and try again, or reselect the model.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#3085d6'
                });
                setJobRequestPending(false);
                return;
            }
        }

        console.log(`[JOB REQUEST] Getting validated form values for job request:`, cosy_prompt);
        console.log(`[JOB REQUEST] All numeric constraints have been enforced before submission`);

        // DEBUG: Check mask field values in form data
        if (cosyflowVariables) {
            const maskFields = Object.entries(cosyflowVariables)
                .filter(([key, field]) => field.type === 'b64data' && field.require_mask === true)
                .map(([key]) => key);

            console.log('[MASK DEBUG] Mask fields detected in schema:', maskFields);
            maskFields.forEach(maskField => {
                const formValue = cosy_prompt[maskField];
                const uploadedValue = uploadedB64Data[maskField];
                console.log(`[MASK DEBUG] Form data for ${maskField}:`, formValue ? `${formValue.substring(0, 50)}...` : 'null/undefined');
                console.log(`[MASK DEBUG] UploadedB64Data for ${maskField}:`, uploadedValue ? `${uploadedValue.substring(0, 50)}...` : 'null/undefined');
            });
        }

        // Robust dual-path processing to handle both nested and flat params formats
        console.log('[PARAMS PROCESSING] Starting robust params field collection...');
        console.log('[PARAMS PROCESSING] Input format:', JSON.stringify(cosy_prompt, null, 2));

        const processedPrompt = { ...cosy_prompt };
        const allParamsFields = {};
        const regularFields = {};

        // First pass: Extract params from nested object if it exists
        if (processedPrompt.params && typeof processedPrompt.params === 'object') {
            console.log('[PARAMS PROCESSING] Found nested params object, extracting fields...');
            Object.entries(processedPrompt.params).forEach(([key, value]) => {
                allParamsFields[`params.${key}`] = value;
                console.log(`[PARAMS PROCESSING] Extracted nested params.${key} =`, value);
            });
            delete processedPrompt.params;
        }

        // Second pass: Process flat params ONLY if not already set by nested
        Object.entries(processedPrompt).forEach(([key, value]) => {
            if (key.startsWith('params.')) {
                // Only use flat value if nested didn't already set it
                if (!allParamsFields.hasOwnProperty(key)) {
                    allParamsFields[key] = value;
                    console.log(`[PARAMS PROCESSING] Using flat ${key} =`, value);
                } else {
                    console.log(`[PARAMS PROCESSING] Skipping flat ${key} = ${value} (nested value ${allParamsFields[key]} takes priority)`);
                }
            } else {
                regularFields[key] = value;
                console.log(`[PARAMS PROCESSING] Regular field ${key} =`, value);
            }
        });

        // Merge everything back together with all params fields now flat
        const cosy_prompt_processed = { ...regularFields, ...allParamsFields };
        console.log('[PARAMS PROCESSING] Collected params fields:', Object.keys(allParamsFields));
        console.log('[PARAMS PROCESSING] Collected regular fields:', Object.keys(regularFields));

        // Update cosy_prompt to use processed version
        Object.keys(cosy_prompt).forEach(key => delete cosy_prompt[key]);
        Object.assign(cosy_prompt, cosy_prompt_processed);

        console.log(`[DEBUG] cosy_prompt keys:`, Object.keys(cosy_prompt));
        // Always set cosyflow field to the selected model (includes __local_ suffix for routing)
        cosy_prompt.cosyflow = selectedModel;
        console.log(`[COSY MODEL] Set cosyflow field with model: ${selectedModel}`);
        // cosyflowVariables already fetched earlier in the function

        // Generate new random seed if in random mode (only for type 'seed' fields)
        if (cosyflowVariables) {
            for (const [key, variable] of Object.entries(cosyflowVariables)) {
                // Only process fields with type 'seed'
                if (variable.type === 'seed') {
                    const modeKey = `${key}_mode`;
                    if (cosy_prompt[modeKey] === 'random' && cosy_prompt.hasOwnProperty(key)) {
                        // Check if field is named 'seed_value' - use empty string for string seeds (AI Horde/legacy models)
                        if (key === 'seed_value') {
                            cosy_prompt[key] = "";  // Empty string triggers server-side random generation for each image
                            console.log(`[handleSubmitPrompt] Set ${key} to empty string for server-side random generation`);
                        } else {
                            const newSeed = generateRandomSeed();
                            cosy_prompt[key] = newSeed;
                            console.log(`[handleSubmitPrompt] Generated new random seed for ${key}: ${newSeed}`);
                        }
                    }
                }
            }
        }
        // Build prompt object from cosyflows data
        const flatFields = {};
        Object.entries(cosy_prompt).forEach(([key, value]) => {
            // Check if we have uploaded b64data for this non-prefixed field
            if (uploadedB64Data[key]) {
                flatFields[key] = uploadedB64Data[key];
                console.log(`[PARAMS RESTRUCTURE] Using uploaded b64data for regular field ${key}`);

                // DEBUG: Special logging for mask fields
                if (cosyflowVariables && cosyflowVariables[key] && cosyflowVariables[key].require_mask === true) {
                    console.log(`[MASK DEBUG] PRIORITY: Mask field ${key} using uploadedB64Data:`, uploadedB64Data[key] ? `${uploadedB64Data[key].substring(0, 50)}...` : 'null/undefined');
                }
            } else {
                flatFields[key] = value;

                // DEBUG: Special logging for mask fields
                if (cosyflowVariables && cosyflowVariables[key] && cosyflowVariables[key].require_mask === true) {
                    console.log(`[MASK DEBUG] PRIORITY: Mask field ${key} using form data:`, value ? `${value.substring(0, 50)}...` : 'null/undefined');
                }
            }
        });
        // Separate params-prefixed fields from regular fields with robust processing
        console.log('[PARAMS RESTRUCTURE] Starting final separation and nesting...');
        // Clear the existing objects for reuse
        Object.keys(regularFields).forEach(key => delete regularFields[key]);
        const paramsFields = {};

        Object.entries(flatFields).forEach(([key, value]) => {
            if (key.startsWith('params.')) {
                // Extract the parameter name after 'params.' prefix
                const paramName = key.substring('params.'.length);
                if (paramName) { // Ensure we have a valid param name
                    paramsFields[paramName] = value;
                    console.log(`[PARAMS RESTRUCTURE] ✓ Moving ${key} → params.${paramName} = ${value}`);
                } else {
                    console.warn(`[PARAMS RESTRUCTURE] ⚠️ Invalid params field name: ${key}`);
                }
            } else if (key !== 'params') {
                regularFields[key] = value;
                console.log(`[PARAMS RESTRUCTURE] ✓ Regular field: ${key} = ${value}`);
            }
        });

        console.log(`[PARAMS RESTRUCTURE] Final separation complete:`);
        console.log(`[PARAMS RESTRUCTURE] - Regular fields (${Object.keys(regularFields).length}):`, Object.keys(regularFields));
        console.log(`[PARAMS RESTRUCTURE] - Params fields (${Object.keys(paramsFields).length}):`, Object.keys(paramsFields));
        // Build the prompt object with proper structure (without model/cosyflow at this level)
        console.log('[FINAL STRUCTURE] Building final prompt object...');
        const promptObject = {
            ...regularFields  // Spread only non-param fields
            // "count": cosy_prompt.batch_size || cosy_prompt.imageCount || cosy_prompt.count || cosy_prompt["params.count"] || 1
        };

        // Add params object if there are any params fields (this ensures nested structure)
        if (Object.keys(paramsFields).length > 0) {
            promptObject.params = paramsFields;
            console.log(`[FINAL STRUCTURE] ✓ Created nested params object with ${Object.keys(paramsFields).length} fields:`);
            Object.entries(paramsFields).forEach(([key, value]) => {
                console.log(`[FINAL STRUCTURE]   - params.${key} = ${value}`);
            });
        } else {
            console.log(`[FINAL STRUCTURE] ⚠️ No params fields found - params object will not be created`);
        }

        // Create the final structure
        generatePrompt = {
            "prompt": promptObject
        };

        console.log(`[JOB REQUEST] ✅ Final API payload structure:`);
        console.log(`[JOB REQUEST] - Root level fields: ${Object.keys(promptObject).filter(k => k !== 'params').length}`);
        console.log(`[JOB REQUEST] - Nested params fields: ${promptObject.params ? Object.keys(promptObject.params).length : 0}`);

        // DEBUG: Check final mask field values in API payload
        if (cosyflowVariables) {
            const maskFields = Object.entries(cosyflowVariables)
                .filter(([key, field]) => field.type === 'b64data' && field.require_mask === true)
                .map(([key]) => key);

            console.log('[MASK DEBUG] FINAL PAYLOAD check for mask fields:', maskFields);
            maskFields.forEach(maskField => {
                const finalValue = promptObject[maskField] || (promptObject.params && promptObject.params[maskField]);
                console.log(`[MASK DEBUG] FINAL PAYLOAD ${maskField}:`, finalValue ? `${finalValue.substring(0, 50)}...` : 'null/undefined');
            });
        }

        console.log(`[JOB REQUEST] Full payload:`, generatePrompt);
        // Handle special modes
        if (controlNet !== "" || pix2pix === true) {
            generatePrompt.prompt.prompt_output = "image-image";
        }
        // Add enhanced and meme prompt if needed
        if (enhancePrompt) {
            generatePrompt.prompt.enhanced = enhancePrompt;
        }
        if (memePrompt) {
            generatePrompt.prompt.meme_prompt = memePrompt;
        }
        // Not sure how this can co-exist with cosyflow dynamic inputs, where we have more freedom to express safety tolerance
        // Perhaps this is just to ask the API server to do its first-pass safety check?
        // let safeMode = true;
        // if (settings.find(setting => setting.key === "safe_mode")) {
        //     safeMode = settings.find(setting => setting.key === "safe_mode").value;
        // }
        // if (safeMode) {
        //     generatePrompt.prompt.safe_mode = safeMode;
        // }

        console.log('[ALL MODELS] Final generatePrompt structure:', JSON.stringify(generatePrompt, null, 2));
        
        // Convert any seed fields to integers if they can be converted
        const convertSeedToInteger = (obj, path = '') => {
            Object.keys(obj).forEach(key => {
                const fullPath = path ? `${path}.${key}` : key;
                const value = obj[key];
                
                // Check if this field looks like a seed field
                if ((key.toLowerCase().includes('seed') || key === 'noise_seed') && value !== null && value !== undefined && value !== '') {
                    // Try to convert to integer
                    const numValue = Number(value);
                    if (!isNaN(numValue) && isFinite(numValue)) {
                        // Convert to integer (truncate decimals)
                        obj[key] = Math.floor(numValue);
                        console.log(`[SEED CONVERSION] Converted ${fullPath} from "${value}" to ${obj[key]}`);
                    } else if (typeof value === 'string' && value.trim() !== '') {
                        // If it's a non-numeric string that can't be converted, log a warning
                        console.warn(`[SEED CONVERSION] Could not convert ${fullPath} value "${value}" to integer, keeping as-is`);
                    }
                } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    // Recursively check nested objects
                    convertSeedToInteger(value, fullPath);
                }
            });
        };
        
        // Apply seed conversion to the entire generatePrompt object
        if (generatePrompt && generatePrompt.prompt) {
            convertSeedToInteger(generatePrompt.prompt);
        }
        
        console.log('[SEED CONVERSION] Final generatePrompt after seed conversion:', JSON.stringify(generatePrompt, null, 2));

        // Add Nano Banana prompt modification logic
        if (selectedModel && selectedModel.includes('Nano Banana')) {
            console.log('[NANO BANANA] Detected Nano Banana model, checking for prompt modification');

            if (generatePrompt && generatePrompt.prompt) {
                const prompt = generatePrompt.prompt;

                // Find the main prompt field using the same logic as validation
                const promptFields = ['positive_prompt', 'text_0', 'text', 'prompt'];
                let mainPromptField = null;
                let currentPromptText = '';

                // Find the first non-empty prompt field
                for (const fieldName of promptFields) {
                    if (fieldName in prompt && typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                        mainPromptField = fieldName;
                        currentPromptText = prompt[fieldName].trim();
                        console.log(`[NANO BANANA] Found main prompt field: "${fieldName}" with text: "${currentPromptText.substring(0, 50)}..."`);
                        break;
                    }
                }

                if (mainPromptField && currentPromptText) {
                    // Check if an image is present using cosyflow schema detection
                    const hasInputImage = () => {
                        if (!cosyflowVariables) {
                            console.log('[NANO BANANA] No cosyflowVariables available, falling back to hardcoded fields');
                            // Fallback to hardcoded field names if schema not available
                            const imageFields = ['input_image', 'image', 'init_image', 'image_0'];
                            for (const field of imageFields) {
                                if ((prompt[field] && prompt[field] !== '') ||
                                    (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                                    return true;
                                }
                            }
                            return false;
                        }

                        // Use cosyflow schema to find image fields
                        for (const [fieldName, field] of Object.entries(cosyflowVariables)) {
                            if (field.type === 'b64data' || field.type === 'image' ||
                                (field.accept && field.accept.includes('image'))) {
                                console.log(`[NANO BANANA] Checking schema-defined image field: "${fieldName}"`);
                                // Check if this field has content
                                if ((prompt[fieldName] && prompt[fieldName] !== '') ||
                                    (prompt.params && prompt.params[fieldName] && prompt.params[fieldName] !== '')) {
                                    console.log(`[NANO BANANA] Found image content in field: "${fieldName}"`);
                                    return true;
                                }
                            }
                        }
                        console.log('[NANO BANANA] No image content found in any schema-defined image fields');
                        return false;
                    };

                    const imagePresent = hasInputImage();

                    // Determine the appropriate prefix
                    let prefix = '';
                    if (imagePresent) {
                        prefix = 'modify the image to ';
                        console.log('[NANO BANANA] Image detected, will use "modify the image to" prefix');
                    } else {
                        prefix = 'generate an image of ';
                        console.log('[NANO BANANA] No image detected, will use "generate an image of" prefix');
                    }

                    // Check if similar wording already exists in the prompt
                    const currentPromptLower = currentPromptText.toLowerCase();
                    const hasGenerateWording = currentPromptLower.includes('generate') && currentPromptLower.includes('image');
                    const hasModifyWording = currentPromptLower.includes('modify') && currentPromptLower.includes('image');
                    const hasCreateWording = currentPromptLower.includes('create') && currentPromptLower.includes('image');
                    const hasMakeWording = currentPromptLower.includes('make') && currentPromptLower.includes('image');

                    const hasSimilarWording = hasGenerateWording || hasModifyWording || hasCreateWording || hasMakeWording;

                    if (!hasSimilarWording) {
                        // Add the prefix to the prompt
                        const modifiedPrompt = prefix + currentPromptText;
                        prompt[mainPromptField] = modifiedPrompt;
                        console.log(`[NANO BANANA] Modified prompt from "${currentPromptText.substring(0, 30)}..." to "${modifiedPrompt.substring(0, 50)}..."`);
                    } else {
                        console.log('[NANO BANANA] Similar wording already exists in prompt, skipping modification');
                    }
                } else {
                    console.log('[NANO BANANA] No valid prompt field found, skipping modification');
                }
            }
        }

        // Check if a positive prompt has been provided
        const checkForPrompt = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return false;
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check various possible prompt field names
            const promptFields = ['positive_prompt', 'text_0', 'text', 'prompt'];
            
            let fieldFound = false;
            for (const fieldName of promptFields) {
                if (fieldName in prompt) {
                    fieldFound = true;
                    if (typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                        console.log(
                            `[PROMPT CHECK] Found valid prompt in field "${fieldName}": "${prompt[fieldName].substring(0, 50)}..."`
                        );
                        return true;
                    }
                }
            }
            
            // If none of the expected fields were found at all
            if (!fieldFound) {
                console.log("[PROMPT CHECK] No expected prompt fields were found.");
                return false;
            }

            // Also check if there's a main prompt in submitPrompt that might not have been synced
            if (submitPrompt && submitPrompt.trim() !== '') {
                console.log(
                    `[PROMPT CHECK] Found prompt in submitPrompt: "${submitPrompt.substring(0, 50)}..."`
                );
                return true;
            }
            
            return false;
        };
        
        // Dynamic prompt checking function that uses schema importance metadata
        const checkForPromptDynamic = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                console.log('[PROMPT CHECK DYNAMIC] No generatePrompt structure found');
                return false;
            }
            
            const prompt = generatePrompt.prompt;
            
            // Try to get the cosyflow variables which contain the importance metadata
            if (cosyflowVariables) {
                console.log('[PROMPT CHECK DYNAMIC] Using cosyflow variables to find main prompt field');
                
                // Find fields with importance: 5 AND type: 'prompt' (main prompt fields)
                const mainPromptFields = [];
                for (const [key, variable] of Object.entries(cosyflowVariables)) {
                    if (variable.importance === 5 && variable.type === 'prompt') {
                        mainPromptFields.push(key);
                        console.log(`[PROMPT CHECK DYNAMIC] Found prompt field with importance 5 and type 'prompt': "${key}"`);
                    }
                }

                // If no prompt fields exist, model doesn't require prompts - skip validation
                if (mainPromptFields.length === 0) {
                    console.log('[PROMPT CHECK DYNAMIC] Model has no prompt requirements (no importance:5 + type:prompt fields), skipping validation');
                    return true;
                }

                // Check if any of the main prompt fields have valid content
                for (const fieldName of mainPromptFields) {
                    if (fieldName in prompt) {
                        if (typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                            console.log(
                                `[PROMPT CHECK DYNAMIC] Found valid prompt in importance:5 field "${fieldName}": "${prompt[fieldName].substring(0, 50)}..."`
                            );
                            return true;
                        }
                    }
                }
                
                // If we found prompt fields but they're all empty
                if (mainPromptFields.length > 0) {
                    console.log(`[PROMPT CHECK DYNAMIC] Found ${mainPromptFields.length} prompt fields with importance:5 + type:prompt but all are empty`);

                    // Check submitPrompt as fallback
                    if (submitPrompt && submitPrompt.trim() !== '') {
                        console.log('[PROMPT CHECK DYNAMIC] Found prompt in submitPrompt (not synced to prompt field):', submitPrompt.substring(0, 50) + '...');
                        return true;
                    }

                    return false;
                }
            } else {
                console.warn('[PROMPT CHECK DYNAMIC] No cosyflow variables available - this should not happen with schema loading guards');
                // Fall back to basic prompt validation instead of skipping
                return checkForPrompt();
            }

            // This should never be reached due to the logic above
            return true;
        };
        
        // Validate that a prompt exists before proceeding
        // Try dynamic check first, which will fall back to original if needed
        if (!checkForPromptDynamic()) {
            console.warn('[PROMPT CHECK] No prompt text found in any expected field');
            Swal.fire({
                icon: 'warning',
                title: 'No Prompt Provided',
                text: 'Please enter a prompt to generate images.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6'
            });
            generateStatusDispatch({ type: 'done' });
            setJobRequestPending(false)
            return;
        }

        // Helper function to validate media content (distinguishes actual content from filenames)
        const isValidMediaContent = (content, mediaType = 'any') => {
            if (!content || typeof content !== 'string') {
                console.log(`[CONTENT VALIDATION] Invalid content type: ${typeof content}`);
                return false;
            }

            const trimmedContent = content.trim();

            // Reject filename patterns - these are likely default/placeholder values
            const filenamePattern = /\.(png|jpg|jpeg|gif|bmp|webp|svg|mp3|wav|ogg|m4a|aac|mp4|webm|mov|avi|mkv|wmv)$/i;
            if (filenamePattern.test(trimmedContent)) {
                console.warn(`[CONTENT VALIDATION] Rejected filename pattern: "${trimmedContent}"`);
                return false;
            }

            // Check for valid URL formats
            const isUrl = /^(https?:\/\/|data:|blob:|file:|safe-file:)/i.test(trimmedContent);
            if (isUrl) {
                console.log(`[CONTENT VALIDATION] Valid URL detected: "${trimmedContent.substring(0, 50)}..."`);
                return true;
            }

            // Check for valid base64 content
            const isValidBase64 = trimmedContent.length > 50 && /^[A-Za-z0-9+/]+/.test(trimmedContent.substring(0, 100));
            if (isValidBase64) {
                console.log(`[CONTENT VALIDATION] Valid base64 content detected (${trimmedContent.length} chars)`);
                return true;
            }

            // Check for very short strings that might be placeholders
            if (trimmedContent.length < 10) {
                console.warn(`[CONTENT VALIDATION] Content too short to be valid: "${trimmedContent}"`);
                return false;
            }

            console.warn(`[CONTENT VALIDATION] Invalid content format: "${trimmedContent.substring(0, 30)}..."`);
            return false;
        };

        // Check if required images are provided using schema-based validation
        const checkForRequiredImages = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return true; // No prompt structure yet, skip image check
            }

            // Use schema-based validation instead of hardcoded field names
            if (!cosyflowVariables) {
                console.log('[IMAGE CHECK SCHEMA] No cosyflow variables available, skipping validation');
                return true; // No schema available, skip validation
            }

            const prompt = generatePrompt.prompt;
            console.log('[IMAGE CHECK SCHEMA] Starting schema-based image validation');

            // Find fields that are required image inputs (importance 5 AND type b64data, but NOT url type)
            const requiredImageFields = [];
            for (const [fieldName, variable] of Object.entries(cosyflowVariables)) {
                if (variable.importance === 5 && variable.type === 'b64data' && variable.type !== 'url') {
                    requiredImageFields.push(fieldName);
                    console.log(`[IMAGE CHECK SCHEMA] Found required image field: "${fieldName}" (importance: ${variable.importance}, type: ${variable.type})`);
                }
            }

            // If no required image fields exist, this is a text-to-image model
            if (requiredImageFields.length === 0) {
                console.log('[IMAGE CHECK SCHEMA] No required image fields found - text-to-image model');
                return true;
            }

            // Check if all required image fields have values
            for (const fieldName of requiredImageFields) {
                let fieldValue = null;
                let fieldLocation = null;

                // Check if field exists directly in prompt
                if (fieldName in prompt) {
                    fieldValue = prompt[fieldName];
                    fieldLocation = fieldName;
                }
                // Check if field exists in params
                else if (prompt.params && fieldName in prompt.params) {
                    fieldValue = prompt.params[fieldName];
                    fieldLocation = `params.${fieldName}`;
                }

                console.log(`[IMAGE CHECK SCHEMA] Checking field "${fieldName}" at location "${fieldLocation}":`,
                           fieldValue ? `${fieldValue.length} characters` : 'null/empty');

                // If field is empty, doesn't exist, or contains invalid content, validation fails
                if (!fieldValue || fieldValue === '' || fieldValue.trim() === '' || !isValidMediaContent(fieldValue, 'image')) {
                    console.warn(`[IMAGE CHECK SCHEMA] Required image field "${fieldName}" has invalid content:`,
                               fieldValue ? `"${fieldValue.substring(0, 50)}..."` : 'null/empty');
                    return false;
                }
            }

            console.log(`[IMAGE CHECK SCHEMA] All ${requiredImageFields.length} required image field(s) have values`);
            return true; // All required image fields have values
        };

        // Check if required audio files are provided using schema-based validation
        const checkForRequiredAudio = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return true; // No prompt structure yet, skip audio check
            }

            // Use schema-based validation instead of hardcoded field names
            if (!cosyflowVariables) {
                console.log('[AUDIO CHECK SCHEMA] No cosyflow variables available, skipping validation');
                return true; // No schema available, skip validation
            }

            const prompt = generatePrompt.prompt;
            console.log('[AUDIO CHECK SCHEMA] Starting schema-based audio validation');

            // Find fields that are required audio inputs (importance 5 AND audio_upload true, but NOT url type)
            const requiredAudioFields = [];
            for (const [fieldName, variable] of Object.entries(cosyflowVariables)) {
                if (variable.importance === 5 && variable.audio_upload === true && variable.type !== 'url') {
                    requiredAudioFields.push(fieldName);
                    console.log(`[AUDIO CHECK SCHEMA] Found required audio field: "${fieldName}" (importance: ${variable.importance}, audio_upload: ${variable.audio_upload})`);
                }
            }

            // If no required audio fields exist, this model doesn't require audio
            if (requiredAudioFields.length === 0) {
                console.log('[AUDIO CHECK SCHEMA] No required audio fields found - model does not require audio');
                return true;
            }

            // Check if all required audio fields have values
            for (const fieldName of requiredAudioFields) {
                let fieldValue = null;
                let fieldLocation = null;

                // Check if field exists directly in prompt
                if (fieldName in prompt) {
                    fieldValue = prompt[fieldName];
                    fieldLocation = fieldName;
                }
                // Check if field exists in params
                else if (prompt.params && fieldName in prompt.params) {
                    fieldValue = prompt.params[fieldName];
                    fieldLocation = `params.${fieldName}`;
                }

                console.log(`[AUDIO CHECK SCHEMA] Checking field "${fieldName}" at location "${fieldLocation}":`,
                           fieldValue ? `${fieldValue.length} characters` : 'null/empty');

                // If field is empty, doesn't exist, or contains invalid content, validation fails
                if (!fieldValue || fieldValue === '' || fieldValue.trim() === '' || !isValidMediaContent(fieldValue, 'audio')) {
                    console.warn(`[AUDIO CHECK SCHEMA] Required audio field "${fieldName}" has invalid content:`,
                               fieldValue ? `"${fieldValue.substring(0, 50)}..."` : 'null/empty');
                    return false;
                }
            }

            console.log(`[AUDIO CHECK SCHEMA] All ${requiredAudioFields.length} required audio field(s) have values`);
            return true; // All required audio fields have values
        };

        // Check if required video files are provided using schema-based validation
        const checkForRequiredVideo = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return true; // No prompt structure yet, skip video check
            }

            // Use schema-based validation instead of hardcoded field names
            if (!cosyflowVariables) {
                console.log('[VIDEO CHECK SCHEMA] No cosyflow variables available, skipping validation');
                return true; // No schema available, skip validation
            }

            const prompt = generatePrompt.prompt;
            console.log('[VIDEO CHECK SCHEMA] Starting schema-based video validation');

            // Find fields that are required video inputs (importance 5 AND video_upload true, but NOT url type)
            const requiredVideoFields = [];
            for (const [fieldName, variable] of Object.entries(cosyflowVariables)) {
                if (variable.importance === 5 && variable.video_upload === true && variable.type !== 'url') {
                    requiredVideoFields.push(fieldName);
                    console.log(`[VIDEO CHECK SCHEMA] Found required video field: "${fieldName}" (importance: ${variable.importance}, video_upload: ${variable.video_upload})`);
                }
            }

            // If no required video fields exist, this model doesn't require video
            if (requiredVideoFields.length === 0) {
                console.log('[VIDEO CHECK SCHEMA] No required video fields found - model does not require video');
                return true;
            }

            // Check if all required video fields have values
            for (const fieldName of requiredVideoFields) {
                let fieldValue = null;
                let fieldLocation = null;

                // Check if field exists directly in prompt
                if (fieldName in prompt) {
                    fieldValue = prompt[fieldName];
                    fieldLocation = fieldName;
                }
                // Check if field exists in params
                else if (prompt.params && fieldName in prompt.params) {
                    fieldValue = prompt.params[fieldName];
                    fieldLocation = `params.${fieldName}`;
                }

                console.log(`[VIDEO CHECK SCHEMA] Checking field "${fieldName}" at location "${fieldLocation}":`,
                           fieldValue ? `${fieldValue.length} characters` : 'null/empty');

                // If field is empty, doesn't exist, or contains invalid content, validation fails
                if (!fieldValue || fieldValue === '' || fieldValue.trim() === '' || !isValidMediaContent(fieldValue, 'video')) {
                    console.warn(`[VIDEO CHECK SCHEMA] Required video field "${fieldName}" has invalid content:`,
                               fieldValue ? `"${fieldValue.substring(0, 50)}..."` : 'null/empty');
                    return false;
                }
            }

            console.log(`[VIDEO CHECK SCHEMA] All ${requiredVideoFields.length} required video field(s) have values`);
            return true; // All required video fields have values
        };

        // Check if a mask image is required for inpainting models
        const checkForMaskImage = () => {
            // First check if this is an inpainting model
            const isInpaintingModel = () => {
                // Check model name
                const modelLower = selectedModel ? selectedModel.toLowerCase() : '';
                if (modelLower.includes('inpaint') || modelLower.includes('in-paint')) {
                    return true;
                }
                
                // Check prompt output type
                if (promptOutput === 'image-in-paint') {
                    return true;
                }
                
                // Check cosyflow field
                if (generatePrompt && generatePrompt.prompt && generatePrompt.prompt.cosyflow) {
                    const cosyflowLower = generatePrompt.prompt.cosyflow.toLowerCase();
                    if (cosyflowLower.includes('inpaint')) {
                        return true;
                    }
                }
                
                return false;
            };
            
            // If not an inpainting model, mask is not required
            if (!isInpaintingModel()) {
                return true;
            }
            
            console.log('[MASK CHECK] Inpainting model detected, checking for mask...');
            
            if (!generatePrompt || !generatePrompt.prompt) {
                return false; // Inpainting model but no prompt structure
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check various possible mask field names
            const maskFields = ['mask_image', 'mask', 'mask_0', 'inpaint_mask'];
            let hasMaskField = false;
            let emptyMaskField = null;
            
            for (const fieldName of maskFields) {
                // Check if field exists in the prompt structure
                if (fieldName in prompt) {
                    hasMaskField = true;
                    // Check if it's empty
                    if (!prompt[fieldName] || prompt[fieldName] === '') {
                        console.log(`[MASK CHECK] Found empty mask field "${fieldName}"`);
                        emptyMaskField = fieldName;
                        break;
                    } else {
                        console.log(`[MASK CHECK] Found valid mask in field "${fieldName}"`);
                        return true; // Found a valid mask
                    }
                }
                
                // Also check params.fieldName
                if (prompt.params && fieldName in prompt.params) {
                    hasMaskField = true;
                    if (!prompt.params[fieldName] || prompt.params[fieldName] === '') {
                        console.log(`[MASK CHECK] Found empty mask field "params.${fieldName}"`);
                        emptyMaskField = `params.${fieldName}`;
                        break;
                    } else {
                        console.log(`[MASK CHECK] Found valid mask in field "params.${fieldName}"`);
                        return true; // Found a valid mask
                    }
                }
            }
            
            // If we're here, it's an inpainting model but no valid mask was found
            console.warn(`[MASK CHECK] Inpainting model requires a mask but none provided`);
            return false;
        };

        // Check if required URL fields are provided using schema-based validation
        const checkForRequiredUrls = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return true; // No prompt structure yet, skip URL check
            }

            if (!cosyflowVariables) {
                console.log('[URL CHECK SCHEMA] No cosyflow variables available, skipping validation');
                return true;
            }

            const prompt = generatePrompt.prompt;
            console.log('[URL CHECK SCHEMA] Starting schema-based URL validation');

            // Find fields that are required URL inputs (type: 'url', importance: 5, image_upload: true)
            const requiredUrlFields = [];
            for (const [fieldName, variable] of Object.entries(cosyflowVariables)) {
                if (variable.type === 'url' && variable.importance === 5 && variable.image_upload === true) {
                    requiredUrlFields.push(fieldName);
                    console.log(`[URL CHECK SCHEMA] Found required URL field: "${fieldName}" (type: ${variable.type}, importance: ${variable.importance}, image_upload: ${variable.image_upload})`);
                }
            }

            if (requiredUrlFields.length === 0) {
                console.log('[URL CHECK SCHEMA] No required URL fields found - model does not require URL input');
                return true;
            }

            // Validate each required URL field
            for (const fieldName of requiredUrlFields) {
                let fieldValue = null;
                let fieldLocation = null;

                // Check if field exists directly in prompt
                if (fieldName in prompt) {
                    fieldValue = prompt[fieldName];
                    fieldLocation = fieldName;
                }
                // Check if field exists in params
                else if (prompt.params && fieldName in prompt.params) {
                    fieldValue = prompt.params[fieldName];
                    fieldLocation = `params.${fieldName}`;
                }

                console.log(`[URL CHECK SCHEMA] Checking field "${fieldName}" at location "${fieldLocation}":`,
                           fieldValue ? `"${fieldValue.substring(0, 50)}..."` : 'null/empty');

                // Check if field is empty
                if (!fieldValue || fieldValue.trim() === '') {
                    console.warn(`[URL CHECK SCHEMA] Required URL field "${fieldName}" is empty`);
                    return false;
                }

                // Validate URL format
                try {
                    new URL(fieldValue);
                    console.log(`[URL CHECK SCHEMA] Valid URL in field "${fieldName}"`);
                } catch {
                    console.warn(`[URL CHECK SCHEMA] Invalid URL format in field "${fieldName}": "${fieldValue}"`);
                    return false;
                }
            }

            console.log(`[URL CHECK SCHEMA] All ${requiredUrlFields.length} required URL field(s) are valid`);
            return true;
        };

        // Validate that required media (image, audio, video, url) is provided if required
        const mediaValidation = {
            images: checkForRequiredImages(),
            audio: checkForRequiredAudio(),
            video: checkForRequiredVideo(),
            urls: checkForRequiredUrls()
        };

        console.log('[MEDIA VALIDATION] Results:', {
            images: mediaValidation.images,
            audio: mediaValidation.audio,
            video: mediaValidation.video,
            urls: mediaValidation.urls,
            modelName: selectedModel
        });

        // Skip media validation for Nano Banana model
        const skipValidation = generatePrompt.prompt.cosyflow.includes('Nano Banana');

        if (!skipValidation) {
            // Check for missing image inputs
            if (!mediaValidation.images) {
                console.warn('[MEDIA CHECK] Input image required but not provided');
                Swal.fire({
                    icon: 'error',
                    title: 'Input Image Required',
                    text: 'Please provide an input image. This model requires an image to proceed.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#d33'
                });
                generateStatusDispatch({ type: 'done' });
                setJobRequestPending(false);
                return;
            }

            // Check for missing audio inputs
            if (!mediaValidation.audio) {
                console.warn('[MEDIA CHECK] Input audio required but not provided');
                Swal.fire({
                    icon: 'error',
                    title: 'Input Audio Required',
                    text: 'Please provide an audio file. This model requires audio input to proceed.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#d33'
                });
                generateStatusDispatch({ type: 'done' });
                setJobRequestPending(false);
                return;
            }

            // Check for missing video inputs
            if (!mediaValidation.video) {
                console.warn('[MEDIA CHECK] Input video required but not provided');
                Swal.fire({
                    icon: 'error',
                    title: 'Input Video Required',
                    text: 'Please provide a video file. This model requires video input to proceed.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#d33'
                });
                generateStatusDispatch({ type: 'done' });
                setJobRequestPending(false);
                return;
            }

            // Check for missing or invalid URL inputs
            if (!mediaValidation.urls) {
                console.warn('[MEDIA CHECK] Input URL required but not provided or invalid');
                Swal.fire({
                    icon: 'error',
                    title: 'Valid URL Required',
                    text: 'Please provide a valid image URL. This model requires a URL input to proceed.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#d33'
                });
                generateStatusDispatch({ type: 'done' });
                setJobRequestPending(false);
                return;
            }
        }
        
        // Validate that mask image is provided for inpainting models
        // if (!checkForMaskImage()) {
        //     console.warn('[MASK CHECK] Mask image required for inpainting but not provided');
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Mask Image Required',
        //         text: 'Please provide a mask image. Inpainting models require both an input image and a mask to specify which areas to modify.',
        //         confirmButtonText: 'OK',
        //         confirmButtonColor: '#d33'
        //     });
        //     generateStatusDispatch({ type: 'done' });
        //     setJobRequestPending(false);
        //     return;
        // }

        // Ensure prompt_output field exists with the correct value
        const ensurePromptOutputField = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return; // No prompt structure yet, skip
            }
            
            // Check if the model has a prefix and skip if it's not unprefixed or uncensored
            if (selectedModel) {
                // Check if model starts with a prefix in parentheses
                const prefixMatch = selectedModel.match(/^\(([^)]+)\)/);
                if (prefixMatch) {
                    const prefix = prefixMatch[1].toLowerCase();
                    // Only continue for uncensored prefix, skip for all other prefixes
                    if (prefix !== 'uncensored') {
                        console.log(`[PROMPT OUTPUT] Skipping prompt_output check for model with prefix: (${prefix})`);
                        return;
                    }
                }
                // If no prefix found or prefix is 'uncensored', continue with the check
                console.log('[PROMPT OUTPUT] Model has no prefix or uncensored prefix, proceeding with check');
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check if prompt_output already exists - if it does, don't modify it
            if (prompt['prompt_output'] && typeof prompt['prompt_output'] === 'string' && prompt['prompt_output'].trim() !== '') {
                console.log(`[PROMPT OUTPUT] Field already exists with value: "${prompt['prompt_output']}", not modifying`);
                return;
            }
            
            // prompt_output is missing or empty, determine what it should be
            console.log('[PROMPT OUTPUT] Field is missing or empty, determining correct value...');
            
            // Helper to check if we have an input image
            const hasInputImage = () => {
                const imageFields = ['input_image', 'image', 'init_image', 'image_0'];
                for (const field of imageFields) {
                    if ((prompt[field] && prompt[field] !== '') || 
                        (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                        return true;
                    }
                }
                return false;
            };
            
            // Helper to check if we have a mask
            const hasMask = () => {
                const maskFields = ['mask_image', 'mask', 'mask_0', 'inpaint_mask'];
                for (const field of maskFields) {
                    if ((prompt[field] && prompt[field] !== '') || 
                        (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                        return true;
                    }
                }
                return false;
            };
            
            // Determine the correct prompt_output value
            let promptOutputValue = "text-image"; // Default
            
            if (hasInputImage() && hasMask()) {
                promptOutputValue = "image-in-paint";
                console.log('[PROMPT OUTPUT] Detected both image and mask - setting to "image-in-paint"');
            } else if (hasInputImage()) {
                promptOutputValue = "image-image";
                console.log('[PROMPT OUTPUT] Detected input image - setting to "image-image"');
            } else {
                console.log('[PROMPT OUTPUT] No input image or mask - setting to "text-image"');
            }
            
            // Set the prompt_output field
            generatePrompt.prompt["prompt_output"] = promptOutputValue;
            console.log(`[PROMPT OUTPUT] Set prompt_output to: "${promptOutputValue}"`);
        };

        // Call the function to ensure prompt_output is set correctly
        ensurePromptOutputField();
        // console.log('[LCHECKL] Final prompt object: ', generatePrompt);

        // Validate mask presence for inpainting models
        console.log('[MASK VALIDATION] Starting mask validation check...');
        const modelRequiresMask = checkIfModelRequiresMask(cosyflowVariables);
        console.log('[MASK VALIDATION] Model requires mask:', modelRequiresMask);

        if (modelRequiresMask) {
            try {
                console.log('[MASK VALIDATION] Starting validation with data:', Object.keys(cosy_prompt));
                const maskValidation = await Promise.race([
                    validateMaskPresence(cosy_prompt, cosyflowVariables),
                    new Promise((_, reject) =>
                        setTimeout(() => reject(new Error('Validation timeout')), 5000)
                    )
                ]);

                if (!maskValidation.isValid) {
                    console.log('[MASK VALIDATION] Validation failed:', maskValidation.message);
                    setJobRequestPending(false);
                    Swal.fire({
                        title: "Mask Required",
                        text: maskValidation.message,
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    });
                    generateStatusDispatch({ type: 'ready' });
                    return; // Stop submission
                }
                console.log('[MASK VALIDATION] Validation passed');
            } catch (error) {
                console.error('[MASK VALIDATION] Error during validation:', error);
                if (error.message === 'Validation timeout') {
                    console.warn('[MASK VALIDATION] Validation timed out, proceeding without validation');
                    // Don't block submission on timeout, just log the issue
                } else {
                    setJobRequestPending(false);
                    Swal.fire({
                        title: "Validation Error",
                        text: "There was an error validating the mask. Please try again.",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    });
                    generateStatusDispatch({ type: 'ready' });
                    return; // Stop submission
                }
            }
        }
        console.log('[MASK VALIDATION] Mask validation complete, proceeding with submission...');

        // FINAL PAYLOAD VALIDATION: Check actual generatePrompt structure before API call
        console.log('[FINAL VALIDATION] Validating final API payload...');
        // if (!validateFinalPayload(generatePrompt, cosyflowVariables)) {
        //     console.error('[FINAL VALIDATION] ❌ CRITICAL: Empty prompt detected in final payload!');
        //     console.error('[FINAL VALIDATION] generatePrompt structure:', JSON.stringify(generatePrompt, null, 2));

        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Prompt Sync Error',
        //         text: 'Unable to sync your prompt properly. Please try again or contact support.',
        //         confirmButtonText: 'OK',
        //         confirmButtonColor: '#d33'
        //     });

        //     generateStatusDispatch({ type: 'done' });
        //     setJobRequestPending(false);
        //     return;
        // }
        console.log('[FINAL VALIDATION] ✅ Final payload validation passed');

        generateStatusDispatch({ type: 'loading' });
        getServerStatus(promptusAPIState, generateStatusDispatch)
            .then((data) => {
                if (numberOfAttemptsRef.current === 1) {
                    // Seed values are now automatically saved to IndexedDB via onFieldChange in DynamicPromptForm
                    props.handleGenerate(generatePrompt, false, null);
                    numberOfAttemptsRef.current++;
                }
            });

        // Add prompt to history after successful submission
        try {
            await addPromptToHistory(cosy_prompt);
        } catch (error) {
            console.error('[handleSubmitPrompt] Error adding prompt to history:', error);
        }
    };

    const handleControlNetToggle = (checked, value) => {
        if (checked) {
            setControlNet(value);
        } else {
            setControlNet("");
        }
        setPix2Pix(false);
        setPromptOutput("text-image");
    }

    const addTagToImage = () => {
        console.log("add tag to image", tag, inputTag);
        if (tag !== "" && inputTag !== "") {
            let concactedString = tag + "," + inputTag;
            if (concactedString !== "") {
                console.log("concactedString", concactedString);
                generateStatusDispatch({ type: 'tagging', tag: concactedString });
            }
        } else if (tag !== "" && inputTag === "") {
            generateStatusDispatch({ type: 'tagging', tag: tag });
        } else if (tag === "" && inputTag !== "") {
            generateStatusDispatch({ type: 'tagging', tag: inputTag });
        }
        setOpen(false)
        handleSubmitPrompt()
    }

    const handleKeyDown = (e) => {
        if (openHistory) {
            if (e.key === "Escape" || e.keyCode == 27) {
                setOpenHistory(false)
            }
        }
        if (e.key === "Enter") {
            if (open) {
                addTagToImage()
            } else {
                handleTagModal()
            }
        }
    };


    const retainPrompt = () => {
        try {
            localStorage.setItem("Generate", JSON.stringify({
                prompt: submitPrompt,
                enhancePrompt: enhancePrompt,
                seed: seed,
                negativeKeywords: negativeKeywords,
                steps: steps,
                guidance: guidance,
                imageCount: imageCount,
                imageWidth: imageWidth,
                imageHeight: imageHeight,
                selectedModel: selectedModel,
                selectedScheduler: selectedScheduler,
                tile: tile,
                shuffle: shuffle,
                upscale: upscale
            }))
        } catch (error) {
            console.error("Error saving prompt: ", error)
        }
    }

    useEffect(() => {
        if (onceTime === false) {
            // retainPrompt()
            setOnceTime(true)
        } else {
            retainPrompt()
        }
    }, [submitPrompt, enhancePrompt, seed, negativeKeywords, steps, guidance, imageCount, imageWidth, imageHeight, selectedModel, selectedScheduler, tile, shuffle, upscale])


    // Function to save user changes to cosyflow values in IndexedDB
    const saveCosyflowChanges = async (fieldKey, fieldValue) => {
        // Allow saving for all models now that they all use cosyflows
        // For base64 data, only log a preview to avoid console overflow
        const isBase64 = typeof fieldValue === 'string' && fieldValue.length > 1000 && fieldValue.includes('base64');
        const logValue = isBase64 ? `[BASE64 DATA - ${fieldValue.length} chars]` : fieldValue;

        console.log('[saveCosyflowChanges] Saving field change:', { fieldKey, fieldValue: logValue, model: selectedModel });

        try {
            // Get the current cosyflow from IndexedDB using indexed lookup
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();

            if (matchingCosyflow) {
                // Update the specific field's default value
                const updatedData = { ...matchingCosyflow.data };

                // Ensure variables exist
                if (!updatedData.variables) {
                    updatedData.variables = {};
                }

                // Update the field's default value
                if (updatedData.variables[fieldKey]) {
                    updatedData.variables[fieldKey] = {
                        ...updatedData.variables[fieldKey],
                        default: fieldValue
                    };
                    
                    // Log if this is an image field being saved
                    const fieldType = updatedData.variables[fieldKey].type;
                    if (fieldType === 'b64data' || fieldType === 'IMAGE' || fieldType === 'file' || fieldType === 'b64') {
                        console.log(`[saveCosyflowChanges] Saving image field ${fieldKey} with type ${fieldType}`);
                    }
                } else {
                    // If field doesn't exist in variables, create it with current promptMapping structure
                    const fieldMapping = promptMappings[fieldKey];
                    if (fieldMapping) {
                        updatedData.variables[fieldKey] = {
                            ...fieldMapping,
                            default: fieldValue
                        };
                    } else {
                        // Create a new field for b64data if no mapping exists
                        console.log(`[saveCosyflowChanges] Creating new field ${fieldKey} for b64data`);
                        updatedData.variables[fieldKey] = {
                            type: 'b64data',
                            default: fieldValue
                        };
                    }
                }

                // Update the record in IndexedDB
                await db.cosyflows.update(matchingCosyflow.id, {
                    data: updatedData,
                    timestamp: Date.now()
                });

                console.log('[saveCosyflowChanges] Successfully saved changes to IndexedDB');
                
                // Log specific success for image fields
                if (isBase64) {
                    console.log(`[saveCosyflowChanges] Successfully saved image data for field: ${fieldKey}`);
                }

                // Optional: Show save indicator
                setSaveStatus('saved');
                setTimeout(() => setSaveStatus(''), 2000);
            } else {
                console.warn('[saveCosyflowChanges] Cosyflow not found in IndexedDB for model:', selectedModel);
                console.log('[saveCosyflowChanges] Creating new cosyflow record for model:', selectedModel);

                // Create a new cosyflow record structure
                const newCosyflowData = {
                    title: selectedModel,
                    variables: {}
                };

                // Build variables from promptMappings
                Object.entries(promptMappings).forEach(([key, mapping]) => {
                    newCosyflowData.variables[key] = {
                        ...mapping,
                        default: mapping.default !== undefined ? mapping.default : null
                    };
                });

                // Set the current field's value
                if (newCosyflowData.variables[fieldKey]) {
                    newCosyflowData.variables[fieldKey].default = fieldValue;
                } else {
                    // If field doesn't exist in promptMappings, create it
                    // Check if this is b64data based on the value
                    const isB64 = typeof fieldValue === 'string' && fieldValue.length > 1000 && fieldValue.includes('base64');
                    newCosyflowData.variables[fieldKey] = {
                        type: isB64 ? 'b64data' : (typeof fieldValue === 'number' ? 'FLOAT' : 'STRING'),
                        default: fieldValue
                    };
                    
                    if (isB64) {
                        console.log(`[saveCosyflowChanges] Creating new b64data field: ${fieldKey}`);
                    }
                }

                // Add the new record to IndexedDB
                try {
                    await db.cosyflows.add({
                        data: newCosyflowData,
                        timestamp: Date.now()
                    });
                    console.log('[saveCosyflowChanges] Successfully created new cosyflow record');
                    setSaveStatus('saved');
                    setTimeout(() => setSaveStatus(''), 2000);
                } catch (error) {
                    console.error('[saveCosyflowChanges] Error creating new cosyflow record:', error);
                    setSaveStatus('error');
                    setTimeout(() => setSaveStatus(''), 2000);
                }
            }
        } catch (error) {
            console.error('[saveCosyflowChanges] Error saving changes:', error);
            setSaveStatus('error');
            setTimeout(() => setSaveStatus(''), 2000);
        }
    };

    // Debounced version of save function for better performance
    const debouncedSaveCosyflowChanges = useCallback(
        debounce((fieldKey, fieldValue) => {
            saveCosyflowChanges(fieldKey, fieldValue);
        }, 500),
        [selectedModel, promptMappings]
    );

    // Function to fetch the latest seed value from IndexedDB for the current model
    const fetchLatestSeedFromDB = async (seedFieldKey = null) => {
        try {
            console.log('[fetchLatestSeedFromDB] Starting fetch:', {
                model: selectedModel,
                seedFieldKey: seedFieldKey,
                timestamp: Date.now()
            });

            // Validate model is selected
            if (!selectedModel) {
                console.warn('[fetchLatestSeedFromDB] No model selected, returning default');
                return '0';
            }

            // Use indexed lookup for O(log n) performance instead of O(n)
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(stripLocalSuffix(selectedModel)).first();
            console.log('[fetchLatestSeedFromDB] Looking for cosyflow with model:', stripLocalSuffix(selectedModel));

            if (!matchingCosyflow) {
                console.log('[fetchLatestSeedFromDB] No cosyflow found for model:', selectedModel);
                return '0';
            }

            if (!matchingCosyflow.data.variables) {
                console.log('[fetchLatestSeedFromDB] No variables found in cosyflow data');
                return '0';
            }

            // If specific seed field key is provided, look for that first
            if (seedFieldKey && matchingCosyflow.data.variables[seedFieldKey]) {
                const seedValue = String(matchingCosyflow.data.variables[seedFieldKey].default || '0');
                console.log(`[fetchLatestSeedFromDB] Found specific seed field '${seedFieldKey}' with value:`, seedValue);
                return seedValue;
            }

            // Otherwise, find any seed field
            const seedFields = [];
            for (const [key, variable] of Object.entries(matchingCosyflow.data.variables)) {
                if (key.toLowerCase().includes('seed') && !key.endsWith('_mode')) {
                    seedFields.push({ key, value: variable.default });
                }
            }

            console.log('[fetchLatestSeedFromDB] Found seed fields:', seedFields);

            if (seedFields.length > 0) {
                // If seedFieldKey was provided but not found, log a warning
                if (seedFieldKey) {
                    console.warn(`[fetchLatestSeedFromDB] Requested field '${seedFieldKey}' not found, using first seed field`);
                }
                const seedValue = String(seedFields[0].value || '0');
                console.log(`[fetchLatestSeedFromDB] Using seed field '${seedFields[0].key}' with value:`, seedValue);
                return seedValue;
            }

            console.log('[fetchLatestSeedFromDB] No seed fields found in variables');
            return '0';
        } catch (error) {
            console.error('[fetchLatestSeedFromDB] Error fetching seed:', error);
            return '0';
        }
    };

    // Helper function to generate random 64-bit seed
    /* global BigInt */
    const generateRandomSeed = () => {
        // Generate a random 64-bit number using BigInt
        const randomBytes = new Uint8Array(8);
        crypto.getRandomValues(randomBytes);
        // Convert bytes to BigInt
        let randomBigInt = 0n;
        for (let i = 0; i < 8; i++) {
            randomBigInt = (randomBigInt << 8n) | BigInt(randomBytes[i]);
        }
        // Ensure positive and within 64-bit signed range (0 to 2^63-1)
        const maxInt64 = (1n << 63n) - 1n;
        randomBigInt = randomBigInt & maxInt64;
        return randomBigInt.toString();
    };

    const handleRecommendedSettings = async (model = selectedModel) => {
        latestRequestedModelRef.current = model;
        console.log('[handleRecommendedSettings] Latest requested model set to:', model);

        // Strip __local_ suffix for DB/API lookups (they use original model names)
        const modelForLookup = stripLocalSuffix(model);
        const isLocalModel = model !== modelForLookup; // true if model had __local_ suffix
        console.log('[handleRecommendedSettings] Model for lookups:', modelForLookup, 'isLocal:', isLocalModel);

        const offlineMode = await getActiveOfflineMode(promptusAPIState);

        if (latestRequestedModelRef.current !== model) {
            console.log('[handleRecommendedSettings] Model changed during offlineMode check, aborting for:', model);
            return;
        }

        setModelTransitioning(true);
        setSchemaLoading(true);
        setSchemaLoaded(false);
        setCosyflowNotFound(false);
        console.log('[handleRecommendedSettings] Setting modelTransitioning to true, schema loading started');

        // Start performance tracking
        const startTime = performance.now();
        const timings = {};

        //console.log(db.table('recommendedSettings').schema.indexes)
        //console.log(typeof selectedModel)
        console.log("MODEL: ", model + " | SELECTED WORKFLOW: " + selectedWorkflow);
        console.log('[PromptHeader] handleRecommendedSettings called for model:', model);
        console.log('🔴 [CRITICAL] handleRecommendedSettings EXECUTING - model:', model);
        console.log(`[TIMING] Function started at: ${new Date().toISOString()}`);

        // Only update selectedModel if it's actually changing
        if (model !== selectedModel) {
            console.log('[PromptHeader] Updating selectedModel from:', selectedModel, 'to:', model);
            setSelectedModel(model);
        } else {
            console.log('[PromptHeader] selectedModel is already:', model, '- not updating');
        }

        let cosyflow_variables = null;

        // ALL models now use cosyflows, not just (cosy) models
        setLogLoading(true);

        // Wrap entire cosyflow loading in try-catch for better error handling
        try {
            const cosyflowStartTime = performance.now();
            console.log("[Cosyflow] Starting cosyflow loading process for model:", model);

            if (!isLocalModel) {
                // Online model path - use IndexedDB + online API
                try {
                    const dbFetchStartTime = performance.now();
                    console.log("[Cosyflow Debug] Looking for model:", modelForLookup);
    
                    // Define normalizeString function for use throughout the matching logic
                    const normalizeString = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    
                    // Declare cosyflowRecords variable in proper scope
                    let cosyflowRecords = null;
    
                    // Try exact match first using indexed lookup (O(log n))
                    let matchingCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();
                    timings.dbFetchDuration = performance.now() - dbFetchStartTime;
                    console.log(`[TIMING] Initial indexed lookup took: ${timings.dbFetchDuration.toFixed(2)}ms`);
    
                    // If no exact match, fall back to full table scan for fuzzy matching
                    if (!matchingCosyflow) {
                        console.log("[Cosyflow Debug] No exact match, falling back to fuzzy matching...");
                        const fallbackStartTime = performance.now();
                        cosyflowRecords = await db.cosyflows.toArray();
    
                        // Debug: Log all available titles
                        console.log("[Cosyflow Debug] Total cosyflows in IndexedDB:", cosyflowRecords.length);
                        console.log("[Cosyflow Debug] All available titles:");
                        cosyflowRecords.forEach((record, index) => {
                            if (record.data && record.data.title) {
                                console.log(`[Cosyflow Debug] ${index}: "${record.data.title}"`);
                            }
                        });
    
                        // Try case-insensitive match
                        console.log("[Cosyflow Debug] Trying case-insensitive match...");
                        matchingCosyflow = cosyflowRecords.find(record =>
                            record.data && record.data.title &&
                            record.data.title.toLowerCase() === modelForLookup.toLowerCase()
                        );
    
                        const fallbackDuration = performance.now() - fallbackStartTime;
                        console.log(`[TIMING] Fallback fuzzy matching took: ${fallbackDuration.toFixed(2)}ms`);
                    }
    
                    // If still no match, try normalized matching (removing special characters)
                    if (!matchingCosyflow && cosyflowRecords) {
                        console.log("[Cosyflow Debug] No case-insensitive match, trying normalized...");
                        const normalizedModel = normalizeString(modelForLookup);
    
                        matchingCosyflow = cosyflowRecords.find(record => {
                            if (record.data && record.data.title) {
                                const normalizedTitle = normalizeString(record.data.title);
                                return normalizedTitle === normalizedModel;
                            }
                            return false;
                        });
                    }
    
                    // If still no match, try without parentheses content
                    if (!matchingCosyflow && cosyflowRecords) {
                        console.log("[Cosyflow Debug] No normalized match, trying without parentheses...");
                        const modelWithoutParens = modelForLookup.replace(/\([^)]*\)/g, '').trim();
                        const modelWithoutParensNorm = normalizeString(modelWithoutParens);
    
                        matchingCosyflow = cosyflowRecords.find(record => {
                            if (!record.data || !record.data.title) return false;
                            const titleWithoutParens = record.data.title.replace(/\([^)]*\)/g, '').trim();
                            const titleWithoutParensNorm = normalizeString(titleWithoutParens);
                            return titleWithoutParensNorm === modelWithoutParensNorm;
                        });
    
                        if (matchingCosyflow) {
                            console.log('[Cosyflow Debug] Found match without parentheses:', matchingCosyflow.data.title);
                        }
                    }
    
                    // If still no match, try partial matching for key model names
                    if (!matchingCosyflow && cosyflowRecords) {
                        console.log("[Cosyflow Debug] No match without parentheses, trying partial match...");
                        // Extract key parts (e.g., "Flux.1-Schnell fp8" from "(AI-Horde) Flux.1-Schnell fp8 (Compact)")
                        const keyParts = modelForLookup.match(/Flux\.?1[^()]*|SDXL[^()]*|stable[^()]*|cascade[^()]*/gi);
                        if (keyParts && keyParts.length > 0) {
                            const keyPart = normalizeString(keyParts[0]);
                            console.log('[Cosyflow Debug] Trying partial match with key part:', keyParts[0]);
    
                            matchingCosyflow = cosyflowRecords.find(record => {
                                if (!record.data || !record.data.title) return false;
                                const titleNorm = normalizeString(record.data.title);
                                return titleNorm.includes(keyPart);
                            });
    
                            if (matchingCosyflow) {
                                console.log('[Cosyflow Debug] Found partial match:', matchingCosyflow.data.title);
                            }
                        }
                    }
    
                    if (matchingCosyflow) {
                        console.log("[Cosyflow Debug] ✅ Found match in IndexedDB");
                        console.log("[Cosyflow Debug] Matched title:", matchingCosyflow.data.title);
                        console.log("Found cosyflow in IndexedDB:", matchingCosyflow);
                        let cosyflow_data = matchingCosyflow.data;
                        
                        // Helper function to validate if a default value matches the field type
                        const isValidDefaultForType = (value, type) => {
                            if (type === undefined || type === null) return true; // Can't validate without type
                            
                            switch(type) {
                                case 'BOOLEAN':
                                case 'boolean':
                                case 'BOOL':
                                case 'bool':
                                    // Boolean fields should only have boolean values
                                    return typeof value === 'boolean' || value === 1 || value === 0 || 
                                           value === 'true' || value === 'false' || value === true || value === false;
                                
                                case 'INT':
                                case 'number':
                                    // Should be a number or numeric string, but not empty string
                                    return !isNaN(value) && value !== '';
                                    
                                case 'FLOAT':
                                    // Should be a number or numeric string, but not empty string
                                    return !isNaN(value) && value !== '';
                                    
                                case 'STRING':
                                case 'prompt':
                                case 'text':
                                    // Strings can be anything
                                    return true;
                                    
                                case 'seed':
                                    // Seeds should be numeric or numeric strings (empty string allowed for seeds)
                                    return !isNaN(value) || value === '';
                                    
                                case 'enum':
                                case 'COMBO':    
                                    // Enum values are typically strings, so accept anything
                                    return true;
                                    
                                case 'b64data':
                                case 'IMAGE':
                                case 'file':
                                case 'b64':
                                    // File/image fields can be empty strings or base64 data
                                    return true;
                                    
                                default:
                                    // For unknown types, accept the value
                                    return true;
                            }
                        };
    
                        // Now check if we need to update the schema from API
                        try {
                            const schemaUpdateStartTime = performance.now();
                            console.log("[Schema Update] ========== STARTING SCHEMA UPDATE CHECK ==========");
                            console.log("[Schema Update] Checking for schema updates from API for model:", model);
                            console.log("[Schema Update] Current schema keys:", cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : 'No variables');
                            // Find record matching this model
                            const record = await db.cosyflows
                                .filter(r => r.data?.title === model)
                                .first();
    
                            if (!record) {
                                console.warn(`[Schema Update] ⚠️ No record found for model: ${model}`);
                                return;
                            }
    
                            // 🔹 Capture old defaults
                            const oldDefaults = {};
                            if (record.data.variables) {
                                for (const [key, obj] of Object.entries(record.data.variables)) {
                                if (obj && typeof obj === "object" && "default" in obj) {
                                    const shortKey = key.includes(".") ? key.split(".")[1] : key;
                                    oldDefaults[shortKey] = obj.default;
                                }
                                }
                            }
    
                            const apiStartTime = performance.now();
                            const apiBase = await getApiBaseUrl();
                            const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(modelForLookup)}`, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${getAuthorizationToken()}`
                                }
                            });
                            timings.apiCallDuration = performance.now() - apiStartTime;
                            console.log(`[TIMING] API call took: ${timings.apiCallDuration.toFixed(2)}ms`);
                            
                            if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                                const cosyflow = response.data.cosyflows[0];
                                if (cosyflow.cosyflow) {
                                  const newCosyflowData = typeof cosyflow.cosyflow === 'string'
                                    ? JSON.parse(cosyflow.cosyflow)
                                    : cosyflow.cosyflow;

                                  console.log("[Schema Update] Cosyflow Data", newCosyflowData);
                                  console.log("[Schema Update] New schema from API keys:", newCosyflowData.variables ? Object.keys(newCosyflowData.variables) : 'No variables');
                                  console.log("[Schema Update] Comparing schemas...");
                                  
                                  // Log differences
                                  const oldKeys = cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : [];
                                  const newKeys = newCosyflowData.variables ? Object.keys(newCosyflowData.variables) : [];
                                  const addedKeys = newKeys.filter(k => !oldKeys.includes(k));
                                  const removedKeys = oldKeys.filter(k => !newKeys.includes(k));
                                  
                                  if (addedKeys.length > 0) console.log("[Schema Update] 🆕 Added fields:", addedKeys);
                                  if (removedKeys.length > 0) console.log("[Schema Update] 🚫 Removed fields:", removedKeys);
                          
                                  // 🔹 Restore defaults into newCosyflowData
                                    if (newCosyflowData.variables) {
                                        console.log("[Schema Update] Checking and preserving valid user defaults from old schema...");
                                        for (const [key, obj] of Object.entries(newCosyflowData.variables)) {
                                        if (obj && typeof obj === "object" && "default" in obj) {
                                            const shortKey = key.includes(".") ? key.split(".")[1] : key;
                                            for (const [oldKey, oldDefault] of Object.entries(oldDefaults)) {
                                            if (shortKey === oldKey) {
                                                // Validate that the old default matches the new field's type
                                                if (isValidDefaultForType(oldDefault, obj.type)) {
                                                    const isBoolean = ['BOOLEAN', 'boolean', 'BOOL', 'bool'].includes(obj.type);
                                                    if (isBoolean) {
                                                        // For boolean fields, use the API default instead of converting old values
                                                        console.log(`[Schema Update] ✅ Using API default for boolean ${key} (type: ${obj.type}): ${obj.default} (ignoring old value: ${oldDefault})`);
                                                        // obj.default remains unchanged from API
                                                    } else {
                                                        console.log(`[Schema Update] ✅ Preserving valid default for ${key} (type: ${obj.type}): ${oldDefault}`);
                                                        obj.default = oldDefault;
                                                    }
                                                } else {
                                                    console.log(`[Schema Update] ⚠️ Rejecting invalid default for ${key} (type: ${obj.type}): "${oldDefault}"`);
                                                    console.log(`[Schema Update] Using new schema's default instead: ${obj.default}`);
                                                    // Don't preserve - let the new schema's default be used
                                                }
                                                break;
                                            }
                                            }
                                        }
                                        }
                                    }
                                
                                    // 🔹 Save updated record
                                    const updateStartTime = performance.now();
                                    await db.cosyflows.update(record.id, {
                                        data: newCosyflowData,
                                        timestamp: Date.now(),
                                    });
                                    timings.dbUpdateDuration = performance.now() - updateStartTime;
                                    console.log(`[TIMING] IndexedDB update took: ${timings.dbUpdateDuration.toFixed(2)}ms`);
                                    
                                    // CRITICAL FIX: Refetch the updated data instead of using old cosyflow_data
                                    console.log("[Schema Update] Refetching updated cosyflow from IndexedDB...");
                                    const updatedRecord = await db.cosyflows.get(record.id);
                                    if (updatedRecord && updatedRecord.data) {
                                        cosyflow_data = updatedRecord.data;
                                        console.log("[Schema Update] ✅ Successfully fetched updated schema");
                                        console.log("[Schema Update] Updated schema keys:", cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : 'No variables');
                                    } else {
                                        console.error("[Schema Update] ⚠️ Failed to refetch updated record!");
                                    }
                          
                                //   console.log(`✅ Successfully updated model: ${modelTitle}`);
                                }
                              }
                              console.log(`[Schema Update] ✅ Successfully completed schema update for model: ${model}`);
                              console.log("[Schema Update] ========== SCHEMA UPDATE COMPLETE ==========");
                              timings.schemaUpdateTotal = performance.now() - schemaUpdateStartTime;
                              console.log(`[TIMING] Total schema update took: ${timings.schemaUpdateTotal.toFixed(2)}ms`);
                            } catch (error) {
                              console.error(`[Schema Update] ❌ Failed to update model: ${model}`, error);
                              console.log("[Schema Update] ========== SCHEMA UPDATE FAILED ==========");
                            }
                        
                        console.log("[Schema Update] Final cosyflow_data being used:", cosyflow_data ? `${Object.keys(cosyflow_data).length} keys` : 'null');
                        console.log("[SAVED VALUES] Loading cosyflow values for model:", model);
                        cosyflow_variables = cosyflow_data.variables;
                        
                        
                        // If schema was updated, we need to ensure the form will re-render with new fields
                        // This is handled by the subsequent setPromptMappings and setDynamic_Inputs calls below
                    } else {
                        console.log("[Cosyflow Debug] ❌ No exact match found for:", model);
    
                        // Debug: Check for similar titles (case-insensitive) - only if we have cosyflowRecords
                        const similarTitles = cosyflowRecords ? cosyflowRecords.filter(record => {
                            if (record.data && record.data.title) {
                                const title = record.data.title.toLowerCase();
                                const searchModel = modelForLookup.toLowerCase();
                                return title.includes(searchModel) || searchModel.includes(title);
                            }
                            return false;
                        }) : [];
    
                        if (similarTitles.length > 0) {
                            console.log("[Cosyflow Debug] Found similar titles:");
                            similarTitles.forEach(record => {
                                console.log(`  - "${record.data.title}"`);
                            });
                        }
    
                        if (!offlineMode.isOffline) {
                            console.log("[Cosyflow] Trying online API ...");
                            const apiBase = await getApiBaseUrl();
                            const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(modelForLookup)}`, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${getAuthorizationToken()}`
                                }
                            });
                            console.log(response);
                            // Check if we got a valid response with cosyflows data
                            if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                                const cosyflow = response.data.cosyflows[0];
                                if (cosyflow.cosyflow) {
                                    const cosyflow_data = typeof cosyflow.cosyflow === 'string'
                                        ? JSON.parse(cosyflow.cosyflow)
                                        : cosyflow.cosyflow;
                                    console.log("Cosyflow Data from API: " + JSON.stringify(cosyflow_data));
                                    cosyflow_variables = cosyflow_data.variables;
                                    // Store in IndexedDB for future use (will be updated with seed values later)
                                    try {
                                        await db.cosyflows.add({
                                            data: cosyflow_data,
                                            timestamp: Date.now()
                                        });
                                        console.log("Stored new cosyflow in IndexedDB for future use");
                                    } catch (storeError) {
                                        console.error("Error storing cosyflow in IndexedDB:", storeError);
                                    }
                                }
                            }
                        } else {
                            console.log("[Cosyflow] Trying localhost API ...");
                            const localhostResponse = await axios.get(
                                `${promptusAPIState.host}/api/generate/get-cosyflow-variables?model=${encodeURIComponent(modelForLookup)}`,
                                { timeout: 5000 }
                            );

                            if (localhostResponse.data?.variables) {
                                console.log("[Cosyflow] Found variables from localhost API:", localhostResponse.data.variables);
                                cosyflow_variables = localhostResponse.data.variables;

                                // Store in IndexedDB for future use (check for existing first)
                                try {
                                    const existingCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();
                                    if (existingCosyflow) {
                                        await db.cosyflows.update(existingCosyflow.id, {
                                            data: { title: modelForLookup, variables: cosyflow_variables },
                                            timestamp: Date.now()
                                        });
                                        console.log("[Cosyflow] Updated existing localhost variables in IndexedDB");
                                    } else {
                                        await db.cosyflows.add({
                                            data: { title: modelForLookup, variables: cosyflow_variables },
                                            timestamp: Date.now()
                                        });
                                        console.log("[Cosyflow] Stored new localhost variables in IndexedDB");
                                    }
                                } catch (storeError) {
                                    if (storeError.name !== 'ConstraintError') {
                                        console.error("[Cosyflow] Error storing localhost variables:", storeError);
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error accessing cosyflows:", error);
                    // If IndexedDB fails, try API as last resort
                    try {
                        const apiBase = await getApiBaseUrl();
                        const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(modelForLookup)}`, {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${getAuthorizationToken()}`
                            }
                        });
                        console.log(response);
    
                        if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                            const cosyflow = response.data.cosyflows[0];
                            if (cosyflow.cosyflow) {
                                const cosyflow_data = typeof cosyflow.cosyflow === 'string'
                                    ? JSON.parse(cosyflow.cosyflow)
                                    : cosyflow.cosyflow;
                                console.log("Cosyflow Data from API (after IndexedDB error): " + JSON.stringify(cosyflow_data));
                                cosyflow_variables = cosyflow_data.variables;
                            }
                        }
                    } catch (apiError) {
                        console.error("API call also failed:", apiError);
    
                        // 3. NEW: Localhost API fallback for offline models
                        try {
                            console.log("[Cosyflow] Trying localhost API fallback...");
                            const localhostResponse = await axios.get(
                                `${promptusAPIState.host}/api/generate/get-cosyflow-variables?model=${encodeURIComponent(modelForLookup)}`,
                                { timeout: 5000 }
                            );

                            if (localhostResponse.data?.variables) {
                                console.log("[Cosyflow] Found variables from localhost API:", localhostResponse.data.variables);
                                cosyflow_variables = localhostResponse.data.variables;

                                // Store in IndexedDB for future use (check for existing first)
                                try {
                                    const existingCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();
                                    if (existingCosyflow) {
                                        await db.cosyflows.update(existingCosyflow.id, {
                                            data: { title: modelForLookup, variables: cosyflow_variables },
                                            timestamp: Date.now()
                                        });
                                        console.log("[Cosyflow] Updated existing localhost variables in IndexedDB");
                                    } else {
                                        await db.cosyflows.add({
                                            data: { title: modelForLookup, variables: cosyflow_variables },
                                            timestamp: Date.now()
                                        });
                                        console.log("[Cosyflow] Stored new localhost variables in IndexedDB");
                                    }
                                } catch (storeError) {
                                    if (storeError.name !== 'ConstraintError') {
                                        console.error("[Cosyflow] Error storing localhost variables:", storeError);
                                    }
                                }
                            }
                        } catch (localhostError) {
                            console.error("[Cosyflow] All methods failed - IndexedDB, online API, and localhost API:", localhostError);
                        }
                    }
                }
            } else {
                // Local model path - use localhost API
                console.log("[Cosyflow] Local model detected, trying localhost API ...");
                const serverInfo = await getServerForModel(modelForLookup);
                console.log("[Cosyflow] Server info for model:", modelForLookup, serverInfo);

                if (serverInfo && (serverInfo.serverType === 'gpu' || serverInfo.serverType === 'cpu')) {
                    console.log(`[Cosyflow] Grabbing default vars for ${serverInfo.serverType} localhost`);
                    try {
                        console.log(`[Cosyflow] Searching for offline GPU/CPU model in DB`);
                        const foundCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();
                        if (foundCosyflow) {
                            console.log(`[Cosyflow] Found data for offline GPU/CPU model in DB: `, foundCosyflow);
                            cosyflow_variables = foundCosyflow.data.variables
                        } else {
                            cosyflow_variables = getOfflineModelVarsFallback(modelForLookup)
                        }
                    } catch (error) {
                        cosyflow_variables = getOfflineModelVarsFallback(modelForLookup)
                    }
                } else if (serverInfo && (serverInfo.serverType === 'cosy')) {
                    const localhostResponse = await axios.get(
                        `${serverInfo.serverUrl}/api/generate/get-cosyflow-variables/${encodeURIComponent(modelForLookup)}`,
                        { timeout: 5000 }
                    );

                    console.log("[Cosyflow] Response from locahost: ", localhostResponse);

                    if (localhostResponse.data) {
                        console.log("[Cosyflow] Found variables from localhost API:", localhostResponse.data);
                        cosyflow_variables = localhostResponse.data;
                        // Store in IndexedDB for future use (check for existing first)
                        try {
                            const existingCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();
                            if (existingCosyflow) {
                                await db.cosyflows.update(existingCosyflow.id, {
                                    data: { title: modelForLookup, variables: cosyflow_variables },
                                    timestamp: Date.now()
                                });
                                console.log("[Cosyflow] Updated existing localhost variables in IndexedDB");
                            } else {
                                await db.cosyflows.add({
                                    data: { title: modelForLookup, variables: cosyflow_variables },
                                    timestamp: Date.now()
                                });
                                console.log("[Cosyflow] Stored new localhost variables in IndexedDB");
                            }
                        } catch (storeError) {
                            if (storeError.name !== 'ConstraintError') {
                                console.error("[Cosyflow] Error storing localhost variables:", storeError);
                            }
                        }
                    }
                }
            }

            console.log("[Cosyflow] cosyflow_variables is:", cosyflow_variables !== null ? "FOUND" : "NULL");
            console.log("[Cosyflow] About to process cosyflow_variables, value:", cosyflow_variables);

            if (cosyflow_variables !== null) {
                console.log("[Cosyflow] Processing cosyflow variables - will set cosyUI to true");
                let new_input_json = {}
                let new_prompt_mappings = {}

                console.log("Cosyflow Data: ", cosyflow_variables);
                for (const key in cosyflow_variables) {
                    if (!excludedKeys.includes(key) && !excludedTypes.includes(cosyflow_variables[key].type)) {
                        console.log(`[SAVED VALUES] Found ${key} with saved value from IndexedDB: ${cosyflow_variables[key].default}`);

                        // Check if this is a seed field (type 'seed')
                        if (cosyflow_variables[key].type === 'seed') {
                            // Always default to 'random' mode for seed fields
                            const modeKey = `${key}_mode`;

                            // Generate a new random seed value
                            const newSeedValue = generateRandomSeed();
                            new_input_json[key] = newSeedValue;
                            new_input_json[modeKey] = 'random';

                            console.log(`Generated new random seed for ${key}: ${newSeedValue}`);
                        } else if (key.endsWith('_mode')) {
                            // Skip _mode fields - they are handled with their corresponding fields
                            console.log(`Skipping ${key} - mode fields are handled separately`);
                        } else {
                            new_input_json[key] = cosyflow_variables[key].default;
                        }

                        new_prompt_mappings[key] = cosyflow_variables[key];
                    }
                }
                console.log(`Cosyflow variables: `, new_prompt_mappings);
                console.log(`[SAVED VALUES] Cosyflow new_input_json with saved values: `, new_input_json);

                // Restore b64data/image fields to uploadedB64Data state
                const b64DataFields = {};
                for (const [key, variable] of Object.entries(cosyflow_variables)) {
                    if (variable.type === 'b64data' || variable.type === 'IMAGE' || 
                        variable.type === 'file' || variable.type === 'b64') {
                        if (variable.default && variable.default !== '') {
                            b64DataFields[key] = variable.default;
                            console.log(`[IMAGE RESTORE] Found saved image for field ${key}, restoring to uploadedB64Data`);
                        }
                    }
                }
                
                // Set the uploaded b64 data if any images were found
                if (Object.keys(b64DataFields).length > 0) {
                    setUploadedB64Data(b64DataFields);
                    console.log(`[IMAGE RESTORE] Restored ${Object.keys(b64DataFields).length} saved image(s) to uploadedB64Data`);
                }

                // Add scheduler field from default mapping if not present in Cosy variables
                // if (!('scheduler' in new_prompt_mappings) && 'scheduler' in default_promptMapping) {
                //     new_prompt_mappings.scheduler = default_promptMapping.scheduler;
                //     new_input_json.scheduler = default_promptMapping.scheduler.default;
                //     console.log('[PromptHeader] Added scheduler to Cosy promptMappings:', {
                //         schedulerOptions: new_prompt_mappings.scheduler.options,
                //         optionsLength: new_prompt_mappings.scheduler.options?.length,
                //         defaultValue: new_input_json.scheduler
                //     });
                // }

                if (latestRequestedModelRef.current !== model) {
                    console.log('[handleRecommendedSettings] Model changed before setting form props, aborting for:', model);
                    return;
                }

                console.log('[DynamicPromptForm Props] ========== SETTING FORM PROPS ==========' );
                console.log('[DynamicPromptForm Props] Setting Cosy promptMappings:', {
                    hasScheduler: 'scheduler' in new_prompt_mappings,
                    schedulerOptions: new_prompt_mappings.scheduler?.options,
                    allKeys: Object.keys(new_prompt_mappings),
                    totalFields: Object.keys(new_prompt_mappings).length
                });
                console.log('[DynamicPromptForm Props] Schema being passed to form:', new_prompt_mappings);
                setPromptMappings(new_prompt_mappings)

                new_input_json.cosyflow = model
                // new_input_json.text1 = ""
                console.log(`NInput JSON: `, new_input_json);
                setInput_json(new_input_json)
                setDynamic_Inputs(new_input_json)

                // Log to verify state updates will trigger re-render
                console.log('[DynamicPromptForm Props] State updates complete. Form should re-render with:', {
                    schemaFieldCount: Object.keys(new_prompt_mappings).length,
                    initialValuesCount: Object.keys(new_input_json).length,
                    timestamp: Date.now()
                });
                console.log(`Input JSON: `, input_json);
                console.log(`[DEBUG] Setting dynamic_inputs with seed_mode:`, new_input_json.seed_mode || 'NOT SET');
                setSelectedWorkflow(model)

                // Force form to reset with the loaded saved values
                // Use a small delay to ensure form is ready
                setTimeout(() => {
                    if (latestRequestedModelRef.current !== model) return;
                    if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                        console.log("[SAVED VALUES] Resetting form with saved values from IndexedDB:", new_input_json);
                        inputGroupRef.current.resetForm(new_input_json);
                    }
                }, 100);

                setOnlineCosyUI(true)
                setCosyUI(true)
                setSelectedWorkflow(model)

                // Save the updated cosyflow with generated seed values back to IndexedDB
                try {
                    // Use indexed lookup for O(log n) performance
                    const matchingCosyflow = await db.cosyflows.where('data.title').equals(modelForLookup).first();

                    if (matchingCosyflow) {
                        // Update the cosyflow with new seed values
                        const updatedData = { ...matchingCosyflow.data };

                        // Update variables with generated values
                        for (const key in new_input_json) {
                            if (updatedData.variables && updatedData.variables[key]) {
                                updatedData.variables[key].default = new_input_json[key];
                            }
                        }

                        // Update the record in IndexedDB
                        await db.cosyflows.update(matchingCosyflow.id, {
                            data: updatedData,
                            timestamp: Date.now()
                        });

                        console.log("Updated cosyflow in IndexedDB with generated seed values");

                        // Force form to reset with the updated values including new seeds
                        // Use a small delay to ensure form is ready
                        setTimeout(() => {
                            if (latestRequestedModelRef.current !== model) return;
                            if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                                console.log("[SAVED VALUES] Resetting form after updating seed values:", new_input_json);
                                inputGroupRef.current.resetForm(new_input_json);
                            }
                        }, 100);
                    }
                } catch (updateError) {
                    console.error("Error updating cosyflow with seed values:", updateError);
                }

                if (latestRequestedModelRef.current !== model) {
                    console.log('[handleRecommendedSettings] Model changed before setLoadedModelData, aborting for:', model);
                    return;
                }

                // Mark that we successfully loaded data for this model
                setLoadedModelData(model);
                console.log('[handleRecommendedSettings] Successfully loaded cosyflow data for model:', model);
            } else {
                console.log("[Cosyflow] ⚠️ ENTERING DEFAULT BRANCH - No cosyflow variables found for the model:", model);

                // Only use default variables for GPU/CPU models when offline
                if (!promptusAPIState.online) {
                    const serverInfo = await getServerForModel(model);
                    console.log("[Cosyflow] Server info for model:", model, serverInfo);

                    if (serverInfo && (serverInfo.serverType === 'gpu' || serverInfo.serverType === 'cpu')) {
                        console.log("[Cosyflow] Creating default cosyflow record for GPU/CPU offline model");
                        console.log("[Cosyflow] Current UI states - cosyUI:", cosyUI, "onlineCosyUI:", onlineCosyUI);

                        // Create a default cosyflow record with standard variables for GPU/CPU models
                        const defaultCosyflowData = {
                            title: model,
                            variables: {
                                "params.count": {
                                    "node_title": "",
                                    "input_title": "No. of images",
                                    "title": "No. of images",
                                    "default": 1,
                                    "type": "INT",
                                    "required": true,
                                    "tooltip": "The number of images to generate.",
                                    "min": 1,
                                    "max": 100,
                                    "importance": 4
                                },
                                "prompt": {
                                    "node_title": "",
                                    "input_title": "Prompt",
                                    "title": "Prompt",
                                    "default": "",
                                    "type": "prompt",
                                    "required": true,
                                    "tooltip": "The text to be encoded.",
                                    "multiline": true,
                                    "dynamic_prompts": true,
                                    "importance": 5
                                },
                                "negative_prompt": {
                                    "node_title": "",
                                    "input_title": "Negative Keywords",
                                    "title": "Negative Keywords",
                                    "default": "",
                                    "type": "prompt",
                                    "required": true,
                                    "tooltip": "The text to be encoded.",
                                    "dynamic_prompts": true,
                                    "importance": 4
                                },
                                "params.seed_value": {
                                    "node_title": "",
                                    "input_title": "Seed",
                                    "title": "Seed",
                                    "default": "",
                                    "type": "STRING",
                                    "required": false,
                                    "tooltip": "The seed used for image generation. Leave blank to use a random value, or fill in a numeric value to reproduce a previous output.",
                                    "importance": 3
                                },
                                "params.num_inference_steps": {
                                    "node_title": "",
                                    "input_title": "Steps",
                                    "title": "Steps",
                                    "default": 20,
                                    "type": "INT",
                                    "required": false,
                                    "tooltip": "The number of steps used in the denoising process.",
                                    "min": 1,
                                    "max": 100,
                                    "importance": 3
                                },
                                "params.guidance_scale": {
                                    "node_title": "",
                                    "input_title": "guidance",
                                    "title": "guidance",
                                    "default": 7.5,
                                    "type": "FLOAT",
                                    "required": false,
                                    "tooltip": "The Classifier-Free Guidance scale balances creativity and adherence to the prompt. Higher values result in images more closely matching the prompt however too high values will negatively impact quality.",
                                    "min": 0,
                                    "max": 20,
                                    "step": 0.1,
                                    "round": 0.01,
                                    "importance": 3
                                },
                                "params.scheduler": {
                                    "node_title": "",
                                    "input_title": "Scheduler",
                                    "title": "Scheduler",
                                    "default": "DPM-Solver",
                                    "type": "enum",
                                    "required": false,
                                    "options": [
                                        "Linear Multistep Scheduler",
                                        "Denoising Diffusion Implicit",
                                        "DPM-Solver",
                                        "Euler 2",
                                        "Pseudo Numerical",
                                        "Denoising Diffusion Probabilistic",
                                        "Ancestral Euler",
                                        "LCM"
                                    ],
                                    "tooltip": "The algorithm used when sampling, this can affect the quality, speed, and style of the generated output.",
                                    "importance": 2
                                },
                                "params.width": {
                                    "node_title": "",
                                    "input_title": "Image width",
                                    "title": "Image width",
                                    "default": 1024,
                                    "type": "INT",
                                    "required": false,
                                    "tooltip": "The width of the latent images in pixels.",
                                    "min": 16,
                                    "max": 16384,
                                    "step": 8,
                                    "importance": 4
                                },
                                "params.height": {
                                    "node_title": "",
                                    "input_title": "Image height",
                                    "title": "Image height",
                                    "default": 1024,
                                    "type": "INT",
                                    "required": false,
                                    "tooltip": "The height of the latent images in pixels.",
                                    "min": 16,
                                    "max": 16384,
                                    "step": 8,
                                    "importance": 4
                                },
                                "params.symmetric": {
                                    "node_title": "",
                                    "input_title": "Symmetric",
                                    "title": "Symmetric",
                                    "default": false,
                                    "type": "BOOLEAN",
                                    "required": false,
                                    "importance": 2
                                },
                                "params.safety_checker": {
                                    "node_title": "",
                                    "input_title": "Safety Checker",
                                    "title": "Safety Checker",
                                    "default": true,
                                    "type": "BOOLEAN",
                                    "style": "safety",
                                    "tooltip": "If enabled, content will be moderated for safety. Disable this setting for uncensored output.",
                                    "required": false,
                                    "importance": 4
                                },
                                "params.tile": {
                                    "node_title": "",
                                    "input_title": "Tile",
                                    "title": "Tile",
                                    "default": false,
                                    "type": "BOOLEAN",
                                    "required": false,
                                    "importance": 2
                                },
                                "params.upscale_factor": {
                                    "node_title": "",
                                    "input_title": "Upscale Factor",
                                    "title": "Upscale Factor",
                                    "default": "0",
                                    "type": "enum",
                                    "required": false,
                                    "options": [
                                        "1",
                                        "2",
                                        "4",
                                        "0"
                                    ],
                                    "importance": 3
                                },
                                "params.model": {
                                    "node_title": "",
                                    "input_title": "Model",
                                    "title": "Model",
                                    "default": model,
                                    "type": "enum",
                                    "required": true,
                                    "options": [
                                        model
                                    ],
                                    "tooltip": "Choose model weights to generate the output image.",
                                    "importance": 2
                                },
                                "prompt_output": {
                                    "node_title": "",
                                    "input_title": "Prompt Output",
                                    "title": "Prompt Output",
                                    "type": "enum",
                                    "required": false,
                                    "options": [
                                        "text-image"
                                    ],
                                    "default": "",
                                    "tooltip": "The transformation to be performed on the input to give the desired output.",
                                    "importance": 2
                                }
                            }
                        };

                        // Store the default cosyflow in IndexedDB
                        try {
                            await db.cosyflows.add({
                                data: defaultCosyflowData,
                                timestamp: Date.now()
                            });
                            console.log("Created default cosyflow record in IndexedDB for model:", model);
                        } catch (storeError) {
                            console.error("Error creating default cosyflow record:", storeError);
                        }

                        // Process the default variables to create form data
                        console.log("[Cosyflow] Processing default cosyflow variables for GPU/CPU model");
                        let new_input_json = {}
                        let new_prompt_mappings = {}

                        const excludedKeys = ['__version__', 'class_type', 'is_changed', '_meta'];
                        const excludedTypes = ['PYOBJ', 'tuple'];

                        console.log("Default variables: ", defaultCosyflowData.variables);
                        for (const key in defaultCosyflowData.variables) {
                            if (!excludedKeys.includes(key) && !excludedTypes.includes(defaultCosyflowData.variables[key].type)) {
                                console.log(`[SAVED VALUES] Setting default value for ${key}: ${defaultCosyflowData.variables[key].default}`);

                                // Check if this is a seed field
                                if (key.includes('seed') || defaultCosyflowData.variables[key].type === 'seed') {
                                    // Generate a new random seed value
                                    const newSeedValue = generateRandomSeed();
                                    new_input_json[key] = newSeedValue;
                                    console.log(`Generated new random seed for ${key}: ${newSeedValue}`);
                                } else {
                                    new_input_json[key] = defaultCosyflowData.variables[key].default;
                                }

                                new_prompt_mappings[key] = defaultCosyflowData.variables[key];
                            }
                        }

                        console.log(`[SAVED VALUES] Default new_input_json: `, new_input_json);
                        console.log(`Default variables prompt mappings: `, new_prompt_mappings);

                        if (latestRequestedModelRef.current !== model) {
                            console.log('[handleRecommendedSettings] Model changed before setting default form props, aborting for:', model);
                            return;
                        }

                        // Set state with default values
                        setPromptMappings(new_prompt_mappings);
                        setDynamic_Inputs(new_input_json);

                        // Set UI state to show dynamic form
                        setOnlineCosyUI(true)
                        setCosyUI(true)
                        setSelectedWorkflow("")

                        // Force form to reset with default values
                        setTimeout(() => {
                            if (latestRequestedModelRef.current !== model) return;
                            if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                                console.log("[SAVED VALUES] Resetting form with default values:", new_input_json);
                                inputGroupRef.current.resetForm(new_input_json);
                            }
                        }, 100);

                        // Mark that we successfully loaded data for this model (even if it's default data)
                        setLoadedModelData(model);
                        console.log('[handleRecommendedSettings] Successfully created default cosyflow for GPU/CPU model:', model);
                    } else {
                        // For online models, cosy models, or when no server info, don't create defaults
                        console.warn('[Cosyflow] No variables found for model and not a GPU/CPU offline model:', model);
                        setCosyflowNotFound(true);
                        setLogLoading(false);
                        setModelTransitioning(false);
                        setSchemaLoading(false);
                        setSchemaLoaded(true);
                        return; // Exit without setting up form
                    }
                } else {
                    // For online models, don't create default variables
                    console.warn('[Cosyflow] No variables found for online model:', model);
                    setCosyflowNotFound(true);
                    setLogLoading(false);
                    setModelTransitioning(false);
                    setSchemaLoading(false);
                    setSchemaLoaded(true);
                    return; // Exit without setting up form
                }
            }

        } catch (error) {
            console.error("[Cosyflow] Fatal error in cosyflow loading:", error);
            console.error("[Cosyflow] Stack trace:", error.stack);
            // Set default values on error
            setCosyUI(false);
            setOnlineCosyUI(false);
        } finally {
            if (latestRequestedModelRef.current === model) {
                setLogLoading(false);
                setModelTransitioning(false);
                setSchemaLoading(false);
                setSchemaLoaded(true);
                console.log('[handleRecommendedSettings] Setting modelTransitioning to false, schema loading completed');

                // Calculate and log total execution time
                const totalTime = performance.now() - startTime;
                console.log('[handleRecommendedSettings] Completed processing for model:', model);
                console.log('[TIMING] ========== PERFORMANCE SUMMARY ==========');
                console.log(`[TIMING] Total execution time: ${totalTime.toFixed(2)}ms`);
                if (timings.apiCallDuration) console.log(`[TIMING]   - API call: ${timings.apiCallDuration.toFixed(2)}ms`);
                if (timings.dbUpdateDuration) console.log(`[TIMING]   - DB update: ${timings.dbUpdateDuration.toFixed(2)}ms`);
                if (timings.schemaUpdateTotal) console.log(`[TIMING]   - Schema update total: ${timings.schemaUpdateTotal.toFixed(2)}ms`);
                console.log('[TIMING] ========================================');

                // Verify what was set
                console.log('[VERIFICATION] Final state set:', {
                    cosyUI: cosyUI,
                    promptMappingsKeys: promptMappings ? Object.keys(promptMappings).length : 0,
                    dynamicInputsKeys: dynamic_inputs ? Object.keys(dynamic_inputs).length : 0
                });
            } else {
                console.log('[handleRecommendedSettings] Model changed during execution, skipping final state updates for:', model);
            }
        }
    };

    const currentModelSelected = () => {
        console.log("Current model selected:", selectedModel);
        // Return the currently selected model formatted for the Select component
        if (!selectedModel) {
            return options && options.length > 0 ? options[0] : { value: "", label: "Select a model" };
        }

        // Find the option that matches the selected model (handles grouped options)
        const modelOption = findModelInOptions(options, selectedModel);

        // If found, return it; otherwise create a new option
        if (modelOption) {
            return modelOption;
        } else {
            return { value: selectedModel, label: selectedModel };
        }
    }

    useEffect(() => {
        if (isUndefined(promptusAPIState.models)) {
            setSelectedModel(options[0])
        }
        // else {
        //     // Don't reset the model if it's a cosy model
        //     if (!promptusAPIState.models.includes(selectedModel) && promptusAPIState.models.length > 0 && promptusAPIState.online && !selectedModel.includes("(cosy)")) {
        //         // setSelectedModel(promptusAPIState.models[0]); // Sets to the first model available if the current selectedModel is not valid
        //         setSelectedModel(getAvailableDefaultModel(options)); // Sets to the first model available if the current selectedModel is not valid

        //     }

        // }
    }, [promptusAPIState.models]);


    useEffect(() => {
        console.log("[UseEffect Model Change] selectedModel:", selectedModel, "type:", typeof selectedModel);
        console.log("[UseEffect Model Change] props.fetchingUndelivered:", props.fetchingUndelivered);

        if (selectedModel && selectedModel.trim() !== '') {
            console.log("[Model Change] Loading recommended settings for:", selectedModel);
            handleRecommendedSettings(selectedModel);
        } else {
            console.log("[Model Change] Skipping - selectedModel is empty or invalid");
        }
    }, [selectedModel]); // Only trigger when selectedModel changes - removed props.fetchingUndelivered to prevent race conditions

    // Load default model data on component mount with a small delay to ensure IndexedDB is ready
    useEffect(() => {
        const loadInitialModelData = async () => {
            // Small delay to ensure IndexedDB is initialized
            await new Promise(resolve => setTimeout(resolve, 100));

            if (selectedModel && selectedModel.trim() !== '') {
                console.log('[Component Mount] Loading initial model data for:', selectedModel);
                await handleRecommendedSettings(selectedModel);
            }
        };

        loadInitialModelData();
    }, []); // Empty dependency array - runs once on mount

    // Handle deep link model
    const [deepLinkProcessed, setDeepLinkProcessed] = useState(false);
    const [pendingDeepLinkModel, setPendingDeepLinkModel] = useState(null);
    const [templateProcessed, setTemplateProcessed] = useState(false);

    // Function to open advanced settings programmatically
    const openAdvancedSettingsForDeepLink = () => {
        if (!settingsOpen && !generateStatus.loading && !cosyUI) {
            // Fetch models first if needed
            fetchUnifiedModels();
            // Open settings
            setSettingsOpen(true);
            // Update driver context
            driverContextDispatch({ type: 'advanced' });
        }
    };

    // Store deep link model if received before models are loaded
    useEffect(() => {
        if (deepLinkModel && !deepLinkProcessed) {
            // Check for filter mode flag and apply it BEFORE model loading
            const filterMode = sessionStorage.getItem('deepLinkFilterMode');
            if (filterMode) {
                console.log("[DeepLink] Setting filter mode to:", filterMode);
                setShowOnlineModels(filterMode === 'online');
                sessionStorage.removeItem('deepLinkFilterMode');
            }

            if (options.length === 0) {
                // Models not loaded yet, store for later
                console.log("Models not loaded yet, storing deep link model for later:", deepLinkModel);
                setPendingDeepLinkModel(deepLinkModel);
                // Trigger model fetch
                fetchUnifiedModels();
            } else {
                // Process immediately if models are loaded
                setPendingDeepLinkModel(null);
            }
        }
    }, [deepLinkModel]);

    // Process deep link when models are loaded
    useEffect(() => {
        // Reset processed flag when deepLinkModel is cleared
        if (!deepLinkModel && !pendingDeepLinkModel && deepLinkProcessed) {
            setDeepLinkProcessed(false);
        }

        const modelToProcess = pendingDeepLinkModel || deepLinkModel;

        if (modelToProcess && options.length > 0 && !deepLinkProcessed) {
            console.log("Deep link model received in PromptHeader:", modelToProcess);

            // Mark as processed immediately to prevent re-runs
            setDeepLinkProcessed(true);

            // Check if the model exists in the available options (handle both flat and grouped)
            const modelExists = modelExistsInOptions(options, modelToProcess);

            if (modelExists) {
                console.log("Setting model from deep link:", modelToProcess);

                const loadDeepLinkModel = async () => {
                    while (modelTransitioning) {
                        console.log("[DeepLink] Waiting for model transition to complete...");
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }

                    console.log("[DeepLink] Setting selectedModel to:", modelToProcess);
                    setSelectedModel(modelToProcess);

                    await new Promise(resolve => setTimeout(resolve, 200));

                    while (modelTransitioning || schemaLoading) {
                        console.log("[DeepLink] Waiting for schema to load...");
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }

                    console.log("[DeepLink] Schema loaded, opening advanced settings");
                    openAdvancedSettingsForDeepLink();
                };
                loadDeepLinkModel();

                // Show notification that model was set
                // Swal.fire({
                //     title: 'Model Selected',
                //     text: `Model "${modelToProcess}" has been selected from deep link`,
                //     icon: 'success',
                //     timer: 3000,
                //     showConfirmButton: false
                // });
            } else {
                console.log("Deep link model not found in available models:", modelToProcess);

                // Open advanced settings to show available models
                setTimeout(() => {
                    openAdvancedSettingsForDeepLink();
                }, 500);

                // Show error notification
                Swal.fire({
                    title: 'Model Not Found',
                    text: `The model "${modelToProcess}" is not available. Using default model instead.`,
                    icon: 'warning',
                    timer: 4000,
                    showConfirmButton: true
                });
            }

            // Clear pending model after processing
            setPendingDeepLinkModel(null);
        }
    }, [deepLinkModel, pendingDeepLinkModel, options, deepLinkProcessed]);

    // Process template data from Templates page
    useEffect(() => {
        if (templateData && !templateProcessed) {
            console.log('Template data received in PromptHeader:', templateData);

            // Mark as processed immediately to prevent re-runs
            setTemplateProcessed(true);

            // Set the prompt
            if (templateData.prompt) {
                setSubmitPrompt(templateData.prompt);
            }

            // Set the model if it exists in options
            if (templateData.model && options.length > 0) {
                const modelExists = modelExistsInOptions(options, templateData.model);
                if (modelExists) {
                    console.log('Setting model from template:', templateData.model);
                    setSelectedModel(templateData.model);
                } else {
                    console.log('Template model not found, using default');
                }
            }

            // Set image width and height
            if (templateData.imageWidth) setImageWidth(templateData.imageWidth);
            if (templateData.imageHeight) setImageHeight(templateData.imageHeight);

            // Set steps
            if (templateData.steps) setSteps(templateData.steps);

            // Set guidance scale
            if (templateData.guidance) setGuidance(templateData.guidance);

            // Set scheduler
            if (templateData.scheduler) setSelectedScheduler(templateData.scheduler);

            // Set negative keywords
            if (templateData.negativeKeywords) setNegativeKeywords(templateData.negativeKeywords);

            // Set uploaded image if present
            if (templateData.uploadedImage) {
                setImage(templateData.uploadedImage);
            }

            // Open advanced settings to show the template configuration
            setTimeout(() => {
                if (!settingsOpen && !generateStatus.loading) {
                    setSettingsOpen(true);
                    driverContextDispatch({ type: 'advanced' });
                }
            }, 300);

            // Show notification
            Swal.fire({
                title: 'Template Applied',
                text: 'Template settings have been applied. You can modify them before generating.',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false
            });
        }

        // Reset processed flag when templateData is cleared
        if (!templateData && templateProcessed) {
            setTemplateProcessed(false);
        }
    }, [templateData, templateProcessed, options]);



    const setMemePromptOptions = (memePrompt) => {
        setMemePrompt(memePrompt)
        console.log("setting model")
        if (promptusAPIState.online && memePrompt) {
            setSettingsOpen(false)
            setSelectedModel("(aimlapi) FLUX.1 schnell");
        }
    };

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);

        if (e.key === "Escape") {
            setOpenHistory(false)
        }
    }

    useEffect(() => {
        if (openHistory) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [openHistory]);


    const clearHistory = async () => {
        console.log("Clear History");
        await db.transaction('rw', db.history, async () => {
            await db.history.clear();
        })
            .then(() => {
                Swal.fire({
                    title: 'History Cleared Succesfully',
                    timer: 2000,
                    showConfirmButton: false
                })
                setOpenHistory(false)
            })
    }

    const fetchWorkflows = async() => {
        if (cosyUI) {
            await getCosyflows(promptusAPIState, generateStatusDispatch)
            .then(async(data) => {
                console.log("Retreived cosyflows data: ", data);
                if (data && !isUndefined(data)) {
                    const installedNodes = data.filter(cosyflow => cosyflow.install_status === 'INSTALLED');
                    const installedTitles = installedNodes.map(cosyflow => cosyflow.title);
                    setAllModels(installedTitles); // Store complete model list for filtering
                    const optionsWithCost = await buildOptionsWithCost(installedTitles);
                    setOptions(optionsWithCost);

                    // Preload cosyflow data for optimized filtering (non-blocking)
                    preloadCosyflowData().then(cache => {
                        setModelMediaTypeMap(cache);
                        console.log(`[CACHE] Successfully loaded ${cache.size} model mappings for optimized filtering`);
                    }).catch(error => {
                        console.error('[CACHE] Failed to preload cosyflow data:', error);
                    });

                    if (testCheck) {
                        // Try weighted selection from default models first (using dynamic models from IndexedDB or fallback)
                        const installedTitles = installedNodes.map(n => n.title);
                        const availableDefaultsWeighted = effectiveDefaultModels.filter(item =>
                            installedTitles.includes(item.name)
                        );

                        let selectedModel;
                        if (availableDefaultsWeighted.length > 0) {
                            selectedModel = selectWeightedRandom(availableDefaultsWeighted);
                            console.log(`[RANDOM MODEL SELECT] Weighted selection from defaults: ${selectedModel}`);
                            console.log(`[RANDOM MODEL SELECT] Available weighted options:`, availableDefaultsWeighted.map(i => `${i.name} (${i.weight})`));
                        } else {
                            // Fallback to equal probability from all installed models if no defaults available
                            const idx = Math.floor(Math.random() * installedNodes.length);
                            selectedModel = installedNodes[idx].title;
                            console.log(`[RANDOM MODEL SELECT] Fallback random from installed: ${selectedModel}`);
                        }

                        setSelectedModel(selectedModel);
                        // Removed direct handleRecommendedSettings call - useEffect will handle it
                        setTestCheck(false)
                    }
                }
                // setOptions(data.map(cosyflow => ({ value: cosyflow.title, label: cosyflow.title })))
                // const values = data.map(cosyflow => {
                //     return cosyflow.title
                // })
                // console.log(values);
                // const morevals = values.map((workflow, index) => {
                //     return workflow
                // })
                // console.log(morevals);
                // setAllWorkflows(data.map(cosyflow => cosyflow.title))
            })
        } else {
            setAllWorkflows([])
            console.log("No cosyflows found")
        }
        // console.log("Comfy workflows: ", workflows);
        // // setAllWorkflows(workflows)
        // setAllWorkflows(workflows.map(workflow => ({ value: workflow, label: workflow })))
    }


    const excludedKeys = []
    const excludedTypes = ["model"]

    const handleWorkflow = async (cosyflowName = selectedWorkflow) => {
        console.log(`Fetching Cosyflow data for ${cosyflowName}`);
        let new_input_json = {}
        let new_prompt_mappings = {}

        await getCosyflowData(cosyflowName, promptusAPIState, generateStatusDispatch)
            .then((data) => {
                console.log("Cosyflow Data: " + JSON.stringify(data));
                for (const key in data) {
                    console.log(`Found ${key} with default value: ${data[key].default}`);
                    if (!excludedKeys.includes(key) && !excludedTypes.includes(data[key].type)) {
                        console.log(`Found ${key} with default value: ${data[key].default}`);

                        // Check if this is a seed field (type 'seed')
                        if (data[key].type === 'seed') {
                            // Always default to 'random' mode for seed fields
                            const modeKey = `${key}_mode`;

                            // Generate a new random seed value
                            const newSeedValue = generateRandomSeed();
                            new_input_json[key] = newSeedValue;
                            new_input_json[modeKey] = 'random';

                            console.log(`Generated new random seed for ${key}: ${newSeedValue}`);
                        } else if (key.endsWith('_mode')) {
                            // Skip _mode fields - they are handled separately
                            console.log(`Skipping ${key} - mode fields are handled separately`);
                        } else {
                            new_input_json[key] = data[key].default;
                        }

                        new_prompt_mappings[key] = data[key];
                    }

                }
            })
        setPromptMappings(new_prompt_mappings)

        new_input_json.cosyflow = cosyflowName
        // new_input_json.text1 = ""
        console.log(`NInput JSON: ${JSON.stringify(new_input_json)}`);
        setInput_json(new_input_json)
        setDynamic_Inputs(new_input_json)
        console.log(`Input JSON: ${JSON.stringify(input_json)}`);
        setSelectedWorkflow(cosyflowName)

        // ✅ Force form to reset to new input values
        if (inputGroupRef.current) {
            console.log("Resetting form with new_input_json:", new_input_json);
            inputGroupRef.current.resetForm(new_input_json);
        }
    }

    const handleNumChange = (e) => {
        let newValue = e.target.value;

        // Remove leading zeros but allow the user to type
        if (newValue.startsWith("0")) {
            newValue = newValue.replace(/^0+/, "") || "0"; // Keep at least "0" if all characters are removed
        }

        setImageCount(newValue);
    };

    const handleNumImages = () => {
        let numValue = parseInt(imageCount, 10); // Convert to number, removing leading zeros

        if (isNaN(numValue) || numValue <= 0) {
            numValue = 1; // Ensure the number is never less than or equal to 0
        }

        setImageCount(numValue);

    }

    const handleRemoveImage = () => {
        setImage(null);
        setControlNet("");
        setMaskImage(null);
        setInPaint(false);
        setPromptOutput("text-image");
        driverContextDispatch({ type: 'advanced' });
        setImageNets("");
    }

    const test_startRecording = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);

        mediaRecorder.ondataavailable = (event) => {
            audioChunksRef.current.push(event.data);
        };

        mediaRecorder.onstop = () => {
            const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
            setAudioBlob(blob);
            setAudioURL(URL.createObjectURL(blob));
            audioChunksRef.current = [];
        };

        mediaRecorder.start();
        mediaRecorderRef.current = mediaRecorder;
        setRecording(true);
    };

    const test_stopRecording = () => {
        console.log(`Stopping recording`);

        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);

            if (!audioBlob) return;

            const reader = new FileReader();
            reader.readAsDataURL(audioBlob);
            reader.onloadend = () => {
                const base64Audio = reader.result; // you can send this to your API
                console.log("Base64 audio:", base64Audio);
            };
        }
    };

    const convertToBase64 = () => {
        if (!audioBlob) return;

        const reader = new FileReader();
        reader.readAsDataURL(audioBlob);
        reader.onloadend = () => {
            const base64Audio = reader.result; // you can send this to your API
            console.log("Base64 audio:", base64Audio);
        };
    };

    useEffect(() => {
        if (image) {
            setMaskImage(null)
        }
    }, [image])

    const location = useLocation();

    useEffect(() => {
        // Handle prompt history navigation
        if (location.state?.prompt) {
            setSubmitPrompt(location.state.prompt);
            if (location.state.seed) {
                setSeed(location.state.seed);
            }
        }
    }, [location]);

    // Handle cosyflow selection from Templates page navigation
    useEffect(() => {
        if (location.state?.selectedCosyflow) {
            const cosyflow = location.state.selectedCosyflow;
            console.log('[PromptHeader] Received selected cosyflow from navigation:', cosyflow.title);

            setSelectedModel(cosyflow.title);

            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    // After the other useEffects but before the return statement
    useEffect(() => {
        // This effect runs once when component mounts
        console.log("PromptHeader mounted, checking for images");

        // Check for images in collection context
        if (collectionContext.collectionImage) {
            console.log("Found image in collection context on mount:", collectionContext.collectionImage);
            // Handle different forms of the collection image
            if (typeof collectionContext.collectionImage === 'string') {
                setImage(collectionContext.collectionImage);
            } else if (collectionContext.collectionImage.image && typeof collectionContext.collectionImage.image === 'string') {
                setImage(collectionContext.collectionImage.image);
            } else {
                console.log("Unknown collectionImage format:", collectionContext.collectionImage);
            }
        }

        // Check for image data in localStorage
        const transferActive = localStorage.getItem('image_transfer_active');
        if (transferActive === 'true') {
            const imageData = localStorage.getItem('temp_image_data');
            if (imageData) {
                console.log("Found image data in localStorage");
                setImage(imageData);

                // Also update the driver mode for image usage
                driverContextDispatch({ type: 'controlNet' });

                // Clear the localStorage flags once used
                localStorage.removeItem('image_transfer_active');
                localStorage.removeItem('temp_image_data');
                localStorage.removeItem('image_transfer_timestamp');
            }
        }
    }, []);

    useEffect(() => {
        // Check if there's a model selected from an image click
        const selectedModelFromImage = localStorage.getItem('selected_model');
        if (selectedModelFromImage) {
            console.log("Setting model from localStorage:", selectedModelFromImage);

            // Ensure we have the models fetched before trying to select one
            (async () => {
                // If we don't have models loaded yet, fetch them
                if (!promptusAPIState.models || promptusAPIState.models.length === 0) {
                    console.log("Fetching models before setting selected model");
                    await fetchUnifiedModels();
                }

                // Set the model directly
                setSelectedModel(selectedModelFromImage);

                // Manually set up the options if they don't exist yet
                if (!options || options.length === 0) {
                    setOptions([{ value: selectedModelFromImage, label: selectedModelFromImage }, ...(options || [])]);
                } else if (!modelExistsInOptions(options, selectedModelFromImage)) {
                    // Add this model to options if it doesn't exist
                    setOptions([{ value: selectedModelFromImage, label: selectedModelFromImage, isLocal: false }, ...options]);
                }

                // Don't automatically open advanced settings when model is selected from image
                // User can manually open if they want to see/change the model
                // if (!settingsOpen) {
                //     setSettingsOpen(true);
                //     driverContextDispatch({type: 'advanced'});
                // }

                // Removed direct handleRecommendedSettings call - useEffect will handle it when selectedModel changes
                console.log("Model selected from image:", selectedModelFromImage);

                // Clear the localStorage item after using it
                localStorage.removeItem('selected_model');
            })();
        }
    }, []);

    // Listen for model selection events from CollectionImage component
    useEffect(() => {
        const handleModelSelectedEvent = (event) => {
            console.log("Received modelSelected event:", event.detail);
            const modelName = event.detail.model;

            if (modelName) {
                // Make sure modelName is a string
                const modelString = typeof modelName === 'string' ? modelName : String(modelName);

                // Set the model directly
                setSelectedModel(modelString);

                // Ensure the model is in options
                if (!modelExistsInOptions(options, modelString)) {
                    console.log("Adding model to options:", modelString);
                    setOptions([{ value: modelString, label: modelString, isLocal: false }, ...options]);
                }

                // Don't automatically open advanced settings when model is selected from image
                // User can manually open if they want to see/change the model
                // if (!settingsOpen) {
                //     setSettingsOpen(true);
                //     driverContextDispatch({type: 'advanced'});
                // }

                // Removed direct handleRecommendedSettings call - useEffect will handle it when selectedModel changes
            }
        };

        // Add event listener
        window.addEventListener('modelSelected', handleModelSelectedEvent);

        // Clean up event listener
        return () => {
            window.removeEventListener('modelSelected', handleModelSelectedEvent);
        };
    }, [options, settingsOpen]);

    // Check for model selection pending flag
    useEffect(() => {
        // Function to check if there's a pending model selection
        const checkForPendingModelSelection = () => {
            if (localStorage.getItem('model_selection_pending') === 'true') {
                // Clear the flag immediately to prevent multiple processing
                localStorage.removeItem('model_selection_pending');

                // Get the most recent model key (they're timestamped)
                const keys = Object.keys(localStorage).filter(key => key.startsWith('selected_model_'));

                if (keys.length > 0) {
                    // Sort keys by timestamp (newest first)
                    keys.sort().reverse();

                    // Get the model from the most recent key
                    const modelValue = localStorage.getItem(keys[0]);

                    if (modelValue) {
                        // Ensure we have a simple string
                        let modelName = modelValue;

                        // If it's a JSON object, try to parse it and extract the model name
                        if (modelValue.startsWith('{') && modelValue.endsWith('}')) {
                            try {
                                const parsed = JSON.parse(modelValue);
                                if (parsed.model) {
                                    modelName = parsed.model;
                                }
                            } catch (e) {
                                console.error("Error parsing model JSON:", e);
                            }
                        }

                        console.log("Found pending model selection:", modelName);

                        // Set the model
                        setSelectedModel(modelName);

                        // Don't automatically open advanced settings when model is selected from image
                        // User can manually open if they want to see/change the model
                        // if (!settingsOpen) {
                        //     setSettingsOpen(true);
                        //     driverContextDispatch({type: 'advanced'});
                        // }

                        // Clean up all temporary model keys
                        keys.forEach(key => localStorage.removeItem(key));
                    }
                }
            }
        };

        // Check immediately
        checkForPendingModelSelection();

        // Set up interval to check periodically (every 1 second)
        const intervalId = setInterval(checkForPendingModelSelection, 1000);

        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
    }, [settingsOpen]);

    // Listen for prompt update events from CollectionImage component (Re-adding simplified version)
    useEffect(() => {
        const handlePromptUpdateEvent = (event) => {
            console.log("Received promptUpdated event:", event.detail);
            const promptText = event.detail.prompt;

            if (promptText && typeof promptText === 'string') {
                // Update the submitPrompt state directly
                console.log("Setting submitPrompt state to:", promptText);
                setSubmitPrompt(promptText);
            }
        };

        // Add event listener for custom event
        window.addEventListener('promptUpdated', handlePromptUpdateEvent);

        // Clean up event listener
        return () => {
            window.removeEventListener('promptUpdated', handlePromptUpdateEvent);
        };
    }, []); // Keep dependencies empty to only set up listener once

    // Add useEffect to load profile photo from localStorage
    useEffect(() => {
        const storedPhoto = localStorage.getItem("profilePhoto");
        if (storedPhoto) {
            setProfilePhoto(storedPhoto);
        }
    }, []);

    // Update profile photo when localStorage changes
    useEffect(() => {
        const handleStorageChange = () => {
            const storedPhoto = localStorage.getItem("profilePhoto");
            setProfilePhoto(storedPhoto || "");
        };

        // Listen for custom event from Profile page
        const handleProfilePhotoChange = () => {
            const storedPhoto = localStorage.getItem("profilePhoto");
            setProfilePhoto(storedPhoto || "");
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('profilePhotoChanged', handleProfilePhotoChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('profilePhotoChanged', handleProfilePhotoChange);
        };
    }, []);

    // // Handle clicks outside advanced settings to close it
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (advancedSettingsRef.current && !advancedSettingsRef.current.contains(event.target)) {
    //             setSettingsOpen(false);
    //             driverContextDispatch({ type: 'reset' });
    //         }
    //     };

    //     if (settingsOpen) {
    //         document.addEventListener('mousedown', handleClickOutside);
    //         return () => {
    //             document.removeEventListener('mousedown', handleClickOutside);
    //         };
    //     }
    // }, [settingsOpen, driverContextDispatch]);

    const stableSchema = useMemo(() => promptMappings, [promptMappings]);
    const stableDefaults = useMemo(() => {
        console.log('[PromptHeader] Creating stableDefaults:', {
            scheduler: dynamic_inputs.scheduler,
            hasScheduler: 'scheduler' in dynamic_inputs,
            seed_mode: dynamic_inputs.seed_mode,
            allKeys: Object.keys(dynamic_inputs),
            fullDynamicInputs: dynamic_inputs
        });

        // Ensure any seed_mode fields are set to 'random' if they're 'fixed'
        const cleanedDefaults = { ...dynamic_inputs };
        Object.keys(cleanedDefaults).forEach(key => {
            if (key.endsWith('_mode') && key.includes('seed')) {
                // Always force seed_mode to 'random'
                console.log(`[PromptHeader] Forcing ${key} to 'random' (was: '${cleanedDefaults[key]}')`);
                cleanedDefaults[key] = 'random';
            }
        });

        return cleanedDefaults;
    }, [dynamic_inputs]);

        // Emit schema changes to inform other components about available fields
        useEffect(() => {
            const currentSchema = cosyUI ? promptMappings : stableSchema;
            let hasImageField = false;
            
            // Check if schema has any image input fields
            for (const [key, field] of Object.entries(currentSchema || {})) {
                // Check various ways an image field might be defined
                if (field.type === 'file' ||
                    field.type === 'b64' ||
                    field.type === 'b64data' ||
                    field.type === 'image' ||
                    (field.type === 'url' && field.image_upload === true) ||  // URL fields with image_upload flag
                    field.url_allowed === true ||              // b64data fields with URL support
                    key.toLowerCase().includes('image') ||
                    key.toLowerCase().includes('img') ||
                    (field.label && field.label.toLowerCase().includes('image')) ||
                    (field.accept && field.accept.includes('image'))) {
                    hasImageField = true;
                    console.log(`[PromptHeader] Found image field: ${key} with type: ${field.type}${field.url_allowed ? ' (URL allowed)' : ''}${field.image_upload ? ' (image_upload)' : ''}`);
                    break;
                }
            }
            
            // Emit the schema state
            eventBus.emit('schemaUpdate', { 
                hasImageField,
                isCosyUI: cosyUI,
                schema: currentSchema
            });
            
            console.log('[PromptHeader] Schema update emitted:', {
                hasImageField,
                isCosyUI: cosyUI,
                schemaKeys: Object.keys(currentSchema || {})
            });
        }, [cosyUI, promptMappings, stableSchema]);

        // Listen for schema requests from components that mount after initial emit
        useEffect(() => {
            const currentSchema = cosyUI ? promptMappings : stableSchema;
            const handleRequestSchema = () => {
                let hasImageField = false;
                for (const [key, field] of Object.entries(currentSchema || {})) {
                    if (field.type === 'file' || field.type === 'b64' || field.type === 'b64data' ||
                        field.type === 'image' || (field.type === 'url' && field.image_upload === true) ||
                        field.url_allowed === true || key.toLowerCase().includes('image') ||
                        key.toLowerCase().includes('img') ||
                        (field.label && field.label.toLowerCase().includes('image')) ||
                        (field.accept && field.accept.includes('image'))) {
                        hasImageField = true;
                        break;
                    }
                }
                console.log('[PromptHeader] Schema requested, emitting current schema');
                eventBus.emit('schemaUpdate', { hasImageField, isCosyUI: cosyUI, schema: currentSchema });
            };
            eventBus.on('requestSchema', handleRequestSchema);
            return () => eventBus.off('requestSchema', handleRequestSchema);
        }, [cosyUI, promptMappings, stableSchema]);

    const tester = () =>{
        console.log("tester", inputGroupRef.current.getValues());
        
    }

    const selectDefaultMediaModel = async (mediaType) => {
        console.log(`[MEDIA TYPE] Switching to media type: ${mediaType}`);

        setActiveMediaType(mediaType);
        setFilteringLoading(true);

        try {
            const isUnified = allModels.length > 0 && typeof allModels[0] === 'object' && 'mediaType' in allModels[0];

            let filteredModels;
            if (mediaType === 'all') {
                filteredModels = allModels;
            } else if (isUnified) {
                filteredModels = allModels.filter(m => m.mediaType === mediaType);
                console.log(`[MEDIA TYPE] Filtered ${allModels.length} → ${filteredModels.length} for ${mediaType}`);
            } else if (allModels.length > 0) {
                filteredModels = await filterModelsByMediaTypeOptimized(allModels, mediaType, modelMediaTypeMap, setModelMediaTypeMap);
            } else {
                filteredModels = [];
            }

            if (filteredModels.length > 0) {
                const filteredNames = filteredModels.map(m => getModelName(m));

                if (isUnified) {
                } else {
                    const sortedFilteredModels = customSort(filteredNames);
                    const optionsWithCost = await buildOptionsWithCost(sortedFilteredModels);
                    setOptions(optionsWithCost);
                }

                if (mediaType === 'all') {
                    if (!selectedModel || !filteredNames.includes(selectedModel)) {
                        setSelectedModel(getAvailableDefaultModel(filteredNames.map(m => ({ value: m, label: m })), promptusAPIState.online, effectiveDefaultModels));
                    }
                } else if (mediaType === 'audio') {
                    const audioModel = filteredNames.find(model =>
                        DEFAULT_AUDIO_MODEL.some(d => model.includes(d.replace(/[()]/g, '')))
                    ) || filteredNames[0];
                    setSelectedModel(audioModel);
                } else if (mediaType === 'video') {
                    const videoModel = filteredNames.find(model =>
                        DEFAULT_VIDEO_MODEL.some(d => model.includes(d.replace(/[()]/g, '')))
                    ) || filteredNames[0];
                    setSelectedModel(videoModel);
                } else {
                    setSelectedModel(getAvailableDefaultModel(filteredNames.map(m => ({ value: m, label: m })), promptusAPIState.online, effectiveDefaultModels));
                }
            } else {
                console.warn(`[MEDIA TYPE] No models found for ${mediaType}`);
                if (mediaType === 'audio') setSelectedModel(DEFAULT_AUDIO_MODEL[0]);
                else if (mediaType === 'video') setSelectedModel(DEFAULT_VIDEO_MODEL[0]);
            }
        } catch (error) {
            console.error(`[MEDIA TYPE] Error filtering for ${mediaType}:`, error);
        } finally {
            setFilteringLoading(false);
        }
        setSettingsOpen(true);
    }

    const startVoiceRecord = () => {
        console.log('[VOICE_RECORD] Starting');
        setRecording(true)
        startRecording()
    }

    const stopVoiceRecord = () => {
        console.log('[VOICE_RECORD] Stopping');
        setRecording(false)
        stopRecording()
    }

    return (
        <header
            className={`${driverContext.isActive ? '' : 'sticky'} top-0 grid grid-cols-4 sm:grid-cols-9 gap-1.5 mobile:gap-2 m-1 mobile:m-2 mt-4 z-10 ${isDraggingPromptFile ? 'ring-4 ring-yellow ring-opacity-75 bg-yellow/10' : ''}`}
            onKeyDown={handleKeyDown}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <LoginModal
                    isOpen={showLoginModal}
                    onClose={() => setShowLoginModal(false)}
                    onLoginSuccess={(userData) => {
                        console.log('User logged in:', userData);
                        // Continue with generation after login
                        setShowLoginModal(false);
                        //   handleGenerate(); // Call your generate function again
                    }}
                    promptMessage="Please log in to start generating"
                />
            {generateStatus.status === 'canceling' ? <div className={"w-full col-span-full text-white bg-red-900 rounded-lg p-4"}>Cancelling Prompt</div> : null}
            {(generateStatus.status === 'error' && generateStatus.message) ? <div className={"w-full col-span-full text-white bg-red-900 rounded-lg p-4"}>{generateStatus.message}</div> : null}
            <button className="border-2 border-cyan/50 rounded-lg min-middle:hidden col-span-1 p-1 cursor-pointer" onClick={() => eventBus.emit('show_nav_menu')}><img src={Logo} className="mx-auto text-black w-10 h-10" /></button>
            <div className="flex md:flex-row col-span-3 sm:col-span-8 header-containers-prompt:col-span-9 xl:col-span-5 max-xl:col-span-4 gap-1 mobile:gap-2 md:gap-0">
                <label className="sr-only" htmlFor="prompt">Enter your Prompt</label>
                <input type="text" name="prompt" value={submitPrompt} onChange={(e) => setSubmitPrompt(e.target.value)}
                    onKeyUp={(e) => (e.key === 'Enter' && !generateStatus.loading) ? handleSubmitPrompt() : null}
                    className="text-base mobile:text-xl w-full rounded-lg md:rounded-tr-none md:rounded-br-none py-2 mobile:py-3 px-3 mobile:px-5 text-dark-blue shadow-xl border-0"
                    id="prompt"
                    placeholder="Enter your prompt here..." required />
                {/* <div id="record" className="h-full">
                    <button className={"bg-white text-dark-blue text-4xl h-full"} onClick={recording ? stopVoiceRecord : startVoiceRecord} >
                        {recording ?
                            <StopRecordingIcon className="h-full" alt="Stop Record Icon" />
                            :
                            <RecordingIcon className="h-full" alt="Record Icon" />
                        }
                    </button>
                </div> */}

                <button id="history" className={"bg-white text-dark-blue text-4xl h-full px-2"} onClick={() => setOpenHistory(true)}>
                    <HistoryIcon alt='Open History' className='h-10 mobile:h-14' />
                </button>
                <button
                    type="submit"
                    onClick={handleTagModal}
                    id="generate"
                    disabled={jobRequestPending || props.fetchingUndelivered || schemaLoading}
                    className={`rounded-lg md:rounded-tl-none md:rounded-bl-none py-2 mobile:py-3 px-3 mobile:px-5 shadow-xl font-bold text-base mobile:text-xl uppercase transition-all duration-300
                        ${(jobRequestPending || schemaLoading) ? 'bg-gray-400 cursor-wait' : 'bg-yellow hover:bg-yellow-500'}
                        ${props.fetchingUndelivered ? 'opacity-80 pointer-events-none' : ''}
                    `}
                >
                    {jobRequestPending ? (
                        <div className="flex items-center justify-center">
                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                            </svg>
                        </div>
                    ) : schemaLoading ? (
                        <div className="flex items-center justify-center text-sm">
                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                            </svg>
                            Loading Model...
                        </div>
                    ) : (
                        'Generate'
                    )}
                </button>
                {/* {generateStatus.loading || generateStatus.status === "generate" ?
                    <button type="submit" onClick={() => {
                        props.cancelPrompt();
                    }}
                            className={`rounded-lg md:rounded-tl-none md:rounded-bl-none bg-red-800 py-3 px-5 shadow-xl font-bold text-xl uppercase}`}>Cancel
                    </button>
                    :
                    <button type="submit" onClick={handleTagModal} id="generate"
                            className={`rounded-lg md:rounded-tl-none md:rounded-bl-none bg-yellow py-3 px-5 shadow-xl ${props.fetchingUndelivered? 'opacity-80 pointer-events-none' : null} font-bold text-xl uppercase`}>Generate
                    </button>
                } */}
                {/* <button className="flex flex-col lg:flex-row items-center justify-center w-20 rounded-lg font-bold ml-1 p-1 gap-2 group bg-white text-dark-purple transition"
                    onClick={help}>
                    <HowToIconActive className={"block w-full"} alt={`Icon for Quick Tour`} />
                </button> */}
            </div>

            <div id="enhance" className={"bg-dark-blue/80 flex flex-col rounded-xl place-content-center place-items-center gap-1 mobile:gap-2 px-2 mobile:px-4 sm:px-8 py-2 mobile:py-3 sm:py-4 h-full col-span-1 sm:col-span-1 header-containers:col-span-2 border border-cyan/50"}>
                <button
                    onClick={handleEnhancePromptClick}
                    disabled={generateStatus.loading || isEnhancing}
                    className={`px-2 mobile:px-4 py-2 rounded-lg text-center font-bold text-xs mobile:text-sm transition-all duration-300 flex items-center justify-center gap-1 mobile:gap-2 w-full h-full ${
                        enhanceSuccess
                            ? 'bg-green-500 text-white'
                            : isEnhancing
                                ? 'bg-yellow/70 text-dark-purple cursor-wait'
                                : 'bg-yellow text-dark-purple hover:bg-yellow/80'
                    } ${(generateStatus.loading || isEnhancing) ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                    {isEnhancing ? (
                        <>
                            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            <span>Enhancing...</span>
                        </>
                    ) : enhanceSuccess ? (
                        <>
                            <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Enhanced!</span>
                        </>
                    ) : (
                        <span>Enhance Prompt</span>
                    )}
                </button>
            </div>
            <div id="meme"
                className={"bg-dark-blue/80 flex flex-row sm:flex-col rounded-xl place-content-center place-items-center gap-1 mobile:gap-2 p-2 h-full col-span-1 sm:col-span-1 header-containers:col-span-2 border border-cyan/50"}>
                <ToggleInput onChange={(e) => setMemePromptOptions(e.target.checked)} checked={memePrompt} disabled={generateStatus.loading} />
                <span className="font-bold text-xs mobile:text-sm sm:text-base xl:whitespace-nowrap text-white transition">Meme</span>
            </div>
            <div id="online" className={"bg-dark-blue/80 flex flex-row sm:flex-col rounded-xl place-content-center place-items-center gap-1 mobile:gap-2 p-2 h-full col-span-1 sm:col-span-1 header-containers:col-span-2 border border-cyan/50"}>
                <ToggleInput onChange={(e) => setShowOnlineModels(e.target.checked)} checked={showOnlineModels} disabled={generateStatus.loading} />
                <span className={`font-bold text-xs mobile:text-sm sm:text-lg xl:whitespace-nowrap ${showOnlineModels ? 'text-yellow' : 'text-white'} transition`}>{showOnlineModels ? 'Online' : 'Local'}</span>
            </div>
            <div id="tokens" className={"bg-dark-blue/80 flex flex-row sm:flex-col items-center justify-center gap-2 rounded-xl px-4 py-2 h-full col-span-1 sm:col-span-1 header-containers:col-span-2 border border-cyan/50"}>
                {accountContext.loggedIn ?
                    <div className="flex items-center sm:mb-1">
                        {profilePhoto ? (
                            <div
                                className="w-8 h-8 rounded-full overflow-hidden border-2 border-amber-500 cursor-pointer hover:opacity-80 transition-opacity"
                                onClick={() => navigate("/profile")}
                            >
                                <img
                                    src={profilePhoto}
                                    alt="Profile"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ) : (
                            <AccountIcon className="w-8 h-8 cursor-pointer hover:opacity-80 transition-opacity" alt="Promptus Account Icon" onClick={() => navigate("/profile")} />
                        )}
                    </div>
                    :
                    null
                }
                <div className="flex flex-row items-center gap-2">
                    <TokenIcon className="w-6 h-6" alt={"Promptus Token Icon"} />
                    <span className={"font-bold text-base text-yellow"}>
                        {accountContext.loggedIn ? accountContext.tokens : 0}
                    </span>
                </div>
            </div>        
            {isFreeUser() && !electronBridge.isElectron ?
                <div className={`bg-yellow/90 rounded-xl col-span-full p-5 backdrop-blur text-center font-semibold text-lg text-border-black`}>
                    You are on a Free plan. Upgrade for more videos, offline unrestricted generations and ComfyUI features without limits. 
                    {/* <a href={`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`} target="_blank" className="font-bold underline">Upgrade</a> */}
                    <a onClick={() => navigate('/profile')} className="font-bold underline">Upgrade</a>
                    .
                </div>
            : 
                null    
            }
            <div ref={advancedSettingsRef} className="col-span-full contents">
                <div className="col-span-full min-lg-inclusive:col-span-2 bg-dark-blue/80 rounded-xl backdrop-blur border border-cyan/50 flex overflow-hidden">
                    <button
                        className={`px-1 mobile:px-3 py-2 mobile:py-3 w-1/4 transition duration-200 flex items-center justify-center gap-1 font-medium text-xs mobile:text-sm ${
                            filteringLoading
                                ? 'bg-gray-600 text-gray-400 border-r border-gray-500 cursor-not-allowed'
                                : activeMediaType === 'all'
                                ? 'bg-cyan/20 text-yellow border-r border-cyan/30'
                                : 'hover:bg-cyan/10 text-white border-r border-cyan/20'
                        }`}
                        onClick={() => !filteringLoading && selectDefaultMediaModel('all')}
                        disabled={filteringLoading}
                    >
                        <span className={`text-base mobile:text-lg ${activeMediaType === 'all' ? 'text-white' : 'text-yellow'}`}><LayoutGridIcon /></span>
                        All
                    </button>
                    <button
                        className={`px-1 mobile:px-3 py-2 mobile:py-3 w-1/4 transition duration-200 flex items-center justify-center gap-1 font-medium text-xs mobile:text-sm ${
                            filteringLoading
                                ? 'bg-gray-600 text-gray-400 border-r border-gray-500 cursor-not-allowed'
                                : activeMediaType === 'image'
                                ? 'bg-cyan/20 text-yellow border-r border-cyan/30'
                                : 'hover:bg-cyan/10 text-white border-r border-cyan/20'
                        }`}
                        onClick={() => !filteringLoading && selectDefaultMediaModel('image')}
                        disabled={filteringLoading}
                    >
                        <span className={`text-base mobile:text-lg ${activeMediaType === 'image' ? 'text-white' : 'text-yellow'}`}><ImageIcon /></span>
                        Image
                    </button>
                    <button
                        className={`px-1 mobile:px-3 py-2 mobile:py-3 w-1/4 transition duration-200 flex items-center justify-center gap-1 font-medium text-xs mobile:text-sm ${
                            filteringLoading
                                ? 'bg-gray-600 text-gray-400 border-r border-gray-500 cursor-not-allowed'
                                : activeMediaType === 'video'
                                ? 'bg-cyan/20 text-yellow border-r border-cyan/30'
                                : 'hover:bg-cyan/10 text-white border-r border-cyan/20'
                        }`}
                        onClick={() => !filteringLoading && selectDefaultMediaModel('video')}
                        disabled={filteringLoading}
                    >
                        <span className={`text-base mobile:text-lg ${activeMediaType === 'video' ? 'text-white' : 'text-yellow'}`}><VideoIcon /></span>
                        Video
                    </button>
                    <button
                        className={`px-1 mobile:px-3 py-2 mobile:py-3 w-1/4 transition duration-200 flex items-center justify-center gap-1 font-medium text-xs mobile:text-sm ${
                            filteringLoading
                                ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                                : activeMediaType === 'audio'
                                ? 'bg-cyan/20 text-yellow'
                                : 'hover:bg-cyan/10 text-white'
                        }`}
                        onClick={() => !filteringLoading && selectDefaultMediaModel('audio')}
                        disabled={filteringLoading}
                    >
                        <span className={`text-base mobile:text-lg ${activeMediaType === 'audio' ? 'text-white' : 'text-yellow'}`}><MusicIcon /></span>
                        Audio
                    </button>
                </div>
                <div className={`bg-dark-blue/80 rounded-xl col-span-full min-lg-inclusive:col-span-7 px-2 mobile:px-5 backdrop-blur h-auto transition border border-cyan/50`}>
                    <button className={`w-full flex flex-row items-center justify-center gap-1 mobile:gap-2 text-sm mobile:text-lg transition duration-300 p-1 lg:p-2`} onClick={handleAdvancedSettings}>Generation Settings:<span className="text-yellow font-bold capitalize">{controlnetDisplay}</span>
                        <span className={`text-yellow font-bold capitalize ${imageNets === "" ? 'hidden' : ''}`}>{imageNets}</span>
                        <AdvancedSettingsIcon className={`${settingsOpen ? 'rotate-0' : 'rotate-180'} transition duration-300`} alt={"Advanced Settings Icon"} /></button>
                </div>
                <div className={`bg-dark-blue/80 rounded-xl col-span-full max-h-screen overflow-y-auto ${driverContext.isActive ? '' : 'backdrop-blur'}`}>
                    <AnimatePresence initial={false}>
                        <motion.div
                            animate="open"
                            initial="collapsed"
                            variants={{
                                open: { opacity: 1, height: "auto", },
                                collapsed: { opacity: 0, height: 0, }
                            }}
                            exit={"collapsed"}
                            transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
                            className={`${settingsOpen ? 'grid' : 'hidden'} gap-2 mt-1 lg:mt-2 ${cosyUI ? '' : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-10'}`}>
                            {console.log("[Select Render] cosyUI:", cosyUI, "- Rendering", cosyUI ? "cosy" : "standard", "Select component")}
                                <>
                                    <div className="col-span-full p-5 overflow-y-visible">
                                            <>
                                                <AnimatedInputGroup
                                                    id="model"
                                                    className={`relative w-[100%] md:w-[55%] xl:w-[35%] mb-10 ${driverContext.isActive ? 'text-black' : ''}`}
                                                >
                                                    <div>
                                                        <label htmlFor={"Model"}
                                                            className="flex flex-row justify-content-between mb-2 text-sm font-medium" >Model
                                                        <InfoIcon title="Model Input" className="h-6 justify-self-end" />
                                                        </label>
                                                        <Select
                                                            value={(() => {
                                                                const validModel = selectedModel && selectedModel.trim() !== '' ? selectedModel : null;
                                                                if (!validModel) return undefined;

                                                                // Handle both flat and grouped options
                                                                let foundOption = null;
                                                                if (Array.isArray(options)) {
                                                                    for (const item of options) {
                                                                        if (item.options) {
                                                                            // Grouped option
                                                                            foundOption = item.options.find(opt => opt.value === validModel);
                                                                            if (foundOption) break;
                                                                        } else if (item.value === validModel) {
                                                                            // Flat option
                                                                            foundOption = item;
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                return foundOption || { value: validModel, label: validModel };
                                                            })()}
                                                            options={Array.isArray(filteredOptions) ? filteredOptions : []}
                                                            components={{ ...animatedComponents, MenuList: CustomMenuList, Option: CustomOption }}
                                                            formatGroupLabel={formatGroupLabel}
                                                            formatOptionLabel={(option, { context }) => {
                                                                if (context === 'value') {
                                                                    return (
                                                                        <div className="flex justify-between items-center w-full">
                                                                            <span className="truncate flex-1 mr-2">{option.label}</span>
                                                                            {option.isLocal && (
                                                                                <span className="text-xs bg-yellow text-dark-blue px-1.5 py-0.5 rounded ml-2">LOCAL</span>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }
                                                                return (
                                                                    <div className="flex justify-between items-center w-full">
                                                                        <span>{option.label}</span>
                                                                        {option.isLocal && (
                                                                            <span className="text-xs bg-yellow text-dark-blue px-1.5 py-0.5 rounded">LOCAL</span>
                                                                        )}
                                                                        {!option.isLocal && option.cost !== undefined && option.cost !== null && (
                                                                            <span className="text-xs text-gray-400">{option.cost >= 1 ? Math.round(option.cost) : option.cost} tokens</span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }}
                                                            onChange={(selectedOption) => {
                                                                console.log("[Select onChange - CosyUI] Selected option:", selectedOption);
                                                                if (selectedOption && selectedOption.value) {
                                                                    console.log("[Select onChange - CosyUI] Setting selectedModel to:", selectedOption.value);
                                                                    setSelectedModel(selectedOption.value);
                                                                    // handleRecommendedSettings will be called by useEffect when selectedModel changes
                                                                } else {
                                                                    console.warn("[Select onChange - CosyUI] No valid option selected");
                                                                }
                                                            }}
                                                            isLoading={logLoading || modelTransitioning || filteringLoading}
                                                            className="text-dark-blue"
                                                            placeholder="Select a model..."
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                menu: (base) => ({ ...base, maxHeight: '400px' }),
                                                                menuList: (base) => ({ ...base, maxHeight: '400px' })
                                                            }}
                                                        />
                                                        {/* {onlineState ?
                                                            <button
                                                            onClick={() => setShowCosyflowsGallery(true)}
                                                            className="w-full bg-yellow hover:bg-yellow/90 text-dark-blue font-bold py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 shadow-lg mt-4"
                                                            >
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                                </svg>
                                                                Browse Workflows Gallery
                                                            </button>
                                                        :
                                                            null
                                                        }     */}
                                                    </div>
                                                </AnimatedInputGroup>
                                            </>
                                        <div className="flex flex-row flex-wrap gap-5">
                                            {/* Show loader when fetching model data, otherwise show the form */}
                                            {(logLoading || modelTransitioning) ? (
                                                <DynamicInputsSkeleton />
                                            ) : cosyflowNotFound ? (
                                                <div className="w-full p-6 bg-red-500/10 border border-red-500/30 rounded-lg">
                                                    <div className="flex items-start gap-3">
                                                        <svg className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                                        </svg>
                                                        <div>
                                                            <h4 className="text-red-400 font-semibold mb-1">Model Configuration Not Found</h4>
                                                            <p className="text-gray-300 text-sm">
                                                                Could not load the configuration for "<span className="text-yellow">{selectedModel}</span>".
                                                                This model may not be available or its settings could not be retrieved.
                                                            </p>
                                                            <p className="text-gray-400 text-xs mt-2">
                                                                Try selecting a different model or check your internet connection.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <DynamicPromptForm
                                                        key="cosy-form"
                                                        schema={promptMappings}
                                                        initialValues={(() => {
                                                            console.log('[PromptHeader] Passing to DynamicPromptForm (Cosy path):', {
                                                                scheduler: dynamic_inputs.scheduler,
                                                                schemaHasScheduler: 'scheduler' in promptMappings,
                                                                schemaScheduler: promptMappings.scheduler,
                                                                allDefaults: dynamic_inputs,
                                                                allSchemaKeys: Object.keys(promptMappings)
                                                            });
                                                            return dynamic_inputs;
                                                        })()}
                                                        ref={inputGroupRef}
                                                        isComfyUIModel={cosyUI}
                                                        selectedModel={selectedModel}
                                                        onFieldChange={debouncedSaveCosyflowChanges}
                                                        onFetchLatestSeed={fetchLatestSeedFromDB}
                                                        uploadedB64Data={uploadedB64Data}
                                                        onB64Upload={(key, value) => {
                                                            setUploadedB64Data(prev => ({ ...prev, [key]: value }));
                                                        }}
                                                        onClearUploadedData={(key) => {
                                                            setUploadedB64Data(prev => {
                                                                const newData = { ...prev };
                                                                delete newData[key];
                                                                return newData;
                                                            });
                                                        }}
                                                    />
                                                    {/* Save status indicator for cosy models */}
                                                    {cosyUI && saveStatus && (
                                                        <div className={`fixed bottom-4 right-4 px-4 py-2 rounded-lg text-white text-sm font-medium transition-all duration-300 ${saveStatus === 'saved' ? 'bg-green-600' : 'bg-red-600'
                                                            }`}>
                                                            {saveStatus === 'saved' ? '✓ Settings saved' : '✗ Error saving'}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        {/* Restore Defaults button for cosyUI models */}
                                        {cosyUI && (
                                            <div className="flex justify-between mt-4">
                                                <button
                                                    className="border-2 rounded uppercase px-5 py-2 bg-blue-500/50 hover:bg-blue-500/70 font-bold transition"
                                                    onClick={handleRestoreDefaults}
                                                >
                                                    Restore Defaults
                                                </button>
                                                <button
                                                    type="submit"
                                                    onClick={handleTagModal}
                                                    id="generate"
                                                    disabled={jobRequestPending || props.fetchingUndelivered || schemaLoading}
                                                    className={`rounded-lg py-3 px-5 shadow-xl font-bold text-xl uppercase transition-all duration-300
                                                        ${(jobRequestPending || schemaLoading) ? 'bg-gray-400 cursor-wait' : 'bg-yellow hover:bg-yellow-500'}
                                                        ${props.fetchingUndelivered ? 'opacity-80 pointer-events-none' : ''}
                                                    `}
                                                >
                                                    {jobRequestPending ? (
                                                        <div className="flex items-center justify-center">
                                                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                                            </svg>
                                                        </div>
                                                    ) : schemaLoading ? (
                                                        <div className="flex items-center justify-center text-sm">
                                                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                                            </svg>
                                                            Loading Model...
                                                        </div>
                                                    ) : (
                                                        'Generate'
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                        {/* <button onClick={testInputGroupRef}>TESTING</button> */}
                                    </div>
                                </>
                            {image ?
                                <>
                                    <AnimatedInputGroup
                                        className={"col-span-8 flex flex-col items-center justify-between"}>
                                        <div className={"flex flex-col md:flex-row gap-2 w-full"}>
                                            <div id="imgtoimg" className={"flex flex-row items-center flex-grow"}>
                                                <ToggleInput id={"imageImage"} onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setPromptOutput("image-image");
                                                        setUpScale(0)
                                                        setControlNet("");
                                                        setPix2Pix(false);
                                                    } else {
                                                        setPromptOutput("text-image");
                                                        setImageNets("")
                                                    }
                                                }} checked={promptOutput === "image-image"} />
                                                <label htmlFor={"imageImage"}
                                                    className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Image to Image</label>
                                            </div>
                                            <div id="inimg" className={"flex flex-row items-center flex-grow"}>
                                                <ToggleInput id={"imageInPaint"} onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setPromptOutput("image-in-paint")
                                                        setUpScale(0)
                                                        setControlNet("");
                                                        setPix2Pix(false);
                                                    } else {
                                                        setPromptOutput("text-image");
                                                        setImageNets("")
                                                    }
                                                }} checked={promptOutput === "image-in-paint"} />
                                                <label htmlFor={"imageInPaint"}
                                                    className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-in-paint" ? 'text-yellow' : 'text-gray-400'} transition`}>In-Paint Image</label>
                                            </div>
                                            <div id="guided" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"Pix2Pix"} onChange={(e) => {
                                                    setControlNet("");
                                                    setPix2Pix(e.target.checked);
                                                    setUpScale(0)
                                                    setPromptOutput("text-image");
                                                    setImageNets("Guided")
                                                    setSelectedModel("instruct-pix2pix")
                                                    if (!e.target.checked) {
                                                        setImageNets("")
                                                    }
                                                }} checked={pix2pix} />
                                                <label htmlFor={"Pix2Pix"}
                                                    className={`inline-block ml-2 text-sm font-medium ${pix2pix ? 'text-yellow' : 'text-gray-400'} transition`}>Guided</label>
                                            </div>
                                            <div className={"flex flex-col w-full p-2 border rounded"}>
                                                <div className={"text-xs py-2"}>Control Nets</div>
                                                <div className={"flex flex-row gap-2"}>
                                                    <div id="pose" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"PoseToImage"} onChange={(e) => handleControlNetToggle(e.target.checked, "pose-to-image")} checked={(controlNet === "pose-to-image")} />
                                                        <label htmlFor={"PoseToImage"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "pose-to-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Pose to Image</label>
                                                    </div>
                                                    <div id="canny" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"Canny"} onChange={(e) => handleControlNetToggle(e.target.checked, "canny")} checked={(controlNet === "canny")} />
                                                        <label htmlFor={"Canny"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "canny" ? 'text-yellow' : 'text-gray-400'} transition`}>Canny</label>
                                                    </div>
                                                    <div id="scribble" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"Scribble"} onChange={(e) => handleControlNetToggle(e.target.checked, "scribble")} checked={(controlNet === "scribble")} />
                                                        <label htmlFor={"Scribble"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "scribble" ? 'text-yellow' : 'text-gray-400'} transition`}>Scribble</label>
                                                    </div>
                                                    <div id="straight" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"StraightLines"} onChange={(e) => handleControlNetToggle(e.target.checked, "mlsd")} checked={(controlNet === "mlsd")} />
                                                        <label htmlFor={"StraightLines"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "mlsd" ? 'text-yellow' : 'text-gray-400'} transition`}>Straight Lines</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AnimatedInputGroup>
                                    <AnimatedInputGroup
                                        className={"flex place-items-center justify-center lg:row-span-2"}
                                    >
                                        <button className={"border-2 rounded uppercase px-5 py-2 bg-red-500 font-bold m-1"} onClick={handleRemoveImage}>Remove Image</button>
                                    </AnimatedInputGroup>
                                    {!generateStatus.loading ?
                                        <>
                                            <AnimatedInputGroup
                                                className={"flex place-items-center justify-center lg:row-span-2"}
                                            >
                                                <button className={"border-2 rounded uppercase px-5 py-2 bg-white/20 font-bold m-1"} onClick={handleClearParams}>clear</button>
                                            </AnimatedInputGroup>
                                        </>
                                        : null}
                                </>
                                : null}
                        </motion.div>
                        {/* {settingsOpen && (
                    )} */}
                    </AnimatePresence>
                </div>
            </div>
            {inPaint ?
                <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                    <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-end"}>
                        <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setInPaint(false)}>
                            <CloseIcon alt='Close Image' className='h-7' />
                        </button>
                    </div>
                    <DrawingInput image={image && image.includes(":\\") ? toFileUrl(image) : `data:image/*;base64,${image}`} isMask={!!image} setImage={image ? setMaskImage : setImage} closeEvent={() => setInPaint(false)} />
                </div> : null}
            {openHistory ?
                // <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                //     <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-between items-center"}>
                //         <h1 className={"text-2xl text-white px-4 font-bold drop-shadow"}>Prompt History</h1>
                //         <div className="flex flex-row">
                //             <button className={"py-2 px-4 m-2 rounded bg-red-600 transition"} onClick={clearHistory}>Delete All</button>
                //             <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setOpenHistory(false)}>
                //                 <CloseIcon alt='Close Image' className='h-7'/>
                //             </button>
                //         </div>
                //     </div>
                //     <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt}/>
                // </div>
                <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt} />
                : null}
            <Modal open={open} onClose={() => setOpen(false)} center >
                <h2 className="text-2xl mb-5 font-bold">Tag</h2>
                <p>
                    Please type in a tag to easily sort out your images
                </p>
                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Tag</label>
                    <input type="text" name="tag" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Tag"
                        value={inputTag} onChange={(e) => setInputTag(e.target.value)} />
                </div>
                <div className="flex flex-row items-center">
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                    <h1 className="mx-4 font-bold text-xl">OR</h1>
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                </div>
                <p>
                    Please select an existing tag to easily sort out your images
                </p>
                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Tag</label>
                    <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-full"} value={tag} onChange={(e) => setTag(e.target.value)}>
                        <option></option>
                        {Array.isArray(collectionContext?.tags) && collectionContext.tags.map((category, i) => (
                            <option key={i} value={`${category}`}>{category}</option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-row justify-center gap-4">
                    <button onClick={addTagToImage} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">Categorize</button>
                    <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                </div>
            </Modal>

            {/* Cosyflows Gallery Modal - only render when needed */}
            {showCosyflowsGallery && (
                <CosyflowsGallery
                    isOpen={showCosyflowsGallery}
                    onClose={() => setShowCosyflowsGallery(false)}
                    onSelectCosyflow={(cosyflow) => {
                        console.log('[PromptHeader] Cosyflow selected from gallery:', cosyflow.title);
                        // The CosyflowsGallery already emits the selectModel event via eventBus
                    }}
                />
            )}
        </header>
    );
};

export function helpOverlays(e, driver) {
    // Help Overlay
    e.stopPropagation();

    const steps = [
        {
            // Step 1
            element: '#prompt',
            popover: {
                title: 'Prompt Input',
                description: 'You will type in a prompt to generate an image with this input.',
                position: 'bottom'
            }
        },
        {// Step 2
            element: '#record',
            popover: {
                title: 'Record',
                description: 'This button will be used to record your voice for a voice prompt then after stopping the recording you will be given the chance to edit anything in the prompt input before generating',
                position: 'bottom'
            }
        },
        {// Step 3
            element: '#history',
            popover: {
                title: 'History',
                description: 'This button will show the history of other inputs you have made',
                position: 'bottom'
            }
        },
        {// Step 4
            element: '#upload',
            popover: {
                title: 'Upload',
                description: 'Here you can upload a image you have generated or an image of your own',
                position: 'bottom'
            }
        },
        {// Step 5
            element: '#edit',
            popover: {
                title: 'Masking',
                description: 'Here you will add a mask to your uploaded image to add/change whatever is in your mask',
                position: 'bottom'
            }
        },
        {// Step 6
            element: '#generate',
            popover: {
                title: 'Generate',
                description: 'Once you are finish with making your prompt, clicking this button will start generating your prompt',
                position: 'bottom'
            }
        },
        {// Step 7
            element: '#enhance',
            popover: {
                title: 'Enhance Prompt',
                description: 'This toggle will make your prompt more detailed to generate a more detailed image',
                position: 'bottom'
            }
        },
        {
            element: '#meme',
            popover: {
                title: 'Meme Prompt',
                description: 'This toggle will turn your prompt into a meme styled image',
                position: 'bottom'
            }
        },
        {
            element: '#online',
            popover: {
                title: 'Online/Offline Toggle',
                description: 'This toggle will switch you to online or offline depending on what you would like to generate on',
                position: 'bottom'
            }
        },
        {// Step 9
            element: '#tokens',
            popover: {
                title: 'Tokens',
                description: 'The tokens decreases everytime you successfully generate a image and you buy tokens to generate more images',
                position: 'left'
            }
        },
        {// Step 10
            element: '#seeds',
            popover: {
                title: 'Seeds',
                description: 'A unique seed number that is generated for each result of the prompt generated.',
                position: 'bottom'
            }
        },
        {// Step 11
            element: '#negative',
            popover: {
                title: 'Negative Keywords',
                description: 'Negative keywords refer to specific terms or phrases that you want to exclude from the generated images. ',
                position: 'bottom'
            }
        },
        {// Step 12
            element: '#steps',
            popover: {
                title: 'Steps',
                description: 'This slider will indicate how detailed you want the image to be the higher you go',
                position: 'bottom'
            }
        },
        {// Step 13
            element: '#guidance',
            popover: {
                title: 'Guidance',
                description: 'This Guidance Scale is a measurement tool used to assess the level of complexity and abstractness of the generated images.This scale ranges from 0 to 20, with higher numbers indicating more complex and abstract images.',
                position: 'bottom'
            }
        },
        {// Step 14
            element: '#number',
            popover: {
                title: 'Number Of Images',
                description: 'You can specify the number of images you would like to generate. This can range from 1 to a large number, depending on the processing power of the source and your preferences.',
                position: 'bottom'
            }
        },
        {// Step 15
            element: '#size',
            popover: {
                title: 'Image Size',
                description: 'You can specify the image size you would like the images to be generated at.',
                position: 'bottom'
            }
        },
        {// Step 16
            element: '#model',
            popover: {
                title: 'Models',
                description: 'The Model is a component of the AI image creation system that selects and processes data to generate images. It samples data from various sources, including image databases, algorithms, and user input, to produce final images. The Model is crucial in determining the quality, complexity, and overall appearance of the generated images and can vary in terms of quality and generation speed based on the algorithms and data sources used.',
                position: 'bottom'
            }
        },
        {// Step 17
            element: '#scheduler',
            popover: {
                title: 'Scheduler',
                description: 'Schedulers can affect the final image generated by controlling how the model is trained during the image generation process. They essentially control the learning rate or step size of the model as it improves over time, and determine how quickly or slowly the model is allowed to learn and adapt to new data. ',
                position: 'bottom'
            }
        },
        {// Step 18
            element: '#tileshuffle',
            popover: {
                title: 'Tile and Shuffle',
                description: 'When tile is enabled, images are generated as s repeatable pattern and when shuffle is enabled, an AI model is randomly selected when images are generated.',
                position: 'bottom'
            }
        },
        {// Step 19
            element: '#scale',
            popover: {
                title: 'Scale',
                description: 'You can scale an uploaded image by 2/4/8 times it\'s original size',
                position: 'bottom'
            }
        },
        {// Step 21
            element: '#imgtoimg',
            popover: {
                title: 'Image To Image',
                description: 'Using an uploaded image you can change this image using it as the base and the prompt will change it however you want it to',
                position: 'bottom'
            }
        },
        {// Step 22
            element: '#inimg',
            popover: {
                title: 'In-Paint Image',
                description: 'Using the mask on an image or using a scribble, in-painting will fill in the missing parts of the image using your prompt as the missing part to present a complete image',
                position: 'bottom'
            }
        },
        {// Step 23
            element: '#guided',
            popover: {
                title: 'Guided',
                description: 'Guided uses the image uploaded and the masking on it to edit the part of the image you masked with the prompt',
                position: 'bottom'
            }
        },
        {// Step 24
            element: '#pose',
            popover: {
                title: 'Pose To Image',
                description: 'This control net maps a human pose of the input image and uses that pose in correspondence with the prompt to create an image with similar poses to the base image',
                position: 'bottom'
            }
        },
        {// Step 25
            element: '#canny',
            popover: {
                title: 'Canny',
                description: 'Canny uses edge detection on your input image and creates a new image with your prompt using the edges it detected',
                position: 'bottom'
            }
        },
        {// Step 26
            element: '#scribble',
            popover: {
                title: 'Scribble',
                description: 'Scribble uses the scribble you made in the mask area or an uploaded scribble and it will use your drawing and prompt as a template to guide the generation',
                position: 'bottom'
            }
        },
        {// Step 27
            element: '#straight',
            popover: {
                title: 'Straight Lines',
                description: 'This control net uses line detection in an input image in addition to a prompt to generate an image',
                position: 'bottom'
            }
        }
    ];


    // Define the steps in the driver
    driver.defineSteps(steps);
};